const leaflets = {
    "tuttorisparmio": {
        "config": {
            "primary-color": "#0e4b24",
            "secondary-color": "#80cb6f",
            "tertiary-color": "#ffdd00",
            "hover-color": "rgba(220, 35, 17, 0.2)",
            "clientIcon": require("assets/images/tuttorisparmio_clientLogo.png"),
            "serverPath": "tuttorisparmio.volantinointerattivo.net/",
            "pdfPath": "/media/volantino.pdf",
            "shareFlyerTitle": "Dai uno sguardo al nuovo volantino TuttoRisparmio!",
            "shareFlyerURL": "https://tuttorisparmio.volantinointerattivo.net",
            "shareProductSentence": "Guarda questa fantastica offerta di TuttoRisparmio!",
            "ogTitleMeta": "Volantino Interattivo TuttoRisparmio",
            "ogDescriptionMeta": "Dai uno sguardo al nostro nuovo volantino.",
            "ogImageMeta": "https://tuttorisparmio.volantinointerattivo.net/media/images/facebook.png",
            "filterBrand": null,
            "filterUnderprice": null,
            "brandImage": "",
            "underPriceImage": "",
            "ga_active": true,
            "ga_tracking_id": "UA-152069090-14",
            "release_id": "1",
        },
        "leaflet": {
            "name": "Tutto_Risparmio",
            "code": "tuttorisparmio2020",
            "id_campaign": "567",
            "index": {
                "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/Indice_TuttoRisparmio_Tavola_disegno_1_SXAvTbC.png",
                "links": [
                    {
                        "page": 2,
                        "blueprint": {
                            "top": 22.096487023214408,
                            "left": 17.9802095459837,
                            "width": 64.43538998835857,
                            "height": 5.981647606656163
                        }
                    },
                    {
                        "page": 4,
                        "blueprint": {
                            "top": 28.033623228103817,
                            "left": 17.9802095459837,
                            "width": 64.43538998835857,
                            "height": 5.981647606656163
                        }
                    },
                    {
                        "page": 6,
                        "blueprint": {
                            "top": 33.97075943299322,
                            "left": 17.848273185875048,
                            "width": 64.43538998835857,
                            "height": 5.981647606656163
                        }
                    },
                    {
                        "page": 12,
                        "blueprint": {
                            "top": 39.90789563788263,
                            "left": 17.9802095459837,
                            "width": 64.43538998835857,
                            "height": 5.981647606656163
                        }
                    },
                    {
                        "page": 18,
                        "blueprint": {
                            "top": 45.84503184277204,
                            "left": 17.848273185875048,
                            "width": 64.43538998835857,
                            "height": 5.981647606656163
                        }
                    },
                    {
                        "page": 22,
                        "blueprint": {
                            "top": 51.89858248305142,
                            "left": 17.9802095459837,
                            "width": 64.43538998835857,
                            "height": 5.981647606656163
                        }
                    }
                ]
            },
            "categories": [
                {
                    "category_name": "Alimentari",
                    "subcategories": [
                        "Dispensa",
                        "Colazione",
                        "Rossi",
                        "Pasta",
                        "Olio",
                        "Snack Salati",
                        "Snack Dolci"
                    ]
                },
                {
                    "category_name": "Bevande",
                    "subcategories": [
                        "Acqua",
                        "Liquori",
                        "Bibite",
                        "Succhi",
                        "Vini e Spumanti",
                        "Birre"
                    ]
                },
                {
                    "category_name": "Gastronomia",
                    "subcategories": [
                        "Salumi",
                        "Formaggi"
                    ]
                },
                {
                    "category_name": "Macelleria",
                    "subcategories": [
                        "Bovino",
                        "Suino",
                        "Altro",
                        "null",
                        "Avicoli"
                    ]
                },
                {
                    "category_name": "Ortofrutta",
                    "subcategories": [
                        "Frutta",
                        "Verdura"
                    ]
                },
                {
                    "category_name": "Pescheria",
                    "subcategories": [
                        "Pescato",
                        "Altro"
                    ]
                },
                {
                    "category_name": "Surgelati",
                    "subcategories": [
                        "Ittico",
                        "Verdure",
                        "Preparati",
                        "Gelati"
                    ]
                },
                {
                    "category_name": "Self Service",
                    "subcategories": [
                        "Yogurt",
                        "Ittico",
                        "Formaggi",
                        "Salumi",
                        "Pasta",
                        "Vegetali",
                        "Snack"
                    ]
                },
                {
                    "category_name": "Igiene Casa",
                    "subcategories": [
                        "Extra",
                        "Superfici",
                        "Bucato",
                        "Pavimenti"
                    ]
                },
                {
                    "category_name": "No Food",
                    "subcategories": [
                        "Home"
                    ]
                },
                {
                    "category_name": "Igiene Persona",
                    "subcategories": [
                        "Corpo",
                        "Capelli",
                        "Viso",
                        "Intima",
                        "Orale"
                    ]
                },
                {
                    "category_name": "Pet",
                    "subcategories": [
                        "Food"
                    ]
                }
            ],
            "pages": [
                {
                    "number": 1,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_1_a9cGM8g.jpg",
                    "products": [
                        {
                            "item_id": "197555",
                            "field1": "hag",
                            "field2": "caffè",
                            "field3": "classico",
                            "field4": "250 gr",
                            "description": "hag caffè classico 250 gr",
                            "grammage": 250,
                            "price": "1.19",
                            "price_label": "€ 1,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 6.729781551735946,
                                "left": 3.4672099340318163,
                                "width": 22.34769111369809,
                                "height": 36.24940080805314
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/443_Hag_Classico_250_g_1530526341_1532963383_1562662014_1564062067_1_CjBM7ZL.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_QWZPrkX_2FH1npV.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "Link",
                                    "data": "https://www.hag.it/"
                                }
                            ],
                            "related": ["130861", "88298", "106404", "107407"],
                        },
                        {
                            "item_id": "92225",
                            "field1": "PAVESI\t",
                            "field2": "Gocciole cioccolato ",
                            "field3": "kg 1",
                            "field4": "",
                            "description": "PAVESI\t Gocciole cioccolato  kg 1",
                            "grammage": 1000,
                            "price": "2.69",
                            "price_label": "€ 2,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 6.613367116345957,
                                "left": 26.951882033372133,
                                "width": 22.47962747380675,
                                "height": 36.24940080805314
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/22312-1022476_pavesiGocciole1Kg_1580825979.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_jG2PkH1_FkLCgW9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "198431",
                            "field1": "FERRERO",
                            "field2": "Nutella",
                            "field3": "gr 750",
                            "field4": "",
                            "description": "FERRERO Nutella gr 750",
                            "grammage": 750,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 6.613367116345957,
                                "left": 50.56849049282111,
                                "width": 22.611563833915405,
                                "height": 36.36581524344313
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/924633_FERRERO_NUTELLA_G750_1565339274_1565630034_1570110616_1574249465.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_RAoqF1l_CC40Ayn.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "Spot",
                                    "data": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/video/nutella.mp4"
                                },
                                {
                                    "type": "world",
                                    "title": "Sito Nutella",
                                    "data": "https://www.nutella.com/it/it/"
                                },
                                {
                                    "type": "hat-chef",
                                    "title": "RICETTA - CRÈPES ALLA NUTELLA (4 PORZIONI)",
                                    "data": {
                                        "ingredients": "3 Uova, 250g Farina, 15gr Burro, 220ml Latte, 60gr Nutella (15gr/porzione), 50gr Nocciole tostate",
                                        "recipe": "STEP 1. Per preparare le crêpes sono necessarie 2 ciotole: in una versate il latte con la farina e mescolate bene; nell'altra unite le uova con il burro. Mescolate poi insieme i 2 preparati. Lasciate riposare la pastella per 15 minuti a temperatura ambiente. STEP 2. Ungete una piastra con della carta assorbente imbevuta nell'olio, scaldatela e versatevi un po' di pastella: dovete ottenere delle crêpes di circa 26 cm di diametro. Cuocetele su entrambi i lati finché non raggiungono una doratura uniforme. STEP 3. Spalmate un po' di Nutella® su ogni crêpe e chiudetele a ventaglio. Tritate grossolanamente le nocciole, disponete le crêpe nei piatti singoli e guarnitele con le nocciole tritate. Servite immediatamente. (Fonte: nutella.com)",
                                        "img": [
                                            "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/images/nutella.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "89414",
                            "field1": "LEVISSIMA",
                            "field2": "Acqua minerale naturale",
                            "field3": "lt 2 ",
                            "field4": "",
                            "description": "LEVISSIMA Acqua minerale naturale lt 2 ",
                            "grammage": 2000,
                            "price": "0.25",
                            "price_label": "€ 0,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Acqua",
                            "blueprint": {
                                "top": 6.38053824556598,
                                "left": 74.05316259216143,
                                "width": 22.611563833915405,
                                "height": 36.36581524344313
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/levissima_15x6_1562574379_1571734644.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_NqE5RuX_TbxVG3j.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "93388",
                            "field1": "CAFFO",
                            "field2": "Vecchio Amaro del capo ",
                            "field3": "cl 70",
                            "field4": "",
                            "description": "CAFFO Vecchio Amaro del capo  cl 70",
                            "grammage": 700,
                            "price": "7.19",
                            "price_label": "€ 7,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Liquori",
                            "blueprint": {
                                "top": 57.02081764021092,
                                "left": 3.3352735739231556,
                                "width": 22.611563833915405,
                                "height": 36.36581524344313
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/AMARODELCAPO_NEW_con_bicchieri_1498813284_1558608504.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_YCKsbe6_ebR7YpG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "Link Sito Esterno",
                                    "data": "https://www.vecchioamarodelcapo.com/it/autorizzazione/?return_to=home"
                                }
                            ],
                            "related": ["105244", "111730"],
                        },
                        {
                            "item_id": "195310",
                            "field1": "MONTEFIORE",
                            "field2": "Prosciutto crudo dolce",
                            "field3": "senza osso",
                            "field4": "al kg",
                            "description": "MONTEFIORE Prosciutto crudo dolce senza osso al kg",
                            "grammage": null,
                            "price": "6.49",
                            "price_label": "€ 6,49 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 57.02081764021092,
                                "left": 26.95188203337213,
                                "width": 22.611563833915405,
                                "height": 36.36581524344313
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/piatto_prosciutto_crudo_1490945279_1562949113_1565187145_1566318314__Ye5t8X5.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Prosc_crudo_estero_al_kg_1431626332_1471614076_1471965409_1515488234_RRRo9QQ.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_bWmvC7H_t2wdhic.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["196928", "207464", "88541"]
                        },
                        {
                            "item_id": "207018",
                            "field1": "MOTTA",
                            "field2": "Colomba doppia crema ",
                            "field3": "vari gusti",
                            "field4": "gr 700",
                            "description": "MOTTA Colomba doppia crema  vari gusti gr 700",
                            "grammage": 700,
                            "price": "3.39",
                            "price_label": "€ 3,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Cioccolato/Vaniglia",
                                "Cioccolato/Caramello"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 57.02081764021092,
                                "left": 50.436554132712445,
                                "width": 22.611563833915405,
                                "height": 36.36581524344313
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/DOPPIACREMA_CIOCCOLATO_VANIGLIA_700GR_H_1582888611.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/DOPPIACREMA_CARAMELLO_CIOCCOLATO_700GR_H_1582888613.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_rU4ksnI_Lk1e3H6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "Sito Motta",
                                    "data": "https://www.mottamilano.it/prodotti/colomba-doppiacrema-cioccolato-latte-caramello/"
                                }
                            ]
                        },
                        {
                            "item_id": "207021",
                            "field1": "LINDT",
                            "field2": "Uovo di cioccolato",
                            "field3": "latte/ fondente",
                            "field4": "gr 270",
                            "description": "LINDT Uovo di cioccolato latte/ fondente gr 270",
                            "grammage": 270,
                            "price": "7.19",
                            "price_label": "€ 7,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Latte",
                                "Fondente"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 57.13723207560091,
                                "left": 74.05316259216143,
                                "width": 22.611563833915405,
                                "height": 36.36581524344313
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/principale_8003340059693_1582889015.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/principale_8003340053592_1582889016.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_2OdbHmH_mHuXmei.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "Sito Lindt",
                                    "data": "https://www.lindt.it/"
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 2,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_2_jggdsdl.jpg",
                    "products": [
                        {
                            "item_id": "117624",
                            "field1": "COMAL",
                            "field2": "Prosciutto cotto ",
                            "field3": "preliba",
                            "field4": "al kg",
                            "description": "COMAL Prosciutto cotto  preliba al kg",
                            "grammage": null,
                            "price": "4.19",
                            "price_label": "€ 4,19 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 9.756556871875642,
                                "left": 3.599146294140462,
                                "width": 46.09623593325572,
                                "height": 33.92111210025337
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Prosciutto_cotto_tagliere_carrefour_1429104475_1433422117_1484234293_vDwrqxi.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_CyYNKZI_9M9b1ys.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "Il Prosciutto Cotto",
                                    "data": {
                                        "titolo": "",
                                        "testo": "Il prosciutto cotto è composto dalla coscia disossata \"vera e propria\" del maiale (S. scrofa domesticus), pertanto, nella sua produzione non vengono utilizzate altre parti dell'animale. NB. Spesso il prosciutto cotto viene rimpiazzato da un prodotto molto simile, ma sensibilmente meno pregiato: la spalla cotta di maiale.Prosciutto cotto\n\n\nLa produzione del prosciutto cotto prevede alcune fasi essenziali: macellazione del suino, lavorazione dell'arto posteriore (sezionatura, sgrassatura, disossamento - ma non sempre - , massaggiatura ecc.), cottura a vapore e confezionamento. Il prosciutto cotto è un alimento dalle origini antiche, risalenti persino all'antica Roma, dove vi è traccia delle ricette di elaborazione della carne di maiale. Effettivamente, pur essendo un salume, il prosciutto cotto non è altro che un \"grosso arrosto\"; la sua scoperta è quindi imputabile ai latini che, nelle regioni settentrionali dell'impero, tentarono di facilitare la cottura della coscia di maiale arrosto facendola bollire in acqua e aromi. ",
                                        "img": [
                                            "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/images/prosciutto-cotto-affettato.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "196928",
                            "field1": "FELSINEO",
                            "field2": "Mortadella sciccosa nazionale",
                            "field3": "con pistacchio",
                            "field4": "al kg",
                            "description": "FELSINEO Mortadella sciccosa nazionale con pistacchio al kg",
                            "grammage": null,
                            "price": "5.45",
                            "price_label": "€ 5,45 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 9.756556871875642,
                                "left": 50.47341870391928,
                                "width": 46.09623593325572,
                                "height": 17.15743340409505
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/59975_FelsineoMortadella_1573127716.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_q9PHm9r_yx51zrK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "207464",
                            "field1": "prosciutto crudo",
                            "field2": "disossato",
                            "field3": "nazionale",
                            "field4": "al kg",
                            "description": "prosciutto crudo disossato nazionale al kg",
                            "grammage": null,
                            "price": "7.69",
                            "price_label": "€ 7,69 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 27.10230774498391,
                                "left": 50.20954598370197,
                                "width": 46.09623593325572,
                                "height": 16.575361227145113
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/piatto_prosciutto_crudo_1490945279_1562949113_1565187145_1566318314__5OWhjds.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Prosc_crudo_estero_al_kg_1431626332_1471614076_1471965409_1515488234_gKSrALX.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_HkCNOLT_LL0H3iC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "89464",
                            "field1": "CASA MODENA",
                            "field2": "Granrosa ",
                            "field3": "prosciutto cotto",
                            "field4": "al kg",
                            "description": "CASA MODENA Granrosa  prosciutto cotto al kg",
                            "grammage": null,
                            "price": "4.89",
                            "price_label": "€ 4,89 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 44.0988153119222,
                                "left": 3.3721381451299894,
                                "width": 23.271245634458676,
                                "height": 16.575361227145113
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/23384_1512388040.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_nomjZZ9_xjsfqDf.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "88541",
                            "field1": "VERONI",
                            "field2": "Prosciutto cotto",
                            "field3": "alta resa",
                            "field4": "al kg",
                            "description": "VERONI Prosciutto cotto alta resa al kg",
                            "grammage": null,
                            "price": "6.19",
                            "price_label": "€ 6,19 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 43.982400876532225,
                                "left": 26.85681024447031,
                                "width": 22.875436554132715,
                                "height": 16.575361227145113
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/29435_1492177989.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_9t9ZgNK_Vcgt5Wi.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "106546",
                            "field1": "VERONI\t",
                            "field2": "Zaffiro prosciutto crudo",
                            "field3": "al kg",
                            "field4": "",
                            "description": "VERONI\t Zaffiro prosciutto crudo al kg",
                            "grammage": 100,
                            "price": "8.39",
                            "price_label": "€ 8,39 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 60.62966513730054,
                                "left": 3.5040745052386426,
                                "width": 23.139309274350023,
                                "height": 16.575361227145113
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/piatto_prosciutto_crudo_1490945279_1559813373.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/51089_1501157876_1512388087_1559813373.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_d0v4TOP_sX8Uo1I.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "hat-chef",
                                    "title": "Gnocchi al pesto e prosciutto crudo",
                                    "data": {
                                        "ingredients": "400 g patate, 120 g farina, 50 g Grana Padano, 1  grattugiata di noce moscata, 1  rosso d'uovo, 1 cucchiaino sale, 50 g Prosciuto Crudo di Parma, 2 cucchiai pesto fresco, 120 g panna, 2  noci di burro",
                                        "recipe": "Per il condimento:\nRosolare nel burro il prosciutto crudo tagliato a strisce, aggiungere la panna fresca e il pesto.\nAmalgamare fino a creare un sugo cremoso.\nPer gli gnocchi:\nBollire le patate con la buccia, una volta cotte pelarle e passarle con lo schiacciapatate, aggiungere la farina a neve, il rosso d'uovo, il grana e la noce moscata, aggiustare di sale e creare un impasto morbido.\nCreare delle strisce e tagliare gli gnocchi. Bollire l'acqua salata, immergere gli gnocchi, togliergli dall'acqua non appena emergono. Metterli in una ciotola con un po' d'olio per non farli attaccare. Se non si consumano subito farli raffreddare in frigo.\nIn una padella mettere il sugo, aggiungere gli gnocchi e padellarli, sistemarli nella ciotola e servire con una spolverata di Parmigiano Reggiano. Mettere nel mixer.\nFonte: veroni.it",
                                        "img": [
                                            "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/images/gnocchi-pesto-prosc.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "117625",
                            "field1": "COATI",
                            "field2": "Manzo affumicato ",
                            "field3": "al kg",
                            "field4": "",
                            "description": "COATI Manzo affumicato  al kg",
                            "grammage": 100,
                            "price": "9.29",
                            "price_label": "€ 9,29 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 60.62966513730054,
                                "left": 26.724873884361656,
                                "width": 23.139309274350023,
                                "height": 16.575361227145113
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/coati_1513005913.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_LF3d2I0_g1OSV00.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "90956",
                            "field1": "FIORUCCI",
                            "field2": "Salame Milano ",
                            "field3": "al kg",
                            "field4": "",
                            "description": "FIORUCCI Salame Milano  al kg",
                            "grammage": 100,
                            "price": "7.79",
                            "price_label": "€ 7,79 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 77.3933438334589,
                                "left": 3.43034536282499,
                                "width": 23.139309274350023,
                                "height": 17.623091145655003
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/25389_1497966918.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_SHeqsLk_uB1jIxl.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "Spot Fiorucci",
                                    "data": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/video/FIorucci_-_Spot_-_15_secondi.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "88555",
                            "field1": "CLAI",
                            "field2": "Salame ungherese",
                            "field3": "al kg",
                            "field4": "",
                            "description": "CLAI Salame ungherese al kg",
                            "grammage": 100,
                            "price": "6.69",
                            "price_label": "€ 6,69 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 77.50975826884886,
                                "left": 26.91501746216531,
                                "width": 23.139309274350023,
                                "height": 17.623091145655003
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/clai_salame_ungherese_1491839632_1512388170.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/6830_1577113307.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_vCvVjZm_gHvEzLu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "87330",
                            "field1": "CAVAZZUTI",
                            "field2": "Salame ",
                            "field3": "contadino",
                            "field4": "al kg",
                            "description": "CAVAZZUTI Salame  contadino al kg",
                            "grammage": 100,
                            "price": "11.99",
                            "price_label": "€ 11,99 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 77.50975826884886,
                                "left": 50.26775320139697,
                                "width": 23.139309274350023,
                                "height": 17.623091145655003
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/14001_1497966969.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_yk25l34_vYmkVmz.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "180648",
                            "field1": "SALAME GOURMAND ",
                            "field2": "Hierbas/pimienta ",
                            "field3": "al kg",
                            "field4": "",
                            "description": "SALAME GOURMAND  Hierbas/pimienta  al kg",
                            "grammage": 100,
                            "price": "5.59",
                            "price_label": "€ 5,59 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [
                                "Hierbas",
                                "Pimienta"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 77.62617270423885,
                                "left": 73.62048894062863,
                                "width": 23.139309274350023,
                                "height": 17.15743340409505
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/23339_1559666547.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_apo7nXQ_7OilylX.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "107842",
                            "field1": "Casa Montorsi",
                            "field2": "Prosciutto Crudo di Vignola ",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Casa Montorsi Prosciutto Crudo di Vignola  al kg",
                            "grammage": null,
                            "price": "7.39",
                            "price_label": "€ 7,39 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 44.0988153119222,
                                "left": 50.26775320139697,
                                "width": 46.49204501358168,
                                "height": 32.989796617133464
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Montorsi_Crudo_Vignola.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/snocciolato_crudo_Piatto.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_Kuy7960_S9Eq6mC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "Prosciutto Crudo di Vignola",
                                    "data": "http://www.casamontorsi.it/prodotti/gli-stagionati/il-gran-crudo-di-vignola"
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 3,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_3_iT6fGwL.jpg",
                    "products": [
                        {
                            "item_id": "108833",
                            "field1": "AMADORI FATTORIA BONITA",
                            "field2": "Fesa di tacchino ",
                            "field3": "arrosto ",
                            "field4": "al kg",
                            "description": "AMADORI FATTORIA BONITA Fesa di tacchino  arrosto  al kg",
                            "grammage": 100,
                            "price": "4.09",
                            "price_label": "€ 4,09 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 9.756556871875642,
                                "left": 3.3352735739231627,
                                "width": 46.36010865347303,
                                "height": 33.92111210025337
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/43113_AMADORI_Fattoria_Bonita_fesa_di_tacchino_1529741049.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_gJpi75R_sebn1EV.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "103939",
                            "field1": "PORCHETTA",
                            "field2": "Montagna ",
                            "field3": "al kg",
                            "field4": "",
                            "description": "PORCHETTA Montagna  al kg",
                            "grammage": 100,
                            "price": "6.99",
                            "price_label": "€ 6,99 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 9.756556871875642,
                                "left": 50.209545983701986,
                                "width": 46.36010865347303,
                                "height": 17.27384783948504
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/porchetta_tradizionale_tagliere_multicedi_1431953087_1447152637_1501775714.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_AI3EovX_5QUCxZX.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85902",
                            "field1": "PORCHETTA ",
                            "field2": "di Ariccia I.G.P.",
                            "field3": "al kg",
                            "field4": "",
                            "description": "PORCHETTA  di Ariccia I.G.P. al kg",
                            "grammage": 100,
                            "price": "9.99",
                            "price_label": "€ 9,99 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 26.869478874203935,
                                "left": 50.34148234381064,
                                "width": 23.00737291424137,
                                "height": 17.27384783948504
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/porchetta_1489760799.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/52654_1552994690.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_kqbRWbU_wcHzycH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "hat-chef",
                                    "title": "Schiacciate con porchetta di Ariccia e provolone",
                                    "data": {
                                        "ingredients": "Schiacciate al forno: 12, Porchetta di Ariccia: 2 fette, Provolone: 80 g, Olio extravergine d'oliva: 5 cucchiai, Aglio: 1 spicchio, Rosmarino: 2 rametti, Semi di finocchio: 1 cucchiaino, Pepe nero: q.b., Songino: q.b.",
                                        "recipe": "Iniziate preparando l’olio aromatico: in un pentolino versate l’olio extravergine d’oliva e fatelo leggermente intiepidire, toglietelo dal fuoco e aggiungetevi uno spicchio d’aglio tagliato a metà 1, il rosmarino tritato finemente con un coltello e i semi di finocchietto che avrete leggermente schiacciato con la lama di un coltello per sprigionarne gli aromi 2. Pepate abbondantemente 3 e lasciate riposare e insaporire l’olio per almeno 2 ore. Private quindi il provolone della crosta e tagliatelo a cubetti 4 regolari (di circa 1 cm a lato). Effettuate la stessa operazione con le 2 fette di porchetta 5. Coprite ogni Schiacciata “La Bottega di Olivia&Marino” con cubetti di porchetta e cubetti di provolone 6. Aggiungete infine alcune foglie di songino, condite con poche gocce di olio aromatico e servite gli stuzzichini! (Fonte: giallozafferano.it)",
                                        "img": [
                                            "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/images/Schiacciate-porchetta-ariccia-provolone.png"
                                        ]
                                    }
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "",
                                        "testo": "La Porchetta di Ariccia è un prodotto a base di carne suina cotta, tipica del comune di Ariccia, in provincia di Roma.\nDal 14 giugno 2011, a livello europeo, la Porchetta di Ariccia ottiene il riconoscimento di indicazione geografica protetta (IGP).\nAriccia è una delle località più conosciute e popolari posta a breve distanza da Roma, dove a differenza di altri paesi limitrofi il legame con la porchetta e la sua produzione vanta una tradizione millenaria, presumibilmente risalente alla popolazione dei latini e precedente la conquista romana. Infatti, non solo si attribuisce ad Ariccia l'origine dei sacerdoti che lavoravano e preparavano le carni suine da offrire in sacrificio nel tempio di Giove Laziare sul vicino Monte Cavo, ma si ritiene anche che grazie alla successiva presenza della nobiltà romana, solita trasferirsi ad Ariccia per la stagione estiva o per organizzare battute di caccia, si sia potuta sviluppare quella maestranza artigiana nel preparare la porchetta presente ancora oggi e che continua a tramandarsi nelle famiglie ariccine.\nL'odierna reputazione della Porchetta di Ariccia risale al 1950, quando i porchettari di Ariccia guidati dal proprio sindaco, Cioli Ovidio, allestirono la prima \"Sagra della Porchetta di Ariccia\", con lo scopo di celebrare questo prodotto tanto gustoso quanto all'epoca già noto. Da allora ogni anno ad Ariccia si svolge questa manifestazione suggestiva e caratteristica dove viene offerta la porchetta su banchi addobbati a festa da venditori vestiti con gli abiti tradizionali ariccini.",
                                        "img": [
                                            "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/images/Porchetta_ariccia.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "85901",
                            "field1": "FINI\t",
                            "field2": "Salsiccia ",
                            "field3": "dolce/piccante ",
                            "field4": "al kg",
                            "description": "FINI\t Salsiccia  dolce/piccante  al kg",
                            "grammage": 100,
                            "price": "8.99",
                            "price_label": "€ 8,99 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [
                                "Dolce",
                                "Piccante"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 26.985893309593923,
                                "left": 73.56228172293368,
                                "width": 23.00737291424137,
                                "height": 16.691775662535093
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/fini_salsiccia_dolce_e_piccante_euroesse_1459863781_1558600055.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_s4F2P5P_mi76BfW.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "204396",
                            "field1": "BISANZIO",
                            "field2": "Coppa",
                            "field3": "dolce/piccante",
                            "field4": "al kg",
                            "description": "BISANZIO Coppa dolce/piccante al kg",
                            "grammage": null,
                            "price": "9.59",
                            "price_label": "€ 9,59 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 43.982400876532225,
                                "left": 3.43034536282499,
                                "width": 23.00737291424137,
                                "height": 16.691775662535093
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/52458_CP_1580400079.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/52459_1580400102.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_oGylqF9_zqKJOQu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "132549",
                            "field1": "BISANZIO",
                            "field2": "Pancetta coppata linea oro",
                            "field3": "al kg",
                            "field4": "",
                            "description": "BISANZIO Pancetta coppata linea oro al kg",
                            "grammage": 100,
                            "price": "8.49",
                            "price_label": "€ 8,49 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 44.0988153119222,
                                "left": 26.81994567326348,
                                "width": 23.139309274350015,
                                "height": 16.458946791755118
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/54102_coppata_1546528546.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_HUnqBjU_3MFy39f.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "89470",
                            "field1": "LUCANA",
                            "field2": "Salsiccia lucanina",
                            "field3": "dolce/piccante",
                            "field4": "al kg",
                            "description": "LUCANA Salsiccia lucanina dolce/piccante al kg",
                            "grammage": 100,
                            "price": "9.99",
                            "price_label": "€ 9,99 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [
                                "Dolce",
                                "Piccante"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 60.74607957269053,
                                "left": 3.298409002716337,
                                "width": 23.139309274350015,
                                "height": 16.458946791755114
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/41845_1573742517.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/41845_1573745069.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_WUcdlTD_RZ2b82k.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "Lucana Salumi",
                                    "data": "http://www.lucanasalumi.it/"
                                }
                            ]
                        },
                        {
                            "item_id": "196751",
                            "field1": "ZAPPALÀ",
                            "field2": "Treccione affumicato",
                            "field3": "al kg",
                            "field4": "",
                            "description": "ZAPPALÀ Treccione affumicato al kg",
                            "grammage": 100,
                            "price": "5.99",
                            "price_label": "€ 5,99 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 60.74607957269053,
                                "left": 26.651144741948002,
                                "width": 23.139309274350015,
                                "height": 16.458946791755118
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/5078403_TRECCIONE__AFFUMICATO__ZAPPALa_2_kg_1505317649_1537866123_1573033818.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_z98CqTt_CN5qqbg.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "207467",
                            "field1": "GALBANI",
                            "field2": "Formaggio stagionato 12 mesi",
                            "field3": "100% italiano",
                            "field4": "al kg",
                            "description": "GALBANI Formaggio stagionato 12 mesi 100% italiano al kg",
                            "grammage": null,
                            "price": "6.99",
                            "price_label": "€ 6,99 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 77.62617270423885,
                                "left": 3.298409002716337,
                                "width": 23.139309274350015,
                                "height": 17.273847839485033
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/62992_1584093785.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_1HuDGXg_69KAb0b.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "207469",
                            "field1": "I BUONA TAVOLA",
                            "field2": "Gran cacio etrusco",
                            "field3": "al kg",
                            "field4": "",
                            "description": "I BUONA TAVOLA Gran cacio etrusco al kg",
                            "grammage": null,
                            "price": "9.99",
                            "price_label": "€ 9,99 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 77.50975826884886,
                                "left": 26.783081102056656,
                                "width": 23.139309274350015,
                                "height": 17.273847839485033
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/56866_gran_cacio_etrusco_1583506490.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_2NcF8Kh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "130723",
                            "field1": "RODEZ",
                            "field2": "formaggio vacchino",
                            "field3": "al kg",
                            "field4": "",
                            "description": "RODEZ formaggio vacchino al kg",
                            "grammage": null,
                            "price": "8.89",
                            "price_label": "€ 8,89 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 77.62617270423885,
                                "left": 50.13581684128832,
                                "width": 23.139309274350015,
                                "height": 17.273847839485033
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Rodez_formaggio_1530262464_1554282662.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_Yooqwl1_NPjbfsZ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Formaggio Rodez",
                                        "testo": "Il Rodez è un formaggio Francese utilizzato in Italia sopratutto in Puglia e nello specifico nel Brindisino. \nIl rodez è un formaggio che si ottiene esclusivamente con latte crudo intero, a pasta cotta e pressata con un sapore mediamente accentuato e salinità/sapidità medio alta. Dal colore ambrato e presentauna buccia striata gialla.  Viene prodotto impiegando latte di mucca della zona francese di produzione. (Fonte: cuocoanonimo.com)",
                                        "img": [
                                            "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/images/Rodez.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "103679",
                            "field1": "PECORINO FRESCO",
                            "field2": "Coratino ",
                            "field3": "al kg",
                            "field4": "",
                            "description": "PECORINO FRESCO Coratino  al kg",
                            "grammage": 100,
                            "price": "8.99",
                            "price_label": "€ 8,99 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 77.50975826884886,
                                "left": 73.48855258051998,
                                "width": 23.139309274350015,
                                "height": 17.273847839485033
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/31898_1552995401.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_NacYDVo_5nboKjV.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "95165",
                            "field1": "VALGRANA",
                            "field2": "Formaggio Scelto 1/8",
                            "field3": "al kg",
                            "field4": "",
                            "description": "VALGRANA Formaggio Scelto 1/8 al kg",
                            "grammage": 100,
                            "price": "6.99",
                            "price_label": "€ 6,99 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 44.0988153119222,
                                "left": 50.26775320139697,
                                "width": 46.22817229336437,
                                "height": 32.756967746353496
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/VALGRANA_piemonte__formaggio_da_tavola_1487072305_1496131660_1497544_5Xlh6hJ.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/26234_1535470785.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/26234_valgrana_1541608561.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_5dBFjg4_BN3GWvr.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Valori nutrizionali Formaggio Valgrana",
                                        "testo": "Valori medi per 100g di prodotto\nENERGIA\t1894 kj / 458 kcal, GRASSI 38 g, DI CUI ACIDI GRASSI SATURI 26 g, CARBOIDRATI 0,7 g, DI CUI ZUCCHERI 0 g, PROTEINE 28 g, SALE 2,0 g",
                                        "img": [
                                            "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/images/23731.jpg"
                                        ]
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 4,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_4_AQGVCTB.jpg",
                    "products": [
                        {
                            "item_id": "118171",
                            "field1": "GRANA PADANO\t",
                            "field2": "Formaggio D.O.P. ",
                            "field3": "1/8 stagionato 10 mesi ",
                            "field4": "al kg",
                            "description": "GRANA PADANO\t Formaggio D.O.P.  1/8 stagionato 10 mesi  al kg",
                            "grammage": 100,
                            "price": "8.29",
                            "price_label": "€ 8,29 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 44.0988153119222,
                                "left": 50.26775320139697,
                                "width": 46.22817229336437,
                                "height": 32.75696774635349
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/grana_padano_dop_1.8_1496652671_1513673557.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_KC8tWGk_OkFbyL6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "hat-chef",
                                    "title": "Crema di Grana PAdano",
                                    "data": {
                                        "ingredients": "100 gr di Grana Padano grattugiato,\n 200 ml di Latte,\n 20 gr di Burro,\n 20 gr di Farina 00,",
                                        "recipe": "Per preparare la Crema di Grana Padano iniziate facendo cuocere il latte, ma senza portalo ad ebollizione. Nel frattempo in una ciotola versate il burro precedentemente sciolto. Aggiungete anche la farina a pioggia, mescolando continuamente con una frusta. A questo punto aggiungete anche il latte caldo a filo, senza mai smettere di mescolare.\nMettete il composto sul fuoco a fiamma bassa e continuate a mescolare fino a quando non si sarà addensato. Spegnete il fuoco e aggiungete il grana grattugiato, sempre mescolando con le fruste fino ad ottenere un composto omogeneo. Ecco che la Crema di Grana Padano è pronta! (Fonte: clubdellericette.it)",
                                        "img": [
                                            "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/images/crema-grana-padano.png"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "87435",
                            "field1": "BAYERNLAND",
                            "field2": "Formaggio",
                            "field3": "filato",
                            "field4": "al kg",
                            "description": "BAYERNLAND Formaggio filato al kg",
                            "grammage": 100,
                            "price": "4.39",
                            "price_label": "€ 4,39 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 9.640142436485641,
                                "left": 3.43034536282499,
                                "width": 46.22817229336437,
                                "height": 34.15394097103335
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/A083000_ILA_MAXI_300g_1528213369.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/2454_bayernland_1533918576.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_kPJGtiB_pZYc6Gz.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "118031",
                            "field1": "BERGADER",
                            "field2": "Edelpilz formaggio ",
                            "field3": "erborinato rettangolare ",
                            "field4": "al kg",
                            "description": "BERGADER Edelpilz formaggio  erborinato rettangolare  al kg",
                            "grammage": 100,
                            "price": "6.49",
                            "price_label": "€ 6,49 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [
                                "Rettangolare",
                                "Rotondo"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 9.872971307265617,
                                "left": 50.209545983701986,
                                "width": 46.22817229336437,
                                "height": 33.6882832294734
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Invernizzi_Gimas_Tronchetto_1538584817_1547197243_1561366484_1582893224.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_KcfNZ9T_KLPuvzf.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Edelpilz, le venature blu di montagna",
                                        "testo": "Formaggio erborinato storico di Bergader, con le sue venature blu rappresenta una raffinata specialità piccante. Con la creatività e l’attenzione al gusto che da sempre caratterizza Bergader, il fondatore Basil Weixler decide di produrre, negli anni Venti, il Bergader Edelpilz, un formaggio dal sapore deciso e pregiato.\nUn successo di gusto che è arrivato a quasi 100 anni di storia e che conserva ancora oggi la sua ricetta originale. Un formaggio che rende omaggio alla tradizione casearia con una lavorazione innovativa, che armonizza il sapere antico dei mastri casari con le nuove tecnologie. (Fonte: bergader.it)",
                                        "img": [
                                            "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/images/edelplitz.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "92298",
                            "field1": "ENTREMONT",
                            "field2": "formaggio brie",
                            "field3": "al kg",
                            "field4": "",
                            "description": "ENTREMONT formaggio brie al kg",
                            "grammage": 100,
                            "price": "4.79",
                            "price_label": "€ 4,79 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 44.0988153119222,
                                "left": 3.298409002716337,
                                "width": 23.403181994567326,
                                "height": 16.458946791755118
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/42957_1499100611_1512041470_1565013348.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/42957_Brie_1581668349.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_IJ0TqlL_0nAUQLk.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "117635",
                            "field1": "BAYERNLAND",
                            "field2": "Edamer tedesco ",
                            "field3": "al kg",
                            "field4": "",
                            "description": "BAYERNLAND Edamer tedesco  al kg",
                            "grammage": 100,
                            "price": "3.69",
                            "price_label": "€ 3,69 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 43.98240087653221,
                                "left": 26.783081102056656,
                                "width": 22.875436554132715,
                                "height": 16.458946791755118
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/bayernland_edamer_tedesco_1513005917_1513006629.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/2453_1554882350.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_UZr5RG7_mTtkApx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "87439",
                            "field1": "MAASDAMER",
                            "field2": "",
                            "field3": "al kg",
                            "field4": "",
                            "description": "MAASDAMER al kg",
                            "grammage": 100,
                            "price": "4.19",
                            "price_label": "€ 4,19 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 60.74607957269053,
                                "left": 3.298409002716337,
                                "width": 23.271245634458676,
                                "height": 16.458946791755118
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/445151_maasdammer_olandese_1508340482_1558600609.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_TezlPdB_LdBzHB9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "Maasdammer",
                                    "data": "http://www.garbelottoformaggi.it/prodotti/maasdammer/"
                                }
                            ]
                        },
                        {
                            "item_id": "85914",
                            "field1": "GALBANI\t",
                            "field2": "Galbanone",
                            "field3": "al kg",
                            "field4": "",
                            "description": "GALBANI\t Galbanone al kg",
                            "grammage": 100,
                            "price": "5.99",
                            "price_label": "€ 5,99 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 60.74607957269053,
                                "left": 26.783081102056656,
                                "width": 23.139309274350023,
                                "height": 16.458946791755118
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/26083_1552996619.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_Omn7JPI_gpbvaVl.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "139681",
                            "field1": "CAROZZI",
                            "field2": "Gorgonzola cremiziola D.O.P.",
                            "field3": "al kg",
                            "field4": "",
                            "description": "CAROZZI Gorgonzola cremiziola D.O.P. al kg",
                            "grammage": 100,
                            "price": "7.89",
                            "price_label": "€ 7,89 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 77.60391700335546,
                                "left": 2.770663562281723,
                                "width": 31.715172681412497,
                                "height": 17.390262274875028
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/58749_gorgonzola_1536162491.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_DA6BDZM_Y7QdgTE.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "91069",
                            "field1": "AURICCHIO",
                            "field2": "Mini provolette",
                            "field3": "al kg",
                            "field4": "",
                            "description": "AURICCHIO Mini provolette al kg",
                            "grammage": 100,
                            "price": "7.49",
                            "price_label": "€ 7,49 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 77.60391700335546,
                                "left": 34.56732634846721,
                                "width": 31.055490880869232,
                                "height": 17.390262274875028
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Auricchio_provolette_1460362929_1535732303_1563890195_1576062457.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_DtXfiIe_aFv1Bvj.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "Spot Auricchio",
                                    "data": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/video/Formaggio_fatto_a_mano_Auricchio_pubblicita_spot_2020.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "118306",
                            "field1": "SORESINA",
                            "field2": "Caciocavallo",
                            "field3": "al kg",
                            "field4": "",
                            "description": "SORESINA Caciocavallo al kg",
                            "grammage": null,
                            "price": "5.59",
                            "price_label": "€ 5,59 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 77.48750256796546,
                                "left": 65.57237097400076,
                                "width": 31.055490880869232,
                                "height": 17.390262274875028
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/latteria_soresina_caciocavallo_1513849855.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_XuDfoL6_ocBA1xb.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 5,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_5_PoCvZ5Y.jpg",
                    "products": [
                        {
                            "item_id": "85977",
                            "field1": "ENTRECOTE",
                            "field2": "di Bovino adulto ",
                            "field3": "sv a pezzo intero",
                            "field4": "al kg",
                            "description": "ENTRECOTE di Bovino adulto  sv a pezzo intero al kg",
                            "grammage": null,
                            "price": "10.99",
                            "price_label": "€ 10,99 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 9.850715606382238,
                                "left": 3.8261544431509438,
                                "width": 45.83236321303841,
                                "height": 33.80469766486338
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/enrecote_1552931310.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_Fkeqve6_xRlJtqz.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "Cos'è l'Entrecote",
                                    "data": {
                                        "titolo": "Cos'è l'Entrecote",
                                        "testo": "Cosa si intende per Entrecote? Si tratta del taglio di carne che si colloca tra le due costole nella lombata del bovino adulto o manzo (ma non per il vitello)\nIl corrispettivo dell’ Entrecote nella tradizione italiana è il Controfiletto, la parte opposta al Filetto nella italianissima Fiorentina, mentre per gli anglosassoni abbiamo Ribeye, Club, Scotch Fillet, or Delmonico.\nSi tratta di un muscolo con poco collagene praticamente inutilizzato da parte della bestia, fatto che lo rende tenero anche se non propriamente come il Filetto che praticamente è li solo per essere mangiato.\nLa vicinanza alle ossa e la presenza di un buono strato di grasso conferiscono a questa carne un buon sapore, tendenzialmente anche migliore di quello del suo antagonista la fiorentina. (Fonte: atuttagriglia.com)",
                                        "img": [
                                            "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/images/1920px-Angus_Organic_Entrecote.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "116960",
                            "field1": "COPPA",
                            "field2": "di Suino senz'osso",
                            "field3": "sv a pezzo intero",
                            "field4": " al kg",
                            "description": "COPPA di Suino senz'osso sv a pezzo intero  al kg",
                            "grammage": null,
                            "price": "4.75",
                            "price_label": "€ 4,75 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 9.734301170992248,
                                "left": 50.209545983701986,
                                "width": 23.403181994567326,
                                "height": 17.506676710265015
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Coppa_di_suino_Market_1453220779_1458893049_1495789583_1512152035.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_rxLTz9A_Qp9eIzn.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "207908",
                            "field1": "PROSCIUTTO T/ROTONDO",
                            "field2": "di Suino",
                            "field3": "sv a pezzo intero",
                            "field4": "al kg",
                            "description": "PROSCIUTTO T/ROTONDO di Suino sv a pezzo intero al kg",
                            "grammage": null,
                            "price": "3.39",
                            "price_label": "€ 3,39 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 9.734301170992248,
                                "left": 73.56228172293368,
                                "width": 23.403181994567326,
                                "height": 17.506676710265015
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/prosciutto_di_suino_1581955392_1583941645.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_TbDY2e8_mc3DhVu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "175167",
                            "field1": "Salsiccia",
                            "field2": "di Suino",
                            "field3": "dolce/piccante conf. famiglia",
                            "field4": "al kg",
                            "description": "Salsiccia di Suino dolce/piccante conf. famiglia al kg",
                            "grammage": null,
                            "price": "4.59",
                            "price_label": "€ 4,59 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 27.429295350270483,
                                "left": 50.47341870391931,
                                "width": 15.487000388048122,
                                "height": 16.226117920975142
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/31358_salsiccia_1569227613_1570179952.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_uwwHi4e_mpi71Oh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "175166",
                            "field1": "Prosciutto ",
                            "field2": "di suino",
                            "field3": "conf. famiglia",
                            "field4": "al kg",
                            "description": "Prosciutto  di suino conf. famiglia al kg",
                            "grammage": null,
                            "price": "4.59",
                            "price_label": "€ 4,59 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 27.31288091488049,
                                "left": 65.90997283663177,
                                "width": 15.223127667830813,
                                "height": 16.226117920975142
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/66654_1564761344.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_eyGoh4Y_jpM6w3D.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "118877",
                            "field1": "DEL CAMPO\t",
                            "field2": "spinacette/cricche",
                            "field3": "",
                            "field4": "al kg",
                            "description": "DEL CAMPO\t spinacette/cricche al kg",
                            "grammage": 0,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Spinacette",
                                "Cricche"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 27.429295350270483,
                                "left": 81.21459060923557,
                                "width": 15.223127667830813,
                                "height": 16.226117920975142
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/58875_1542802111.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/58876_1542802111.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_p6OQqXl_WpjgrxF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "87476",
                            "field1": "CONIGLIO",
                            "field2": "INTERO",
                            "field3": "al kg",
                            "field4": "",
                            "description": "CONIGLIO INTERO al kg",
                            "grammage": null,
                            "price": "5.59",
                            "price_label": "€ 5,59 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 47.56899267273847,
                                "left": 3.43034536282499,
                                "width": 23.403181994567326,
                                "height": 12.966513730055468
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/coniglio_intero_1552899898.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_kEruPdd_u8uygEt.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "91002",
                            "field1": "HAMBURGER",
                            "field2": "Misti gustosi",
                            "field3": "al kg",
                            "field4": "",
                            "description": "HAMBURGER Misti gustosi al kg",
                            "grammage": null,
                            "price": "4.29",
                            "price_label": "€ 4,29 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 47.452578237348476,
                                "left": 26.651144741948002,
                                "width": 23.00737291424137,
                                "height": 12.966513730055468
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/hamburger_1536660585_1569229055.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Hamburger_misti_1572878467.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_U1oqPks_PJT1XVi.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "87489",
                            "field1": "CARRÈ",
                            "field2": "di Suino",
                            "field3": "al kg",
                            "field4": "",
                            "description": "CARRÈ di Suino al kg",
                            "grammage": null,
                            "price": "4.29",
                            "price_label": "€ 4,29 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 60.72382387180714,
                                "left": 3.1664726426076832,
                                "width": 15.618936748156775,
                                "height": 16.691775662535093
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/carre_1550505247_1552931643_1559815638.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_EnoKh1r_kfKtBeE.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "88409",
                            "field1": "TRITATO",
                            "field2": "di Suino",
                            "field3": "al kg",
                            "field4": "",
                            "description": "TRITATO di Suino al kg",
                            "grammage": null,
                            "price": "3.49",
                            "price_label": "€ 3,49 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 60.60740943641716,
                                "left": 18.734963135428796,
                                "width": 15.487000388048122,
                                "height": 16.691775662535093
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Macinato_maiale_1452766467_1557501037.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/29834_1565105272.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_jnLVuni_TUK6sIa.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85986",
                            "field1": "SALSICCIA",
                            "field2": "Mista",
                            "field3": "al kg",
                            "field4": "",
                            "description": "SALSICCIA Mista al kg",
                            "grammage": null,
                            "price": "4.99",
                            "price_label": "€ 4,99 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 60.72382387180714,
                                "left": 34.17151726814125,
                                "width": 15.487000388048122,
                                "height": 16.691775662535093
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/salsiccia_1550488175_1558601620.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_DuIjKWm_KHyEFxu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85968",
                            "field1": "AGNELLO",
                            "field2": "misto",
                            "field3": "al kg",
                            "field4": "",
                            "description": "AGNELLO misto al kg",
                            "grammage": null,
                            "price": "8.49",
                            "price_label": "€ 8,49 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "null",
                            "blueprint": {
                                "top": 47.452578237348476,
                                "left": 50.26775320139697,
                                "width": 46.36010865347303,
                                "height": 29.846606861603778
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/ovino_svezzato_1552666541_1562665262.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_7BPyih1_42oaImy.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "hat-chef",
                                    "title": "Stufato d'Agnello",
                                    "data": {
                                        "ingredients": "600 g di coscia o spalla disossate di agnello,\n300 g di patate,\n80 g di cipolla,\n3 cucchiai di olio extravergine di oliva,\n1 cucchiaino di concentrato di pomodoro,\n1 spicchio d’aglio,\n3 mestoli di brodo di carne o fondo d’agnello",
                                        "recipe": "Taglia la carne d’agnello in grossi pezzi (da circa 150 g l’uno), cospargila di sale e pepe e falla rosolare in una casseruola nell’olio caldo in modo da sigillarne all’interno i succhi. Riduci la cipolla a fettine e aggiungila alla carne insieme allo spicchio d’aglio, mescolando fino a quando sarà diventata trasparente. Unisci il concentrato di pomodoro, che avrai precedentemente diluito in un cucchiaio di brodo, la paprica, e sfuma con il vino. Quando sarà evaporato, abbassa la fiamma, aggiungi le erbe aromatiche insieme al brodo caldo e cuoci, coperto, per 1 ora facendo sobbollire dolcemente.\nTrascorso questo tempo sbuccia le patate, tagliale a cubetti di 3 cm e uniscile all’agnello. Prosegui la cottura per altri 20 minuti, aggiungendo eventualmente altro brodo se necessario. Aggiusta di sale e pepe e servi subito. (Fonte: cucchiaio.it)",
                                        "img": [
                                            "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/images/stufato-agnello.png"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "111739",
                            "field1": "SOVRACOSCE",
                            "field2": "di Pollo",
                            "field3": "al kg",
                            "field4": "",
                            "description": "SOVRACOSCE di Pollo al kg",
                            "grammage": null,
                            "price": "2.59",
                            "price_label": "€ 2,59 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Avicoli",
                            "blueprint": {
                                "top": 77.72033143874548,
                                "left": 3.298409002716337,
                                "width": 18.653473030655803,
                                "height": 17.15743340409505
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/sovracosce_pollo_1552668625.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_gccxRuQ_gSv865s.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "94764",
                            "field1": "PETTO",
                            "field2": "di Pollo intero",
                            "field3": "al kg",
                            "field4": "",
                            "description": "PETTO di Pollo intero al kg",
                            "grammage": null,
                            "price": "5.29",
                            "price_label": "€ 5,29 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Avicoli",
                            "blueprint": {
                                "top": 77.48750256796549,
                                "left": 22.03337213814513,
                                "width": 18.653473030655803,
                                "height": 17.15743340409505
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/petto_di_pollo_28408_1501154453.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/48921_1545242557.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_kYuJVed_ydoy8xP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "hat-chef",
                                    "title": "Petto di pollo all'arancia",
                                    "data": {
                                        "ingredients": "Petto di pollo intero 500 g, Succo d'arancia sanguinella 130 g, Farina 00 40 g, Burro 20 g, Grand Marnier 40 g, Olio extravergine d'oliva 25 g, Sale fino q.b., Pepe nero q.b.",
                                        "recipe": "Per preparare il petto di pollo all’arancia cominciate dai pomodorini. Staccateli dai rametti e poi sciacquateli, dopodiché divideteli a metà  e sistemateli in un colino posto all’interno di una ciotola, così il liquido in eccesso colerà sul fondo.\nIn una padella scaldate l’olio extravergine d’oliva insieme a uno spicchio d’aglio in camicia (prima ricordate di schiacciarlo un po’ con il palmo della mano), poi unite i pomodorini e lasciateli saltare per qualche minuto. Regolate di sale e di pepe e lasciate andare ancora per qualche minuto, dopodiché eliminate lo spicchio d’aglio 5. Quando i pomodorini risulteranno leggermente appassiti, orientativamente minuti di cottura in tutto, potrete spegnere la fiamma e aggiungere le foglioline di timo \nNel frattempo occupatevi del resto: dividete a metà l’arancia e ottenetene il succo, se volete potete anche filtrarlo così da eliminare eventuali residui di polpa; tenete da parte. Prendete poi il petto di pollo intero, dividetelo a metà e pulite da eventuali residui di grasso e cartilagini. Infarinate i 2 pezzi per bene e scrollateli per eliminare la farina in eccesso .\nIn una padella mettete a scaldare a fuoco dolce olio e burro; non appena il fondo sarà ben caldo sistemate il pollo e lasciate dorare per bene entrambi i lati fino per un paio di minuti ciascuno. Non appena saranno ben dorati sfumate con il Grand Marnier: fate moltissima attenzione all’eventuale fiammata di ritorno se utilizzate il fornello a gas.\nNon appena l’alcol sarà completamente evaporato, orientativamente ci vorrà 1 minuto, unite anche il succo d’arancia 13 e lasciate cuocere irrorando con il succo e rigirando di tanto in tanto. Lasciate cuocere per 10-15 minuti e a metà cottura regolate anche di sale e di pepe.\nUna volta pronti sistemate i petti di pollo su un tagliere, o un piatto e affettate in obliquo ottenendo così delle fette spesse circa 2 cm. Guarnite coi pomodorini ed ecco pronto il vostro petto di pollo all’arancia: gustate ancora caldissimo! (Fonte: giallozafferano.it)",
                                        "img": [
                                            "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/images/petto-pollo-arancia.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "85977",
                            "field1": "ENTRECOTE",
                            "field2": "di Bovino adulto ",
                            "field3": "al kg",
                            "field4": "",
                            "description": "ENTRECOTE di Bovino adulto  al kg",
                            "grammage": null,
                            "price": "12.59",
                            "price_label": "€ 12,59 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 77.60391700335546,
                                "left": 40.63639891346527,
                                "width": 18.653473030655803,
                                "height": 17.15743340409505
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/enrecote_1552931310_oXfHuAS.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_E2lK1Le_1FJYGEJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "87478",
                            "field1": "REALE",
                            "field2": "di Bovino adulto",
                            "field3": "al kg",
                            "field4": "",
                            "description": "REALE di Bovino adulto al kg",
                            "grammage": null,
                            "price": "6.49",
                            "price_label": "€ 6,49 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 77.60391700335546,
                                "left": 59.371362048894056,
                                "width": 18.653473030655803,
                                "height": 17.15743340409505
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/reale_di_bovino_1525945610.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/reale_di_bovino_adulto_1559223155.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/reale_1552667908_1562665089.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_GhborfO_jywSnaE.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "90990",
                            "field1": "CARPACCIO",
                            "field2": "di Bovino adulto",
                            "field3": "al kg",
                            "field4": "",
                            "description": "CARPACCIO di Bovino adulto al kg",
                            "grammage": null,
                            "price": "8.99",
                            "price_label": "€ 8,99 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 77.60391700335546,
                                "left": 77.84245246410555,
                                "width": 18.653473030655803,
                                "height": 17.15743340409505
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/carpaccio_di_bovino_1494834750_1557502137.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_LErOvYW_V896FB5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 6,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_6_GP2UqYK.jpg",
                    "products": [
                        {
                            "item_id": "205717",
                            "field1": "ARANCE TAROCCO ",
                            "field2": "Sfuse",
                            "field3": "al kg",
                            "field4": "vendita a imballo intero",
                            "description": "ARANCE TAROCCO  Sfuse al kg vendita a imballo intero",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Frutta",
                            "blueprint": {
                                "top": 10.782031089502146,
                                "left": 3.298409002716337,
                                "width": 23.403181994567326,
                                "height": 16.226117920975142
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/arancia_tarocco_1515693633_1519751382_1550858382_1575279995_1581356155.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_1FKgKF2_QZ7QOqH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "specs",
                                    "title": "Valori nutrizionali Arance Tarocco",
                                    "data": {
                                        "specifiche": "fibre, vitamina A, vitamina C, vitamina B1, vitamina B2, folati, vitamina K, vitamina PP, acido citrico, calcio, altri minerali e vitamine, antocianine (in particolare cianidina)",
                                        "img": [
                                            "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/images/arance-tarocco-bio.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "113034",
                            "field1": "KIWI",
                            "field2": "al kg",
                            "field3": "vendita a imballo intero",
                            "field4": "",
                            "description": "KIWI al kg vendita a imballo intero",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Frutta",
                            "blueprint": {
                                "top": 10.665616654112156,
                                "left": 26.783081102056656,
                                "width": 23.139309274350023,
                                "height": 16.226117920975142
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/kiwi_shutter_1484124529_ok_1504545359_1509118164.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_KLy2sCf_vU3Vk1Y.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "208100",
                            "field1": "POMODORO",
                            "field2": "PER INSALATA",
                            "field3": "al kg",
                            "field4": "vendita a imballo intero",
                            "description": "POMODORO PER INSALATA al kg vendita a imballo intero",
                            "grammage": 0,
                            "price": "1.59",
                            "price_label": "€ 1,59 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 10.549202218722169,
                                "left": 50.13581684128832,
                                "width": 23.139309274350023,
                                "height": 16.226117920975142
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/insalataro_pomodoro_1511363341_1525100330_1550743355_1584109143.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_Bqvxx7Z_ra2wClP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "91008",
                            "field1": "MELANZANE",
                            "field2": "al kg",
                            "field3": "vendita a imballo intero",
                            "field4": "",
                            "description": "MELANZANE al kg vendita a imballo intero",
                            "grammage": 0,
                            "price": "1.19",
                            "price_label": "€ 1,19 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 10.782031089502146,
                                "left": 73.48855258051998,
                                "width": 23.139309274350023,
                                "height": 16.226117920975142
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/melanzane_273717584_1493893426_1494252854.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_YLM4IGh_bfScUcD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "208101",
                            "field1": "radicchio rosso",
                            "field2": "tondo",
                            "field3": "al kg",
                            "field4": "vendita a imballo intero",
                            "description": "radicchio rosso tondo al kg vendita a imballo intero",
                            "grammage": null,
                            "price": "1.39",
                            "price_label": "€ 1,39 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 27.080052044100515,
                                "left": 3.562281722933644,
                                "width": 23.139309274350023,
                                "height": 16.226117920975142
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/radicchio_chioggia_1481125117_1508162572_1584109196.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_AYrQfH8_RqPlKYm.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "hat-chef",
                                    "title": "Radicchio rosso in padella",
                                    "data": {
                                        "ingredients": "3 cespi di radicchio, 1 cipolla bianca, 2 rametti di maggiorana fresca, olio extravergine di oliva, sale, pepe nero",
                                        "recipe": "niziate la preparazione del radicchio in padella mondando ogni cespo dal torsolo centrale e da eventuali foglie esterne rovinate. Sfogliatelo e tagliatelo a striscioline.\nIn una padella scaldate 3 cucchiai di olio, unite la cipolla tritata e fate soffriggere per qualche minuto. Unite il radicchio e fate cuocere a fiamma viva per 5 minuti. Una volta cotto unite le foglie di maggiorana e aggiustate di sale e di pepe macinato al momento.\nIl radicchio in padella è pronto per essere servito come gustoso contorno di stagione.",
                                        "img": [
                                            "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/images/ricetta-radicchio.png"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "87460",
                            "field1": "PATATE",
                            "field2": "in Rete kg 4",
                            "field3": "al pz",
                            "field4": "vendita a imballo intero",
                            "description": "PATATE in Rete kg 4 al pz vendita a imballo intero",
                            "grammage": 4000,
                            "price": "2.39",
                            "price_label": "€ 2,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 27.31288091488049,
                                "left": 26.651144741948002,
                                "width": 23.139309274350023,
                                "height": 16.226117920975142
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/PATATE_KG4_1503560413.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_cWZhlAI_8nWPbj2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "88712",
                            "field1": "JENTU",
                            "field2": "Insalata Primavera",
                            "field3": "gr 200",
                            "field4": "",
                            "description": "JENTU Insalata Primavera gr 200",
                            "grammage": 200,
                            "price": "1.05",
                            "price_label": "€ 1,05",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 27.31288091488049,
                                "left": 50.13581684128832,
                                "width": 23.139309274350023,
                                "height": 16.226117920975142
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/6000986_1528795124.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_kc2zlGn_mm8X9hF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "94910",
                            "field1": "JENTU",
                            "field2": "Carote julienne ",
                            "field3": "gr 200",
                            "field4": "",
                            "description": "JENTU Carote julienne  gr 200",
                            "grammage": 200,
                            "price": "0.60",
                            "price_label": "€ 0,60",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 27.31288091488049,
                                "left": 73.48855258051998,
                                "width": 23.139309274350023,
                                "height": 16.226117920975142
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/6000990_1498034756.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_ULeTPVN_1jreCiP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "88672",
                            "field1": "ORATE",
                            "field2": "",
                            "field3": "al kg",
                            "field4": "",
                            "description": "ORATE al kg",
                            "grammage": 0,
                            "price": "4.90",
                            "price_label": "€ 4,90 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pescheria",
                            "subcategory": "Pescato",
                            "blueprint": {
                                "top": 52.225570088338,
                                "left": 3.298409002716329,
                                "width": 25.90997283663175,
                                "height": 20.882695336574677
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/orate_1584372407.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_j4llI2H_1PyTFJM.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "88662",
                            "field1": "COZZE",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "COZZE al kg",
                            "grammage": 0,
                            "price": "1.59",
                            "price_label": "€ 1,59 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pescheria",
                            "subcategory": "Pescato",
                            "blueprint": {
                                "top": 52.45839895911798,
                                "left": 29.025999223903757,
                                "width": 21.42413659293753,
                                "height": 20.882695336574677
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cozze_1492162033.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_BPWZu5l_31gkYuy.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "188303",
                            "field1": "SEPPIE SPORCHE ",
                            "field2": "Decongelate",
                            "field3": "al kg ",
                            "field4": "",
                            "description": "SEPPIE SPORCHE  Decongelate al kg ",
                            "grammage": 0,
                            "price": "8.90",
                            "price_label": "€ 8,90 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 52.341984523727994,
                                "left": 50.399689561505625,
                                "width": 23.403181994567326,
                                "height": 20.882695336574677
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/seppie_sporche_1584372535.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_7gBPVee_jR1zaCF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "126574",
                            "field1": "SCAMPI DECONGELATI ",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "SCAMPI DECONGELATI  al kg",
                            "grammage": 0,
                            "price": "8.90",
                            "price_label": "€ 8,90 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pescheria",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 52.10915565294801,
                                "left": 73.35661622041133,
                                "width": 23.403181994567326,
                                "height": 20.882695336574677
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/scampi_decongelati__1584372477.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_00F4PI5_vLwAE4g.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "207633",
                            "field1": "TRIGLIA ",
                            "field2": "di Scoglio",
                            "field3": "al kg",
                            "field4": "",
                            "description": "TRIGLIA  di Scoglio al kg",
                            "grammage": null,
                            "price": "13.90",
                            "price_label": "€ 13,90 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pescheria",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 73.4129973293159,
                                "left": 3.5622817229336365,
                                "width": 17.334109429569267,
                                "height": 20.882695336574677
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Triglie__1584372990.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_gvjoZau_tz8sBB4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "Tutto quello che c'è da sapere sulla triglia",
                                    "data": {
                                        "titolo": "",
                                        "testo": "Bella e buona, tra i migliori fra tutti i pesci, anche superiore alla spigola e al rombo per parlare di pesci pregiati. Bella per il suo colore bruno-rosso vivo e buona per il suo sapore deciso di mare, deciso ma delicato e direi raffinato. Si parla naturalmente della triglia di scoglio (mullus surmuletus), molto apprezzata anche dagli antichi romani.\nLa triglia è un pesce che si presta a tutte le preparazioni: in umido col pomodoro, fritta se di piccola taglia e, se grossa anche arrosto o semplicemente bollita in court-bouillon e condita con un filo d’olio e, proprio per il suo sapore deciso, non può mancare nelle zuppe di pesce alle quali dà anche colore perché rimane bella rossa anche dopo la cottura. (Fonte: piattoforte.it)",
                                        "img": [
                                            "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/images/triglia.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "207634",
                            "field1": "TRANCE ",
                            "field2": "di Pesce spada ",
                            "field3": "decongelato",
                            "field4": "al kg",
                            "description": "TRANCE  di Pesce spada  decongelato al kg",
                            "grammage": 0,
                            "price": "16.90",
                            "price_label": "€ 16,90 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 73.4129973293159,
                                "left": 20.71400853705859,
                                "width": 17.334109429569267,
                                "height": 20.882695336574677
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/trance_di_pesce_spada__1584373042.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_En6LzK2_uLPZZSm.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "92481",
                            "field1": "CROMARIS ",
                            "field2": "spigola",
                            "field3": "al kg",
                            "field4": "",
                            "description": "CROMARIS  spigola al kg",
                            "grammage": 0,
                            "price": "7.90",
                            "price_label": "€ 7,90 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pescheria",
                            "subcategory": "Pescato",
                            "blueprint": {
                                "top": 73.4129973293159,
                                "left": 36.94218083042297,
                                "width": 21.292200232828876,
                                "height": 20.882695336574677
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/spigola_orata_piatto_1584372610.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_Z9W60jg_NfROKYE.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "207482",
                            "field1": "CROMARIS ",
                            "field2": "ombrina",
                            "field3": "ALLEVATA ADRIATICO",
                            "field4": "al kg",
                            "description": "CROMARIS  ombrina ALLEVATA ADRIATICO al kg",
                            "grammage": null,
                            "price": "13.90",
                            "price_label": "€ 13,90 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pescheria",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 73.52941176470588,
                                "left": 56.9965075669383,
                                "width": 21.292200232828876,
                                "height": 20.882695336574677
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cromaris_logo_1584372853.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/ombrina_1490375453_1584372854.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_O1rWlnU_IJJT46B.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "Cromaris",
                                    "data": "http://www.cromaris.hr/it"
                                }
                            ]
                        },
                        {
                            "item_id": "205169",
                            "field1": "POLPO ",
                            "field2": "Decongelato",
                            "field3": "arricciato in acqua di mare",
                            "field4": "al kg",
                            "description": "POLPO  Decongelato arricciato in acqua di mare al kg",
                            "grammage": 0,
                            "price": "9.90",
                            "price_label": "€ 9,90 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pescheria",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 73.4129973293159,
                                "left": 77.05083430345363,
                                "width": 19.445091191307725,
                                "height": 20.882695336574677
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/31704_polpo_1584372910.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_4KIg2ZM_0aOzYAk.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 7,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_7_eFVe902.jpg",
                    "products": [
                        {
                            "item_id": "94736",
                            "field1": "ROCCHETTA\t",
                            "field2": "Acqua naturale ",
                            "field3": "lt 1,5 ",
                            "field4": "",
                            "description": "ROCCHETTA\t Acqua naturale  lt 1,5 ",
                            "grammage": 1500,
                            "price": "0.29",
                            "price_label": "€ 0,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Acqua",
                            "blueprint": {
                                "top": 9.617886735602275,
                                "left": 3.298409002716329,
                                "width": 46.49204501358168,
                                "height": 43.117852496062454
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Rocchetta_15L__1494486530_1497364089.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_LkUSFAr_4V67yJS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "106323",
                            "field1": "SAN BENEDETTO",
                            "field2": "Acqua minerale",
                            "field3": "naturale oligominerale",
                            "field4": "lt 2 ",
                            "description": "SAN BENEDETTO Acqua minerale naturale oligominerale lt 2 ",
                            "grammage": 12000,
                            "price": "0.19",
                            "price_label": "€ 0,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Acqua",
                            "blueprint": {
                                "top": 10.549202218722181,
                                "left": 50.07760962359333,
                                "width": 23.53511835467598,
                                "height": 21.23193864274464
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/san_benedetto_acqua_2lt_1560354068_1581353204.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_FXQy37N_A6Homet.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "102989",
                            "field1": "ULIVETO",
                            "field2": "Acqua minerale naturale",
                            "field3": "lt 1,5",
                            "field4": "",
                            "description": "ULIVETO Acqua minerale naturale lt 1,5",
                            "grammage": 1500,
                            "price": "0.35",
                            "price_label": "€ 0,35",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Acqua",
                            "blueprint": {
                                "top": 10.549202218722181,
                                "left": 73.56228172293368,
                                "width": 23.139309274350015,
                                "height": 21.23193864274464
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/1589_1528212189.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_yGybZR0_um6cuam.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "87222",
                            "field1": "LILIA",
                            "field2": "Acqua minerale ",
                            "field3": "naturale/SVEVA Effervescente naturale",
                            "field4": "cl 50",
                            "description": "LILIA Acqua minerale  naturale/SVEVA Effervescente naturale cl 50",
                            "grammage": 500,
                            "price": "0.10",
                            "price_label": "€ 0,10",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Sveva",
                                "Lilia"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Acqua",
                            "blueprint": {
                                "top": 31.85304389509005,
                                "left": 50.209545983702,
                                "width": 23.139309274350015,
                                "height": 20.882695336574677
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/7611_1490975061.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/7610_1490975093_1583517714.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_MAVHG5W_yMh34BN.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "207463",
                            "field1": "LAURETANA",
                            "field2": "Acqua in vetro",
                            "field3": "lt 1",
                            "field4": "",
                            "description": "LAURETANA Acqua in vetro lt 1",
                            "grammage": 1000,
                            "price": "0.65",
                            "price_label": "€ 0,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Acqua",
                            "blueprint": {
                                "top": 31.85304389509005,
                                "left": 73.56228172293368,
                                "width": 23.139309274350015,
                                "height": 20.882695336574677
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/lauretana_acqua_1525857810_1583505676.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_7RArtKL_UEL5bKr.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "127572",
                            "field1": "SPRITE ",
                            "field2": "classica/ FANTA classica/ zero/ COCA COLA",
                            "field3": "vari tipi",
                            "field4": "cl 66",
                            "description": "SPRITE  classica/ FANTA classica/ zero/ COCA COLA vari tipi cl 66",
                            "grammage": 660,
                            "price": "0.65",
                            "price_label": "€ 0,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Fanta",
                                "Fanta Zero",
                                "Coca Cola"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 53.3897144422379,
                                "left": 3.2402017850213585,
                                "width": 23.139309274350015,
                                "height": 20.649866465794698
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/fanta_zero_660_ml_1524048589_1524493108_1536154941.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/57968-sf9_1536154967.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/57969-sf9_1536154968.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/coca_cola_1525273392_1536155047.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/58365_1559575631.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_3qJOdSX_mqlIGf6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "92628",
                            "field1": "PEPSI",
                            "field2": "Cola classica/max zero",
                            "field3": "lt 1,75 ",
                            "field4": "",
                            "description": "PEPSI Cola classica/max zero lt 1,75 ",
                            "grammage": 1750,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Cola Classica",
                                "Max Zero"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 53.15688557145793,
                                "left": 26.59293752425302,
                                "width": 23.139309274350015,
                                "height": 20.649866465794698
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/pepsi_15_classica_1468309603_1470237957_1510056289_1519204848.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_wggWRP6_plwE5fG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "87234",
                            "field1": "FANTA/SPRITE",
                            "field2": "Vari tipi",
                            "field3": "lt 1,5",
                            "field4": "",
                            "description": "FANTA/SPRITE Vari tipi lt 1,5",
                            "grammage": 1500,
                            "price": "0.85",
                            "price_label": "€ 0,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Fanta ",
                                "Sprite"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 73.99506950626584,
                                "left": 3.240201785021354,
                                "width": 23.139309274350015,
                                "height": 20.649866465794698
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Fanta_15_1460049113_1460649943_1461668143_1462289209_1466695039_1467_NBoYMJS.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Sprite_Lt_15_1501168372.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_rBqJlas_ggxkmPD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "86928",
                            "field1": "BRAVO  ",
                            "field2": "Succo classico",
                            "field3": "vari gusti",
                            "field4": "lt 2",
                            "description": "BRAVO   Succo classico vari gusti lt 2",
                            "grammage": 2000,
                            "price": "1.05",
                            "price_label": "€ 1,05",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Succhi",
                            "blueprint": {
                                "top": 74.11148394165582,
                                "left": 26.724873884361674,
                                "width": 23.139309274350015,
                                "height": 20.649866465794698
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/6330-P88_bravo_multivatimin_1558682437.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/8956-P88_1558682555.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_G0kojxW_QHYVfpe.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "89415",
                            "field1": "COCA COLA",
                            "field2": "Classica/zero",
                            "field3": "lt 2",
                            "field4": "",
                            "description": "COCA COLA Classica/zero lt 2",
                            "grammage": 2000,
                            "price": "1.25",
                            "price_label": "€ 1,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classica",
                                "Zero"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 53.15688557145793,
                                "left": 50.07760962359335,
                                "width": 46.49204501358168,
                                "height": 41.60446483599261
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Coca_Cola_2_LT_1486649909_1487608435.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_8rrlyr7_zfw9b1E.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 8,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_8_uC5jeGs.jpg",
                    "products": [
                        {
                            "item_id": "104027",
                            "field1": "BOTTE BUONA",
                            "field2": "Vino I.G.T. ",
                            "field3": "bianco/rosso d'Italia ",
                            "field4": "cl 75",
                            "description": "BOTTE BUONA Vino I.G.T.  bianco/rosso d'Italia  cl 75",
                            "grammage": 750,
                            "price": "0.79",
                            "price_label": "€ 0,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Bianco",
                                "Rosso"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 53.15688557145793,
                                "left": 50.07760962359335,
                                "width": 46.49204501358168,
                                "height": 41.60446483599261
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Botte_Buona_Bianco_cl_75_1498838946.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Botte_Buona_Rosso_cl_75_1498838947.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_O44mDwE_9a48TWy.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "114019",
                            "field1": "BOTTE BUONA",
                            "field2": "Vino I.G.T. Lambrusco di Romagna ",
                            "field3": "frizzante amabile ",
                            "field4": "cl 75",
                            "description": "BOTTE BUONA Vino I.G.T. Lambrusco di Romagna  frizzante amabile  cl 75",
                            "grammage": 750,
                            "price": "1.25",
                            "price_label": "€ 1,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Lambrusco",
                                "Frizzante Amabile"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 9.850715606382252,
                                "left": 3.43034536282499,
                                "width": 46.49204501358168,
                                "height": 42.76860918989249
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/BB_LAMBRUSCOamab.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_WUCPhoB_niXDkNo.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "105244",
                            "field1": "DILMOOR",
                            "field2": "Amaro del Duca ",
                            "field3": "cl 70",
                            "field4": "",
                            "description": "DILMOOR Amaro del Duca  cl 70",
                            "grammage": 700,
                            "price": "3.19",
                            "price_label": "€ 3,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Liquori",
                            "blueprint": {
                                "top": 10.66561665411217,
                                "left": 50.399689561505625,
                                "width": 23.139309274350023,
                                "height": 21.11552420735465
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/27932_1500039963.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_RJRego7_aMGJWTr.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "113994",
                            "field1": "STOCK",
                            "field2": "Limoncè crema ",
                            "field3": "cl 50",
                            "field4": "",
                            "description": "STOCK Limoncè crema  cl 50",
                            "grammage": 500,
                            "price": "4.99",
                            "price_label": "€ 4,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Liquori",
                            "blueprint": {
                                "top": 10.782031089502157,
                                "left": 73.48855258051998,
                                "width": 23.139309274350023,
                                "height": 21.11552420735465
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/stock_Crema_Limonce_50_cl.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_qMUixMK_Sp5Tv7n.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "118193",
                            "field1": "PALLINI ",
                            "field2": "maloney’s Irish country cream ",
                            "field3": "cl 70",
                            "field4": "",
                            "description": "PALLINI  maloney’s Irish country cream  cl 70",
                            "grammage": 700,
                            "price": "4.79",
                            "price_label": "€ 4,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Liquori",
                            "blueprint": {
                                "top": 31.73662945970006,
                                "left": 50.26775320139697,
                                "width": 23.139309274350023,
                                "height": 21.11552420735465
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/49046_Maloneys_1513702212.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_EIPu0CJ_m1aYdKx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "111730",
                            "field1": "BORGHETTI",
                            "field2": "Caffè sport ",
                            "field3": "cl 70",
                            "field4": "",
                            "description": "BORGHETTI Caffè sport  cl 70",
                            "grammage": 700,
                            "price": "6.99",
                            "price_label": "€ 6,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Liquori",
                            "blueprint": {
                                "top": 31.73662945970006,
                                "left": 73.62048894062863,
                                "width": 23.139309274350023,
                                "height": 21.11552420735465
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Borghetti_Caffe_70_cl_1444808008_1508237706.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_sT9vEGE_lRnHdKu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "112158",
                            "field1": "TERRE PASSERI",
                            "field2": "Vino Garganega Pinot grigio D.O.C.",
                            "field3": "",
                            "field4": "cl 75",
                            "description": "TERRE PASSERI Vino Garganega Pinot grigio D.O.C. cl 75",
                            "grammage": 750,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 53.15688557145793,
                                "left": 3.4303453628249825,
                                "width": 23.139309274350023,
                                "height": 20.766280901184686
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/47683_1516377782.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_wRpfxRw_1jqNd7c.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "86936",
                            "field1": "BALI'AGGIO",
                            "field2": "Vino rosso Basilicata I.G.P.",
                            "field3": "cl 75",
                            "field4": "",
                            "description": "BALI'AGGIO Vino rosso Basilicata I.G.P. cl 75",
                            "grammage": 750,
                            "price": "2.25",
                            "price_label": "€ 2,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 53.27330000684791,
                                "left": 26.9150174621653,
                                "width": 23.139309274350023,
                                "height": 20.766280901184686
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/36485_1490193358.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_9WxTuxQ_EhvE6ac.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "92278",
                            "field1": "SANCRISPINO\t",
                            "field2": "Vino rosso/ rosato/ bianco",
                            "field3": "lt 1",
                            "field4": "",
                            "description": "SANCRISPINO\t Vino rosso/ rosato/ bianco lt 1",
                            "grammage": 1000,
                            "price": "1.15",
                            "price_label": "€ 1,15",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Rosso",
                                "Rosato",
                                "Bianco"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 74.11148394165582,
                                "left": 3.562281722933633,
                                "width": 23.139309274350023,
                                "height": 20.766280901184686
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cantine_ronco_sancrispino_bianco_1lt_1495122911.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cantine_ronco_sancrispino_rosso_1lt_1495122912.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_MLfO6iF_8Oqwgk2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "89461",
                            "field1": "CANTINA DI VENOSA ",
                            "field2": "Vino dama vetro",
                            "field3": "rosato/rosso Basilicata I.G.T.",
                            "field4": "lt 5",
                            "description": "CANTINA DI VENOSA  Vino dama vetro rosato/rosso Basilicata I.G.T. lt 5",
                            "grammage": 5000,
                            "price": "6.99",
                            "price_label": "€ 6,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Rosato",
                                "Rosso"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 74.22789837704582,
                                "left": 26.65114474194799,
                                "width": 23.139309274350023,
                                "height": 20.766280901184686
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/42152_1493289249.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_qcR6APO_WxBfGkX.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 9,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_9_dzWxvna.jpg",
                    "products": [
                        {
                            "item_id": "107116",
                            "field1": "GRIFO",
                            "field2": "Vino D.O.P. Castel del Monte bianco / rosso/ rosato /",
                            "field3": "Vino I.G.P. Puglia bombino bianco/ ",
                            "field4": "Nero di Troia cl 75",
                            "description": "GRIFO Vino D.O.P. Castel del Monte bianco / rosso/ rosato / Vino I.G.P. Puglia bombino bianco/  Nero di Troia cl 75",
                            "grammage": 750,
                            "price": "1.25",
                            "price_label": "€ 1,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Castel del Monte Bianco",
                                "Castel del Monte Rosso",
                                "Castel del Monte Rosato",
                                "Puglia Bombino Bianco",
                                "Puglia Bombino Nero di Troia"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 9.734301170992264,
                                "left": 3.430345362824979,
                                "width": 46.22817229336437,
                                "height": 42.88502362528248
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/A83_1502176960.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/43732-a83_1517481900.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_UUqoGDV_Y7geIqQ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "103590",
                            "field1": "LA CACCIATORA",
                            "field2": "Vino frizzante Pinot Rosa/",
                            "field3": "Chardonnay/Verduzzo ",
                            "field4": "cl 75",
                            "description": "LA CACCIATORA Vino frizzante Pinot Rosa/ Chardonnay/Verduzzo  cl 75",
                            "grammage": 750,
                            "price": "2.55",
                            "price_label": "€ 2,55",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Frizzante Pinot Rosa",
                                "Chardonnay",
                                "Verduzzo"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 10.782031089502157,
                                "left": 50.209545983701986,
                                "width": 23.271245634458676,
                                "height": 20.882695336574677
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Chardonnay_frizzante_075_lt_1474905138_1498556992.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/la_cacciatora_pinot_1474905150_1498556992.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/La_cacciatora_verduzzo_1482144838_1498556992.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_NPVZFSv_FrE8DDw.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "94750",
                            "field1": "NOTTE ROSSA",
                            "field2": "Vino Salice salentino",
                            "field3": "D.O.P. ",
                            "field4": "cl 75",
                            "description": "NOTTE ROSSA Vino Salice salentino D.O.P.  cl 75",
                            "grammage": 750,
                            "price": "4.49",
                            "price_label": "€ 4,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 10.66561665411217,
                                "left": 73.69421808304233,
                                "width": 22.875436554132715,
                                "height": 20.882695336574677
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/51705_1547658263.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_mPcSFHW_9UbTbTG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "188302",
                            "field1": "SETTEARCHI",
                            "field2": "Vino I.G.T. vino salento",
                            "field3": "",
                            "field4": "cl 75",
                            "description": "SETTEARCHI Vino I.G.T. vino salento cl 75",
                            "grammage": 750,
                            "price": "2.59",
                            "price_label": "€ 2,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "falanghina",
                                "fiano",
                                "aglianico",
                                "malvasia nera"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 31.96945833048004,
                                "left": 50.341482343810654,
                                "width": 22.875436554132715,
                                "height": 20.882695336574677
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/61451_MalvasiaNera75_1566406626.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/SETTEARCHI_VINO_FIANO.SAL.IGT_CL_75_1557151601_1569225702.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_YbfVEOG_NWHZqbv.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "95153",
                            "field1": "TERRE PASSERI",
                            "field2": "Vino bianco/rosso/rosato",
                            "field3": "cl 75",
                            "field4": "",
                            "description": "TERRE PASSERI Vino bianco/rosso/rosato cl 75",
                            "grammage": 750,
                            "price": "1.05",
                            "price_label": "€ 1,05",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Bianco",
                                "Rosso",
                                "Rosato"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 31.96945833048004,
                                "left": 73.69421808304229,
                                "width": 22.875436554132715,
                                "height": 20.882695336574677
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/terre_passeri_vino_bianco_75_cl_1497610920.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/terre_passeri_vino_rose_75_cl_1497610921.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/terre_passeri_vino_rosso_75_cl_1497610922.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_yS8XX4Q_DvX0IF4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "204393",
                            "field1": "SOLOPERTO ",
                            "field2": "Primitivo di manduria d.o.c.",
                            "field3": "cl 75",
                            "field4": "",
                            "description": "SOLOPERTO  Primitivo di manduria d.o.c. cl 75",
                            "grammage": 750,
                            "price": "6.29",
                            "price_label": "€ 6,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 53.15688557145793,
                                "left": 3.6360108653472882,
                                "width": 22.875436554132715,
                                "height": 20.882695336574677
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Soloperto_primitivo_di_manduria_doc_cl.75_1533288159_1558018999_1579885802.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_2eElQuq_Mcmrr2s.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "184596",
                            "field1": "ZONIN",
                            "field2": "Prosecco extra dry D.O.C.",
                            "field3": "cl 75",
                            "field4": "",
                            "description": "ZONIN Prosecco extra dry D.O.C. cl 75",
                            "grammage": 750,
                            "price": "3.25",
                            "price_label": "€ 3,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 53.15688557145793,
                                "left": 26.8568102444703,
                                "width": 22.875436554132715,
                                "height": 20.649866465794698
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/zonin_prosecco_75_cl_1542629543_1562657884.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_KOVIvqX_CI6Pign.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "114768",
                            "field1": "GANCIA",
                            "field2": "Brachetto d'Acqui",
                            "field3": "D.O.C.G. ",
                            "field4": "cl 75",
                            "description": "GANCIA Brachetto d'Acqui D.O.C.G.  cl 75",
                            "grammage": 750,
                            "price": "3.75",
                            "price_label": "€ 3,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 53.27330000684791,
                                "left": 50.07760962359331,
                                "width": 23.271245634458676,
                                "height": 20.649866465794698
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Gancia_brachetto_dacqui_1448011375.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_4gkJwrv_NX046Tm.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "113949",
                            "field1": "CALDIROLA",
                            "field2": "Fragolino",
                            "field3": "cl 75",
                            "field4": "",
                            "description": "CALDIROLA Fragolino cl 75",
                            "grammage": 750,
                            "price": "1.89",
                            "price_label": "€ 1,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 53.27330000684791,
                                "left": 73.56228172293363,
                                "width": 23.271245634458676,
                                "height": 20.649866465794698
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/665193_Caldirola_Fragolino_75_cl_1510057291.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_30zhk9U_PtzmDZ1.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "115354",
                            "field1": "GANCIA",
                            "field2": "Asti spumante D.O.C.G. ",
                            "field3": "cl 75",
                            "field4": "",
                            "description": "GANCIA Asti spumante D.O.C.G.  cl 75",
                            "grammage": 750,
                            "price": "3.29",
                            "price_label": "€ 3,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 74.11148394165582,
                                "left": 3.298409002716337,
                                "width": 23.271245634458676,
                                "height": 20.649866465794698
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/gancia_spumante_asti_docg_1510929556_1510994176.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_CvCUULn_FcAgM53.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "115356",
                            "field1": "GANCIA",
                            "field2": "Pinot di Pinot ",
                            "field3": "brut/rosè ",
                            "field4": "cl 75",
                            "description": "GANCIA Pinot di Pinot  brut/rosè  cl 75",
                            "grammage": 750,
                            "price": "2.89",
                            "price_label": "€ 2,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Brut",
                                "Rosè"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 74.22789837704582,
                                "left": 26.783081102056656,
                                "width": 23.271245634458676,
                                "height": 20.649866465794698
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Gancia_pinot_rose_75_cl_1448461855_1510994178.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Gancia_pinot_pinot_brut_75_cl_1510994178.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_8tpDb2p_S9Ns1Hl.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "195811",
                            "field1": "ZONIN",
                            "field2": "Spumante rosato brut",
                            "field3": "cl 75",
                            "field4": "",
                            "description": "ZONIN Spumante rosato brut cl 75",
                            "grammage": 750,
                            "price": "3.69",
                            "price_label": "€ 3,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 74.22789837704582,
                                "left": 50.13581684128832,
                                "width": 23.271245634458676,
                                "height": 20.649866465794698
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/61447_zonin_rose_brut_1572020497.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_n7lAQeF_ogHuPsC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "106328",
                            "field1": "GANCIA\t",
                            "field2": "Spumante grand reale dolce",
                            "field3": "cl 75",
                            "field4": "",
                            "description": "GANCIA\t Spumante grand reale dolce cl 75",
                            "grammage": 750,
                            "price": "1.85",
                            "price_label": "€ 1,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 74.11148394165582,
                                "left": 73.62048894062863,
                                "width": 23.271245634458676,
                                "height": 20.649866465794698
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/GANCIA_GRAN_REALE__75_._CL_1480591171.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_SD6OScp_vbFPIV0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 10,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_10_3CXWO1v.jpg",
                    "products": [
                        {
                            "item_id": "107422",
                            "field1": "NASTRO AZZURRO",
                            "field2": "Birra",
                            "field3": "cl 66",
                            "field4": "",
                            "description": "NASTRO AZZURRO Birra cl 66",
                            "grammage": 660,
                            "price": "0.79",
                            "price_label": "€ 0,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Birre",
                            "blueprint": {
                                "top": 9.850715606382252,
                                "left": 3.43034536282499,
                                "width": 46.22817229336437,
                                "height": 43.00143806067246
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/nastro_azzurro_birra_66_cl_1439309571_1502296460.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_FnywPsk_cSobOoP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "113993",
                            "field1": "STOCK",
                            "field2": "Limoncè",
                            "field3": "cl 50",
                            "field4": "",
                            "description": "STOCK Limoncè cl 50",
                            "grammage": 500,
                            "price": "4.35",
                            "price_label": "€ 4,35",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Liquori",
                            "blueprint": {
                                "top": 53.15688557145793,
                                "left": 50.341482343810625,
                                "width": 46.22817229336437,
                                "height": 41.60446483599261
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/stock_Limonce_50_cl_1510071920.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_s9h2D3y_4gLWZbV.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "95149",
                            "field1": "DREHER\t",
                            "field2": "Birra ",
                            "field3": "cl 33 x 3",
                            "field4": "",
                            "description": "DREHER\t Birra  cl 33 x 3",
                            "grammage": 990,
                            "price": "1.14",
                            "price_label": "€ 1,14",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Birre",
                            "blueprint": {
                                "top": 10.66561665411217,
                                "left": 50.341482343810625,
                                "width": 23.271245634458676,
                                "height": 20.99910977196466
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Dreher_Originale_3x33cl_ow_1436520304_1439993106_1497611256.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_hGMQ0gl_vSbn7st.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "110490",
                            "field1": "PERONI",
                            "field2": "Birra ",
                            "field3": "cl 33 X 3",
                            "field4": "",
                            "description": "PERONI Birra  cl 33 X 3",
                            "grammage": 990,
                            "price": "1.19",
                            "price_label": "€ 1,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Birre",
                            "blueprint": {
                                "top": 10.66561665411217,
                                "left": 73.56228172293363,
                                "width": 23.271245634458676,
                                "height": 20.99910977196466
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/peroni_33x3_1546514355.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_IIa8F4E_8AKKNfH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "104927",
                            "field1": "TUBORG",
                            "field2": "Birra",
                            "field3": "cl 33 x 3",
                            "field4": "",
                            "description": "TUBORG Birra cl 33 x 3",
                            "grammage": 990,
                            "price": "1.22",
                            "price_label": "€ 1,22",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Birre",
                            "blueprint": {
                                "top": 31.96945833048004,
                                "left": 50.209545983701965,
                                "width": 23.271245634458676,
                                "height": 20.99910977196466
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/5998-46136_tuborg_1535107266.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_FBI4uZ8_H77rcAS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "86930",
                            "field1": "BELTION",
                            "field2": "Amaro mediterraneo",
                            "field3": "lt 1 ",
                            "field4": "",
                            "description": "BELTION Amaro mediterraneo lt 1 ",
                            "grammage": 1000,
                            "price": "5.79",
                            "price_label": "€ 5,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Liquori",
                            "blueprint": {
                                "top": 31.96945833048004,
                                "left": 73.56228172293363,
                                "width": 23.271245634458676,
                                "height": 20.99910977196466
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/539_beltion_1539240886.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/BELTION_AMARO_1570466503.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_s6XQE0o_DJNdj9D.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "104928",
                            "field1": "LUCANO",
                            "field2": "Amaro",
                            "field3": "cl 70",
                            "field4": "",
                            "description": "LUCANO Amaro cl 70",
                            "grammage": 700,
                            "price": "6.99",
                            "price_label": "€ 6,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Liquori",
                            "blueprint": {
                                "top": 53.15688557145793,
                                "left": 3.298409002716337,
                                "width": 23.271245634458676,
                                "height": 20.99910977196466
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/lucano_amaro_70_cl_1499707772.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_8bFUAud_oymidvG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "115352",
                            "field1": "DISARONNO",
                            "field2": "Amaretto ",
                            "field3": "cl 70",
                            "field4": "",
                            "description": "DISARONNO Amaretto  cl 70",
                            "grammage": 700,
                            "price": "8.99",
                            "price_label": "€ 8,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Liquori",
                            "blueprint": {
                                "top": 53.15688557145793,
                                "left": 26.783081102056656,
                                "width": 23.271245634458676,
                                "height": 20.99910977196466
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/1159_1575903182.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_63b0rcB_yk6TFIe.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "112155",
                            "field1": "CYNAR",
                            "field2": "Amaro",
                            "field3": "cl 70",
                            "field4": "",
                            "description": "CYNAR Amaro cl 70",
                            "grammage": 700,
                            "price": "6.49",
                            "price_label": "€ 6,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Liquori",
                            "blueprint": {
                                "top": 74.11148394165582,
                                "left": 3.43034536282499,
                                "width": 23.271245634458676,
                                "height": 20.99910977196466
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Cynar_Amaro_cl_70_1430325361_1508774545.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_LWxtdNi_q7Cui4D.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "104929",
                            "field1": "VODKA",
                            "field2": "Russian standard",
                            "field3": "original",
                            "field4": "cl 70",
                            "description": "VODKA Russian standard original cl 70",
                            "grammage": 700,
                            "price": "8.79",
                            "price_label": "€ 8,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Liquori",
                            "blueprint": {
                                "top": 74.11148394165582,
                                "left": 26.783081102056656,
                                "width": 22.74350019402406,
                                "height": 20.99910977196466
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Standard_Russian_vodka_Bottle_70_cl_1429891858_1499707812.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_6QsV9HE_9mAdVwq.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 11,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_11_HvJu2Aa.jpg",
                    "products": [
                        {
                            "item_id": "207458",
                            "field1": "MUTTI",
                            "field2": "Pelati mediterranei",
                            "field3": "kg 2,5",
                            "field4": "",
                            "description": "MUTTI Pelati mediterranei kg 2,5",
                            "grammage": 2500,
                            "price": "2.45",
                            "price_label": "€ 2,45",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Rossi",
                            "blueprint": {
                                "top": 9.734301170992264,
                                "left": 3.298409002716337,
                                "width": 46.36010865347303,
                                "height": 33.80469766486338
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/3771400_1520360198_mutti_pelati_2_252C5_kg_1583516088.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_xUIeYpq_KI1W5SJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "204388",
                            "field1": "RIBEIRA",
                            "field2": "Tonno",
                            "field3": "all'olio di oliva",
                            "field4": " gr 1730",
                            "description": "RIBEIRA Tonno all'olio di oliva  gr 1730",
                            "grammage": 1730,
                            "price": "9.99",
                            "price_label": "€ 9,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 43.96014517564884,
                                "left": 50.341482343810625,
                                "width": 46.36010865347303,
                                "height": 32.989796617133464
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/27333_1580400001.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_46ef0D3_9w53HEI.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "164635",
                            "field1": "DESANTIS",
                            "field2": "Olio extra vergine di oliva ",
                            "field3": "san giovanni ",
                            "field4": "lt 5",
                            "description": "DESANTIS Olio extra vergine di oliva  san giovanni  lt 5",
                            "grammage": 5000,
                            "price": "14.49",
                            "price_label": "€ 14,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 10.66561665411217,
                                "left": 50.20954598370197,
                                "width": 23.00737291424137,
                                "height": 32.989796617133464
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/40984_1540918171.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_kD9tR4f_R1xWg1v.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "93577",
                            "field1": "CENTRONE",
                            "field2": "Funghi champignon",
                            "field3": "affettati al naturale ",
                            "field4": "kg 1,2 ",
                            "description": "CENTRONE Funghi champignon affettati al naturale  kg 1,2 ",
                            "grammage": 1200,
                            "price": "4.49",
                            "price_label": "€ 4,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 10.66561665411217,
                                "left": 73.69421808304229,
                                "width": 23.00737291424137,
                                "height": 32.989796617133464
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/23150_centrone_funghi_champignon_affettati_1496914539.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_HYL34dv_F6AzVZa.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "117987",
                            "field1": "FLOTT",
                            "field2": "Pezzetti di acciughe ",
                            "field3": "gr 720",
                            "field4": "",
                            "description": "FLOTT Pezzetti di acciughe  gr 720",
                            "grammage": 720,
                            "price": "6.49",
                            "price_label": "€ 6,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 44.07655961103883,
                                "left": 3.5040745052386355,
                                "width": 23.00737291424137,
                                "height": 16.458946791755118
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/flott-alici_1513336223.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_ZLDrvq0_btDkqMC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "165193",
                            "field1": "FERRERO",
                            "field2": "Nutella",
                            "field3": "gr 15 x 120   ",
                            "field4": "",
                            "description": "FERRERO Nutella gr 15 x 120   ",
                            "grammage": null,
                            "price": "13.99",
                            "price_label": "€ 13,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 44.192974046428816,
                                "left": 26.724873884361646,
                                "width": 23.00737291424137,
                                "height": 16.458946791755118
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/50308_nutella_1541494765.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_TzPqklV_osxZhIg.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "86161",
                            "field1": "MERANO\t",
                            "field2": "Yogurt bianco",
                            "field3": "intero/magro",
                            "field4": "kg 1",
                            "description": "MERANO\t Yogurt bianco intero/magro kg 1",
                            "grammage": 1000,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 60.840238307197154,
                                "left": 3.562281722933644,
                                "width": 23.00737291424137,
                                "height": 16.458946791755118
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/54309_meran_1538068667.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/58393_meran_1538068668.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_EvdcoS8_TpguRqM.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "207471",
                            "field1": "GREEN FROST",
                            "field2": "Zucchine a fette alla griglia",
                            "field3": "kg 1",
                            "field4": "",
                            "description": "GREEN FROST Zucchine a fette alla griglia kg 1",
                            "grammage": 1000,
                            "price": "2.79",
                            "price_label": "€ 2,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 60.60740943641718,
                                "left": 26.783081102056656,
                                "width": 23.00737291424137,
                                "height": 16.458946791755118
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Green_frost_ZUCCHINE_GRIGLIATE_1_KG_1583506337.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_cT1dw9n_OLkWtak.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "200561",
                            "field1": "PIZZOLI",
                            "field2": "Crocchette di patate",
                            "field3": "kg 2,5",
                            "field4": "",
                            "description": "PIZZOLI Crocchette di patate kg 2,5",
                            "grammage": 2500,
                            "price": "4.55",
                            "price_label": "€ 4,55",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Preparati",
                            "blueprint": {
                                "top": 77.72033143874548,
                                "left": 3.43034536282499,
                                "width": 23.00737291424137,
                                "height": 17.15743340409505
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/12690_1575909292.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_eajoZsl_Fw6vJ4C.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "170217",
                            "field1": "MC CAIN",
                            "field2": "Crispers",
                            "field3": "kg 2,5",
                            "field4": "",
                            "description": "MC CAIN Crispers kg 2,5",
                            "grammage": 2500,
                            "price": "5.19",
                            "price_label": "€ 5,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 77.48750256796549,
                                "left": 26.651144741948002,
                                "width": 23.00737291424137,
                                "height": 17.15743340409505
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/60079_McCainCrispers25kg_1545328145.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_uakBYhk_M5gCHaV.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "116547",
                            "field1": "VOGLIAZZI",
                            "field2": "Insalata di mare ",
                            "field3": "al naturale",
                            "field4": "kg 3",
                            "description": "VOGLIAZZI Insalata di mare  al naturale kg 3",
                            "grammage": 100,
                            "price": "17.99",
                            "price_label": "€ 17,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 77.72033143874548,
                                "left": 50.003880481179664,
                                "width": 23.271245634458676,
                                "height": 17.15743340409505
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/43273_1512394021.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_h7o3zgI_3IMjgml.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "204402",
                            "field1": "AMADORI",
                            "field2": "Cotoletta di pollo",
                            "field3": "x20 - kg 2,5",
                            "field4": "",
                            "description": "AMADORI Cotoletta di pollo x20 - kg 2,5",
                            "grammage": 2500,
                            "price": "6.49",
                            "price_label": "€ 6,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Preparati",
                            "blueprint": {
                                "top": 77.83674587413545,
                                "left": 73.48855258051998,
                                "width": 23.271245634458676,
                                "height": 17.15743340409505
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/23395_1580398997.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_ZNIzI4d_tJ3gjvF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 12,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_12_zGl64Tk.jpg",
                    "products": [
                        {
                            "item_id": "107211",
                            "field1": "GRANORO",
                            "field2": "Pomodori pelati  ",
                            "field3": "gr 800",
                            "field4": "",
                            "description": "GRANORO Pomodori pelati   gr 800",
                            "grammage": 800,
                            "price": "0.52",
                            "price_label": "€ 0,52",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Rossi",
                            "blueprint": {
                                "top": 10.59020923805764,
                                "left": 3.434004474272928,
                                "width": 46.09992542878448,
                                "height": 32.95828398473483
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/15412_granoro_pomodori_pelati_interi_800g_1541431085.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_CzlHJBa_bI8Nlek.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "93367",
                            "field1": "LA MOLISANA",
                            "field2": "Pasta formati tradizionali ",
                            "field3": "vari tipi ",
                            "field4": "gr 500",
                            "description": "LA MOLISANA Pasta formati tradizionali  vari tipi  gr 500",
                            "grammage": 500,
                            "price": "0.55",
                            "price_label": "€ 0,55",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 10.70206606132386,
                                "left": 50.33929903057419,
                                "width": 23.027591349738998,
                                "height": 32.95828398473483
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/6971_1568910906.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/36764_1568910907.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_46eRK2b_fAslYNY.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "173883",
                            "field1": "BARILLA",
                            "field2": "Pasta integrale",
                            "field3": "vari tipi",
                            "field4": "gr 500",
                            "description": "BARILLA Pasta integrale vari tipi gr 500",
                            "grammage": 500,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 10.59020923805764,
                                "left": 73.41163310961967,
                                "width": 23.027591349738998,
                                "height": 32.95828398473483
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/15570-kioBarillaCellentani500gr_1551969570.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/15569-kio_BarillaIntegraleCasarecce500gr_1579513630.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/15578-kio_1579540681.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_BVFZaOk_9BnrtaS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "93804",
                            "field1": "POMì",
                            "field2": "Passata di pomodoro",
                            "field3": "gr 700",
                            "field4": "",
                            "description": "POMì Passata di pomodoro gr 700",
                            "grammage": 700,
                            "price": "0.55",
                            "price_label": "€ 0,55",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Rossi",
                            "blueprint": {
                                "top": 44.14725621792342,
                                "left": 3.5495898583146905,
                                "width": 23.027591349738998,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/41796_1521624359.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_6UlhEOX_INilRGo.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "86125",
                            "field1": "BARILLA\t",
                            "field2": "Pasta formati tradizionali ",
                            "field3": "vari tipi  ",
                            "field4": "gr 500",
                            "description": "BARILLA\t Pasta formati tradizionali  vari tipi   gr 500",
                            "grammage": 500,
                            "price": "0.49",
                            "price_label": "€ 0,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 44.0353993946572,
                                "left": 26.748695003728564,
                                "width": 23.027591349738998,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/42-1_1529327870.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/45-A05-1_1529327871.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_nDlLave_XZ5SGnl.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85784",
                            "field1": "BARILLA EMILIANE",
                            "field2": "Tortelloni prosciutto crudo e parmigiano/",
                            "field3": "tortellini prosciutto crudo/cappelletti carne",
                            "field4": "gr 250",
                            "description": "BARILLA EMILIANE Tortelloni prosciutto crudo e parmigiano/ tortellini prosciutto crudo/cappelletti carne gr 250",
                            "grammage": 250,
                            "price": "1.65",
                            "price_label": "€ 1,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Tortelloni prosciutto crudo e parmigiano",
                                "Tortellini prosciutto crudo",
                                "Cappelletti carne"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 44.14725621792342,
                                "left": 50.32811334824758,
                                "width": 23.027591349738998,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/barilla_Cappelletti_parmigiano_250_g_1480581111_1484045639.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Tortellini_prosciutto_crudo_250g_sx_1480008751_1480435823_1519213581_Y4w4GMm.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/30839_emiliane_cappelletti_carne_1538065309.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_oYWFoZm_CnLR3hn.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "118160",
                            "field1": "BARILLA EMILIANE",
                            "field2": "Tortellini ",
                            "field3": "con prosciutto crudo",
                            "field4": "gr 500 ",
                            "description": "BARILLA EMILIANE Tortellini  con prosciutto crudo gr 500 ",
                            "grammage": 500,
                            "price": "2.59",
                            "price_label": "€ 2,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 43.92354257139097,
                                "left": 73.52721849366145,
                                "width": 23.027591349738998,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Tortellini_prosciutto_crudo_500g_sx_1484041554_1484736594.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_h5iTC1D_Ni1ZO2o.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "109548",
                            "field1": "BARILLA EMILIANE",
                            "field2": "Cannelloni all'uovo ",
                            "field3": "gr 250",
                            "field4": "",
                            "description": "BARILLA EMILIANE Cannelloni all'uovo  gr 250",
                            "grammage": 250,
                            "price": "1.15",
                            "price_label": "€ 1,15",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 61.03763653112252,
                                "left": 3.676360924683072,
                                "width": 23.027591349738998,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Cannelloni_250g_sx_1576487109_1576510958_1576689491_1577955224_15796_5AH39LS.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_IdFo3bz_KJdwKO1.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85779",
                            "field1": "BARILLA EMILIANE",
                            "field2": "Pasta all'uovo paglia e fieno ",
                            "field3": "gr 250",
                            "field4": "",
                            "description": "BARILLA EMILIANE Pasta all'uovo paglia e fieno  gr 250",
                            "grammage": 250,
                            "price": "1.15",
                            "price_label": "€ 1,15",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 60.925779707856314,
                                "left": 26.748695003728564,
                                "width": 23.027591349738998,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/3719_EmilianePagliaeFieno250gr_1579508229.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_YcJRdYu_aSPL9PK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85772",
                            "field1": "BARILLA EMILIANE",
                            "field2": "Lasagne all'uovo",
                            "field3": "gr 500",
                            "field4": "",
                            "description": "BARILLA EMILIANE Lasagne all'uovo gr 500",
                            "grammage": 500,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 60.70206606132387,
                                "left": 50.074571215510815,
                                "width": 23.027591349738998,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/115-115_LasagneBarilla500gr_1579507734.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_H0XAoDX_uk6VB0D.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85776",
                            "field1": "BARILLA EMILIANE",
                            "field2": "Pasta all'uovo ",
                            "field3": "vari tipi",
                            "field4": "gr 250",
                            "description": "BARILLA EMILIANE Pasta all'uovo  vari tipi gr 250",
                            "grammage": 250,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Tagliatelle all'uovo",
                                "Fettuccine all'uovo"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 60.81392288459008,
                                "left": 73.65398956002983,
                                "width": 23.027591349738998,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/121-a13-Pappardelle250gr_1579507852.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/123-a13-Taglierini250gr_1579507854.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/254-a13-_BarillaFettuccine250gr_1579508187.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/3971-a13-1_Tagliatelle250_1579512220.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_wZhEdBu_t1BKXsC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "87129",
                            "field1": "MUTTI",
                            "field2": "Polpa di pomodoro",
                            "field3": "gr 400 x 3",
                            "field4": "",
                            "description": "MUTTI Polpa di pomodoro gr 400 x 3",
                            "grammage": 1200,
                            "price": "1.48",
                            "price_label": "€ 1,48",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Rossi",
                            "blueprint": {
                                "top": 78.48730096065273,
                                "left": 3.2960477255779272,
                                "width": 23.027591349738998,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Mutti_Polpa_gr_400_x_3.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_lF4uJW7_0XstL59.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "110143",
                            "field1": "MUTTI",
                            "field2": "Pomodorini ciliegini ",
                            "field3": "di collina ",
                            "field4": "gr 400",
                            "description": "MUTTI Pomodorini ciliegini  di collina  gr 400",
                            "grammage": 400,
                            "price": "0.55",
                            "price_label": "€ 0,55",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Rossi",
                            "blueprint": {
                                "top": 78.37544413738652,
                                "left": 27.002237136465325,
                                "width": 23.027591349738998,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/39096_1506433846.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_BlUHAWx_WA4P9nI.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "125355",
                            "field1": "DIVELLA",
                            "field2": "Pasta di semola formati speciali",
                            "field3": "vari tipi ",
                            "field4": "gr 500",
                            "description": "DIVELLA Pasta di semola formati speciali vari tipi  gr 500",
                            "grammage": 500,
                            "price": "0.85",
                            "price_label": "€ 0,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 77.74049217002238,
                                "left": 49.93661446681581,
                                "width": 46.52498135719612,
                                "height": 17.00223713646532
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Calamari-F.-Specialita-in-vaschetta-Divella-gr.500-8005121001464_2_1_7BVrrGD.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/divella_conchiglioni_500_gr_1505289691_1524044161.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/663-g85_divella_millerighi_1539330606.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_BPZLiKP_6jk76Wb.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 13,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_13_aI5eKOT.jpg",
                    "products": [
                        {
                            "item_id": "85809",
                            "field1": "CALVÈ",
                            "field2": "Maionese classica",
                            "field3": "ml 500",
                            "field4": "",
                            "description": "CALVÈ Maionese classica ml 500",
                            "grammage": 500,
                            "price": "1.15",
                            "price_label": "€ 1,15",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 9.507829977628635,
                                "left": 3.4116331096196824,
                                "width": 46.77852348993289,
                                "height": 34.56375838926175
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/27997_calve_classica_1553762509.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_6mTjobE_tH51s4B.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85926",
                            "field1": "SCOTTI\t",
                            "field2": "Oro per insalate classiche",
                            "field3": "kg 1",
                            "field4": "",
                            "description": "SCOTTI\t Oro per insalate classiche kg 1",
                            "grammage": 1000,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 10.51454138702461,
                                "left": 50.06338553318419,
                                "width": 23.325876211782255,
                                "height": 33.33333333333333
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/27993_Scotti_-_Oro_per_Insalate_-_astuccio_sottovuoto_da_kg.1_149259_fi6cwry.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_NBpxKgI_6aqGTJA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "186455",
                            "field1": "SCOTTI",
                            "field2": "Oro Riso Fantasia Insalate",
                            "field3": "Gran Nero",
                            "field4": "gr 800",
                            "description": "SCOTTI Oro Riso Fantasia Insalate Gran Nero gr 800",
                            "grammage": 800,
                            "price": "1.65",
                            "price_label": "€ 1,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 11.185682326621924,
                                "left": 73.76957494407158,
                                "width": 21.931394481730052,
                                "height": 15.771812080536915
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/scotti_Oro_Fantasia_di_Insalate_Gran_Nero_parboiled_10_gr._800_15602_EckFMy7.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_vzlphiC_wMucdUk.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "86201",
                            "field1": "SCOTTI\t",
                            "field2": "Riso",
                            "field3": "basmati con riso rosso gr 800",
                            "field4": "",
                            "description": "SCOTTI\t Riso basmati con riso rosso gr 800",
                            "grammage": 0,
                            "price": "1.75",
                            "price_label": "€ 1,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 27.293064876957494,
                                "left": 73.38926174496643,
                                "width": 21.931394481730052,
                                "height": 16.107382550335572
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/scotti_basmati_rosso_1561027990.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_2yKViKK_GSVLbj5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "92622",
                            "field1": "CURTIRISO",
                            "field2": "Ribe parboiled ambra",
                            "field3": "classico",
                            "field4": "kg 1",
                            "description": "CURTIRISO Ribe parboiled ambra classico kg 1",
                            "grammage": 1000,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 44.071588366890374,
                                "left": 2.651006711409392,
                                "width": 24.086502609992547,
                                "height": 16.107382550335572
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/29073_CurtirisoAmbra1kg_1554803052.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_fqoOIAs_MbM7QLl.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "197741",
                            "field1": "STAGIONI D'ITALIA",
                            "field2": "Riso carnaroli",
                            "field3": "kg 1",
                            "field4": "",
                            "description": "STAGIONI D'ITALIA Riso carnaroli kg 1",
                            "grammage": 1000,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 44.071588366890374,
                                "left": 26.483967188665172,
                                "width": 23.579418344519016,
                                "height": 16.107382550335572
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/34175_StagioniDItaliaCarnaroli1kg_1573662217.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_9FhyKQl_Ouja4B9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "103008",
                            "field1": "BARILLA",
                            "field2": "Farina tipo \"00\" ",
                            "field3": "kg 1",
                            "field4": "",
                            "description": "BARILLA Farina tipo \"00\"  kg 1",
                            "grammage": 1000,
                            "price": "0.50",
                            "price_label": "€ 0,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 44.29530201342282,
                                "left": 50.190156599552566,
                                "width": 23.579418344519016,
                                "height": 16.107382550335572
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/137-1_BarillaFarina1kg_1579507908.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_8S0rNwm_mJTS544.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "86986",
                            "field1": "DIVELLA",
                            "field2": "Semola rimacinata",
                            "field3": "kg 1",
                            "field4": "",
                            "description": "DIVELLA Semola rimacinata kg 1",
                            "grammage": 1000,
                            "price": "0.75",
                            "price_label": "€ 0,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 44.51901565995525,
                                "left": 73.26249067859806,
                                "width": 23.579418344519016,
                                "height": 16.107382550335572
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/699_divella_semola_rimacinata_1540484950.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_9UleuUy_wQi3uio.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "93340",
                            "field1": "CASILLO",
                            "field2": "Farina per pizza/dolci",
                            "field3": "kg 1",
                            "field4": "",
                            "description": "CASILLO Farina per pizza/dolci kg 1",
                            "grammage": 1000,
                            "price": "0.52",
                            "price_label": "€ 0,52",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 61.07382550335571,
                                "left": 2.662192393736018,
                                "width": 23.579418344519016,
                                "height": 16.107382550335572
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/61lwE1uO_1508864232_1583516231.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/CASILLO_FARINA_PER_PIZZA_KG.1_1574865521_1583516256.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_TydLfGP_KDAu7h4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "113933",
                            "field1": "CASILLO",
                            "field2": "Semola di grano duro ",
                            "field3": "100% pugliese ",
                            "field4": "gr 500",
                            "description": "CASILLO Semola di grano duro  100% pugliese  gr 500",
                            "grammage": 500,
                            "price": "0.45",
                            "price_label": "€ 0,45",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 60.96196868008949,
                                "left": 26.62192393736018,
                                "width": 23.579418344519016,
                                "height": 16.107382550335572
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/casillo_semola_rimacinata_pugliese_1513331357.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_jjc33gp_A92ZmGx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "88305",
                            "field1": "DESANTIS",
                            "field2": "San Giovanni olio extra vergine di oliva",
                            "field3": "lt 1",
                            "field4": "",
                            "description": "DESANTIS San Giovanni olio extra vergine di oliva lt 1",
                            "grammage": 1000,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Olio",
                            "blueprint": {
                                "top": 60.96196868008949,
                                "left": 49.94780014914243,
                                "width": 23.579418344519016,
                                "height": 16.107382550335572
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/356_1530268148.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_s2mGhtM_W01mk6A.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "90835",
                            "field1": "DESANTIS",
                            "field2": "Friggidor olio",
                            "field3": "lt 1",
                            "field4": "",
                            "description": "DESANTIS Friggidor olio lt 1",
                            "grammage": 1000,
                            "price": "1.19",
                            "price_label": "€ 1,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Olio",
                            "blueprint": {
                                "top": 60.96196868008949,
                                "left": 73.40044742729306,
                                "width": 23.579418344519016,
                                "height": 16.107382550335572
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/358_1530268293.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_dtqfeYH_rlN6onF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "113937",
                            "field1": "ACETUM",
                            "field2": "Aceto balsamico di Modena I.G.P. ",
                            "field3": "1 foglia graspa verde",
                            "field4": "ml 500",
                            "description": "ACETUM Aceto balsamico di Modena I.G.P.  1 foglia graspa verde ml 500",
                            "grammage": 500,
                            "price": "1.09",
                            "price_label": "€ 1,09",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 78.97091722595077,
                                "left": 3.042505592841163,
                                "width": 23.579418344519016,
                                "height": 16.107382550335572
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/54313_1510166462.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_Y8fqj50_0GK1uIw.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "87093",
                            "field1": "ACETUM BLAZE ",
                            "field2": "Glassa all' aceto balsamico",
                            "field3": "gusto classico",
                            "field4": "ml 215",
                            "description": "ACETUM BLAZE  Glassa all' aceto balsamico gusto classico ml 215",
                            "grammage": 215,
                            "price": "1.05",
                            "price_label": "€ 1,05",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 78.85906040268455,
                                "left": 26.495152870991795,
                                "width": 23.579418344519016,
                                "height": 16.107382550335572
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/48917-bgc_1530277607.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_VJM4UnZ_PMuqnLM.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "87107",
                            "field1": "CALVÈ",
                            "field2": "Top down",
                            "field3": "ketchup",
                            "field4": "ml 400",
                            "description": "CALVÈ Top down ketchup ml 400",
                            "grammage": 400,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 78.41163310961967,
                                "left": 49.94780014914243,
                                "width": 23.579418344519016,
                                "height": 16.107382550335572
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/ketchup_400ml_1523614936.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_Z04AW1n_aNc7J6B.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "103505",
                            "field1": "OROPAN\t",
                            "field2": "Le friselle medie di grano duro/",
                            "field3": "integrali/giganti",
                            "field4": "gr 350",
                            "description": "OROPAN\t Le friselle medie di grano duro/ integrali/giganti gr 350",
                            "grammage": 350,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 77.85234899328857,
                                "left": 73.40044742729306,
                                "width": 23.579418344519016,
                                "height": 16.890380313199106
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/le_friselle_integrali_1498492419.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_AVZNACG_BDjQI3D.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 14,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_14_fCLd0Rw.jpg",
                    "products": [
                        {
                            "item_id": "165095",
                            "field1": "SELECT",
                            "field2": "Ceci messicani/",
                            "field3": "fagioli vari tipi lessati",
                            "field4": "gr 360",
                            "description": "SELECT Ceci messicani/ fagioli vari tipi lessati gr 360",
                            "grammage": 360,
                            "price": "0.49",
                            "price_label": "€ 0,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Fagioli Borlotti",
                                "Fagioli Cannellini",
                                "Ceci Messicani"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 9.619686800894854,
                                "left": 3.5384041759880644,
                                "width": 46.77852348993289,
                                "height": 34.340044742729305
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Select_Fagioli_Borlotti_1521644296_1541170884.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Select_Fagioli_Cannellini_1521644296_1541170884.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_0YCAjmz_EnQY9MQ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "110054",
                            "field1": "MARE APERTO",
                            "field2": "Tonno all'olio di oliva ",
                            "field3": "gr 80 x 8 lattine",
                            "field4": "",
                            "description": "MARE APERTO Tonno all'olio di oliva  gr 80 x 8 lattine",
                            "grammage": 640,
                            "price": "4.19",
                            "price_label": "€ 4,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 10.961968680089484,
                                "left": 50.443698732289334,
                                "width": 45.257270693512304,
                                "height": 15.995525727069351
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/mare_aperto_tonno_olio_oliva_g._80_x_8_1503931904_1506332972.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_WeUXBZX_Lm8tvgR.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "112791",
                            "field1": "CASA RIMINI",
                            "field2": "Piadina sfogliata gr 360",
                            "field3": "",
                            "field4": "",
                            "description": "CASA RIMINI Piadina sfogliata gr 360",
                            "grammage": 360,
                            "price": "0.55",
                            "price_label": "€ 0,55",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 27.516778523489933,
                                "left": 50.57046979865771,
                                "width": 22.94556301267711,
                                "height": 15.995525727069351
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/53674_1509004731.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_hgJbUcD_04gIDFp.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "92619",
                            "field1": "C.R.M.",
                            "field2": "Sfogliata",
                            "field3": "all'olio extravergine d'oliva",
                            "field4": "gr 300",
                            "description": "C.R.M. Sfogliata all'olio extravergine d'oliva gr 300",
                            "grammage": 300,
                            "price": "0.85",
                            "price_label": "€ 0,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 27.852348993288594,
                                "left": 74.02311707680835,
                                "width": 22.311707680835198,
                                "height": 15.995525727069351
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/CRM_Piada_Sfogliata_300_g_1427186963_1495545943.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_GYzzcgS_7eFX206.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "93449",
                            "field1": "D'AMICO",
                            "field2": "Filetti di melanzane alla napoletana ",
                            "field3": "in olio extravergine di oliva",
                            "field4": "gr 280",
                            "description": "D'AMICO Filetti di melanzane alla napoletana  in olio extravergine di oliva gr 280",
                            "grammage": 280,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 44.407158836689035,
                                "left": 3.284862043251301,
                                "width": 23.452647278150636,
                                "height": 15.995525727069351
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/10626_damico_melanzana_alla_napoletana_1496853926.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_7FJwHQ0_4eylvd4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "93816",
                            "field1": "ROBERTO",
                            "field2": "Essenza pane tramezzino ",
                            "field3": "classico/integrale ",
                            "field4": "gr 250",
                            "description": "ROBERTO Essenza pane tramezzino  classico/integrale  gr 250",
                            "grammage": 250,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Tramezzino",
                                "Tramezzino Integrale"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 44.29530201342282,
                                "left": 26.864280387770318,
                                "width": 22.94556301267711,
                                "height": 15.995525727069351
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/24458_roberto_tramezzino_250_g_1496737503.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/41082_1517421653.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_HBfy0ge_u9IVjok.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "103552",
                            "field1": "ALISA",
                            "field2": "Olive nere intere gr 500/ ",
                            "field3": "denocciolate gr 340",
                            "field4": "",
                            "description": "ALISA Olive nere intere gr 500/  denocciolate gr 340",
                            "grammage": null,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 61.18568232662192,
                                "left": 3.284862043251301,
                                "width": 23.325876211782255,
                                "height": 16.107382550335572
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/alisa_olive_nere_intere_1498500062.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/54592_1557410164.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_ClV11js_yPOiJAk.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "207460",
                            "field1": "D'AMICO",
                            "field2": "Carciofette lessate",
                            "field3": "",
                            "field4": "latta gr 380",
                            "description": "D'AMICO Carciofette lessate latta gr 380",
                            "grammage": 380,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 61.297539149888145,
                                "left": 26.610738255033553,
                                "width": 23.325876211782255,
                                "height": 16.107382550335572
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/8005695002454_AmicoCarciofette_1583505611.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_CLxobkr_6UbFwDb.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "89390",
                            "field1": "RIO MARE",
                            "field2": "Tonno al naturale ",
                            "field3": "gr 80 x 3 lattine + 1 gratis",
                            "field4": "",
                            "description": "RIO MARE Tonno al naturale  gr 80 x 3 lattine + 1 gratis",
                            "grammage": 320,
                            "price": "2.65",
                            "price_label": "€ 2,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 44.183445190156604,
                                "left": 50.31692766592094,
                                "width": 46.52498135719612,
                                "height": 32.774049217002236
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Rio_Mare_tonno_al_naturale_4_x_80_gr_1441291984_1474290220_1489229017.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_UBkKFKP_JZ5RuwK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "88342",
                            "field1": "D'AMICO",
                            "field2": "Capperi",
                            "field3": "gr 103",
                            "field4": "",
                            "description": "D'AMICO Capperi gr 103",
                            "grammage": 103,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 77.40492170022371,
                                "left": 3.2960477255779272,
                                "width": 23.325876211782255,
                                "height": 17.225950782997764
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/9521_1492196759.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_nyqs7de_I6JsF4W.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "92192",
                            "field1": "PONTI\t",
                            "field2": "Giardiniera all'aceto di vino",
                            "field3": "gr 290",
                            "field4": "",
                            "description": "PONTI\t Giardiniera all'aceto di vino gr 290",
                            "grammage": 290,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 77.51677852348993,
                                "left": 26.748695003728564,
                                "width": 23.325876211782255,
                                "height": 17.225950782997764
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/58776_ponti_giardiniera_1495114993.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_Ei3QpVA_XseaqhK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "107866",
                            "field1": "PONTI",
                            "field2": "Antipasto di verdure ",
                            "field3": "gr 280",
                            "field4": "",
                            "description": "PONTI Antipasto di verdure  gr 280",
                            "grammage": 280,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 77.62863534675614,
                                "left": 50.20134228187919,
                                "width": 23.325876211782255,
                                "height": 17.225950782997764
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/1379_1503677191_1509119398.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_CVl2qt9_Y3hpGgs.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "106411",
                            "field1": "PONTI",
                            "field2": "Carciofini interi in olio di semi ",
                            "field3": "gr 190",
                            "field4": "",
                            "description": "PONTI Carciofini interi in olio di semi  gr 190",
                            "grammage": 190,
                            "price": "2.05",
                            "price_label": "€ 2,05",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 77.74049217002235,
                                "left": 73.52721849366145,
                                "width": 23.325876211782255,
                                "height": 17.225950782997764
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/34694_1501658626.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_Ron0Ux0_WhR8DxO.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 15,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_15_wAjVbzE.jpg",
                    "products": [
                        {
                            "item_id": "115331",
                            "field1": "TESORI D'APULIA",
                            "field2": "Tarallini ai semi di finocchio/",
                            "field3": "classici all'olio extravergine di oliva/al peperoncino",
                            "field4": "gr 200",
                            "description": "TESORI D'APULIA Tarallini ai semi di finocchio/ classici all'olio extravergine di oliva/al peperoncino gr 200",
                            "grammage": 200,
                            "price": "0.49",
                            "price_label": "€ 0,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Semi di Finocchio",
                                "Classici",
                                "Peperoncino"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 9.843400447427268,
                                "left": 3.5495898583146905,
                                "width": 46.14466815809098,
                                "height": 34.00447427293064
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/51548_tesori_1536239404.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/51549_tesori_1536239404.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/51550_tesori_1536239405.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_aRKJuue_QjqSDL4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85745",
                            "field1": "BARILLA ",
                            "field2": "Pan carrè 16 fette ",
                            "field3": "gr 285",
                            "field4": "",
                            "description": "BARILLA  Pan carrè 16 fette  gr 285",
                            "grammage": 285,
                            "price": "0.45",
                            "price_label": "€ 0,45",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 10.85011185682324,
                                "left": 50.454884414615954,
                                "width": 23.19910514541387,
                                "height": 15.883668903803132
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/15071_pancarre_1539680420.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_GAOVK0t_rkqHESf.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "88986",
                            "field1": "BARILLA",
                            "field2": "Pan bauletto bianco",
                            "field3": "gr 400",
                            "field4": "",
                            "description": "BARILLA Pan bauletto bianco gr 400",
                            "grammage": 400,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 10.85011185682324,
                                "left": 73.52721849366145,
                                "width": 23.19910514541387,
                                "height": 15.883668903803132
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/15095-1009439-BP1-1010705_MulinoPanBauletto_1579513115.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_7O1QzTD_3OCGg6i.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85766",
                            "field1": "BARILLA",
                            "field2": "Grissini torinesi ",
                            "field3": "gr 280",
                            "field4": "",
                            "description": "BARILLA Grissini torinesi  gr 280",
                            "grammage": 280,
                            "price": "0.90",
                            "price_label": "€ 0,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 27.06935123042503,
                                "left": 50.20134228187919,
                                "width": 23.19910514541387,
                                "height": 16.666666666666664
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/11463_mulino_torinesi_1543343168.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_ZtBipND_S8ZyVpt.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85762",
                            "field1": "BARILLA",
                            "field2": "Granetti classici ",
                            "field3": "dorati",
                            "field4": "gr 280",
                            "description": "BARILLA Granetti classici  dorati gr 280",
                            "grammage": 280,
                            "price": "0.85",
                            "price_label": "€ 0,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 26.957494407158812,
                                "left": 73.65398956002983,
                                "width": 23.19910514541387,
                                "height": 16.666666666666664
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/12700-wm3_GranettiClassici_1579512929.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_pUwk6OK_aApVO0v.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "94061",
                            "field1": "EUROCOMPANY",
                            "field2": "Mais tostato e salato",
                            "field3": "gr 250",
                            "field4": "",
                            "description": "EUROCOMPANY Mais tostato e salato gr 250",
                            "grammage": 250,
                            "price": "0.55",
                            "price_label": "€ 0,55",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 44.407158836689014,
                                "left": 3.2960477255779272,
                                "width": 23.19910514541387,
                                "height": 15.995525727069351
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/36699_1506013408.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_t7oQ8nn_4mx2anQ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "130002",
                            "field1": "ROBERTO",
                            "field2": "Panfiocco",
                            "field3": "classico/integrale ",
                            "field4": "gr 400",
                            "description": "ROBERTO Panfiocco classico/integrale  gr 400",
                            "grammage": 400,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classico",
                                "Integrale"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 44.183445190156576,
                                "left": 26.62192393736018,
                                "width": 23.19910514541387,
                                "height": 15.995525727069351
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/0068568_ROBERTO_PANFIOCCO_400G_1527239111.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_uqQyrla_PDyrKpz.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "87216",
                            "field1": "PAI",
                            "field2": "Le patatine",
                            "field3": "",
                            "field4": "gr 500 ",
                            "description": "PAI Le patatine gr 500 ",
                            "grammage": 500,
                            "price": "1.45",
                            "price_label": "€ 1,45",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 44.183445190156576,
                                "left": 50.20134228187919,
                                "width": 23.19910514541387,
                                "height": 15.995525727069351
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/344017_PAI_CHIPS_TRASPARENTI_GR.500_1492538760_1512127240.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_jt1365o_1NDM7PM.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "92253",
                            "field1": "SAIWA CIPSTER",
                            "field2": "Freeky fries ",
                            "field3": "gr 25 x 5 buste",
                            "field4": "",
                            "description": "SAIWA CIPSTER Freeky fries  gr 25 x 5 buste",
                            "grammage": 125,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 44.183445190156576,
                                "left": 73.65398956002983,
                                "width": 23.19910514541387,
                                "height": 15.995525727069351
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/12684_1503300362.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_EGOWy5W_os7SWJx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85755",
                            "field1": "PAVESI",
                            "field2": "Cracker mais ",
                            "field3": "gr 280",
                            "field4": "",
                            "description": "PAVESI Cracker mais  gr 280",
                            "grammage": 280,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 61.1856823266219,
                                "left": 3.2960477255779272,
                                "width": 23.19910514541387,
                                "height": 15.995525727069351
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/49117_PavesiCrackerMais280gr_1580830707.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_oeguZXZ_j1zQluo.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85755",
                            "field1": "PAVESI",
                            "field2": "cracker",
                            "field3": "",
                            "field4": "pomodoro/rosmarino gr 280",
                            "description": "PAVESI cracker pomodoro/rosmarino gr 280",
                            "grammage": 280,
                            "price": "1.09",
                            "price_label": "€ 1,09",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Pomodoro",
                                "Rosmarino"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 61.297539149888124,
                                "left": 27.002237136465325,
                                "width": 23.19910514541387,
                                "height": 15.995525727069351
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/GP_cracker_olive_280g_sx_1580830822.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/GP_cracker_pomodoro_280g_sx_1580830823.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_TJJqr2f_NVSBUwJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "92626",
                            "field1": "SALATI PREZIOSI",
                            "field2": "",
                            "field3": "grigliata gr 180",
                            "field4": "",
                            "description": "SALATI PREZIOSI grigliata gr 180",
                            "grammage": 180,
                            "price": "0.75",
                            "price_label": "€ 0,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 61.297539149888124,
                                "left": 50.074571215510815,
                                "width": 23.19910514541387,
                                "height": 15.995525727069351
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/53613_1511366054.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_sSNGDCi_GMovONd.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "87205",
                            "field1": "PRINGLES",
                            "field2": "Patatine",
                            "field3": "classica/paprika",
                            "field4": "gr 165",
                            "description": "PRINGLES Patatine classica/paprika gr 165",
                            "grammage": 165,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classica",
                                "Paprika"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 61.297539149888124,
                                "left": 73.52721849366145,
                                "width": 23.19910514541387,
                                "height": 15.995525727069351
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/53505_1502292753.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/53506_1502292753.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_2vNlblE_5B8p0Bo.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "104835",
                            "field1": "BARILLA",
                            "field2": "Cracker integrali ",
                            "field3": "gr 500",
                            "field4": "",
                            "description": "BARILLA Cracker integrali  gr 500",
                            "grammage": 500,
                            "price": "1.22",
                            "price_label": "€ 1,22",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 77.62863534675613,
                                "left": 3.5495898583146905,
                                "width": 23.19910514541387,
                                "height": 16.666666666666664
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Cracker_integrali_sx_1556277968_1556301058_1556892793_1561555846_2_1_5cDFlfm.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_cTIEhm9_ZgcpC31.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85934",
                            "field1": "FONZIES\t",
                            "field2": "gr 100",
                            "field3": "",
                            "field4": "",
                            "description": "FONZIES\t gr 100",
                            "grammage": 100,
                            "price": "0.85",
                            "price_label": "€ 0,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 77.74049217002235,
                                "left": 26.748695003728564,
                                "width": 23.19910514541387,
                                "height": 16.666666666666664
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/fonzies_original_1446720518_1489074809.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_288eI1E_FDEg2ZS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "109564",
                            "field1": "SAIWA RITZ",
                            "field2": "Mini ",
                            "field3": "6 bustine",
                            "field4": "",
                            "description": "SAIWA RITZ Mini  6 bustine",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 77.74049217002235,
                                "left": 50.074571215510815,
                                "width": 23.19910514541387,
                                "height": 16.666666666666664
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/1295_Ritz6Buste_1553191276.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_LftFqfk_dkGggWl.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "92625",
                            "field1": "LAY'S",
                            "field2": "classica gr 145/ campagnola gr 133/ ",
                            "field3": "extra bbq gr 110/ bacon gr 133/ paprika gr 133",
                            "field4": "",
                            "description": "LAY'S classica gr 145/ campagnola gr 133/  extra bbq gr 110/ bacon gr 133/ paprika gr 133",
                            "grammage": 0,
                            "price": "0.65",
                            "price_label": "€ 0,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classica",
                                "Campagnola",
                                "Extra BBQ",
                                "Bacon ",
                                "Paprika"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 77.85234899328856,
                                "left": 73.52721849366145,
                                "width": 23.19910514541387,
                                "height": 16.666666666666664
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Lays_Campagnola_1474034930_1495547262.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Lays_Classiche_1474034941_1495547263.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_h7WiB5z_oMYdUEw.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 16,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_16_b9NOJCN.jpg",
                    "products": [
                        {
                            "item_id": "104830",
                            "field1": "BARILLA",
                            "field2": "Fette biscottate ",
                            "field3": "dorate",
                            "field4": "gr 630 x 2",
                            "description": "BARILLA Fette biscottate  dorate gr 630 x 2",
                            "grammage": 1260,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 10.067114093959695,
                                "left": 3.5495898583146905,
                                "width": 23.19910514541387,
                                "height": 33.44519015659955
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/mulino_bianco_fette_biscottate_dorate_formato_convenienza_1562250654_LMqzekA.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_ngmRs2R_HTu9MW7.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "104830",
                            "field1": "MULINO BIANCO",
                            "field2": "Fette biscottate ",
                            "field3": "Integrali ",
                            "field4": "gr 630 x 2",
                            "description": "MULINO BIANCO Fette biscottate  Integrali  gr 630 x 2",
                            "grammage": 1260,
                            "price": "2.59",
                            "price_label": "€ 2,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 10.178970917225914,
                                "left": 26.495152870991795,
                                "width": 23.19910514541387,
                                "height": 33.44519015659955
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/mulino_bianco_fette_biscottate_integrali_formato_convenienza_1562250_SheFN3u.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_6lZjDOj_H0LgL1k.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85751",
                            "field1": "BARILLA",
                            "field2": "Fette biscottate",
                            "field3": "dorate",
                            "field4": "gr 315",
                            "description": "BARILLA Fette biscottate dorate gr 315",
                            "grammage": 315,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 10.85011185682323,
                                "left": 50.20134228187919,
                                "width": 23.07233407904549,
                                "height": 16.219239373601788
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Fette_dorate_36_sx_1562581600_1566310342.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_FIdxG4e_ZwgzrVz.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "195802",
                            "field1": "BOSCHETTI",
                            "field2": "Confettura 70% frutta",
                            "field3": "vari gusti",
                            "field4": "gr 330",
                            "description": "BOSCHETTI Confettura 70% frutta vari gusti gr 330",
                            "grammage": 330,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Fragole",
                                "Pesche"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 10.73825503355701,
                                "left": 73.65398956002983,
                                "width": 22.94556301267711,
                                "height": 15.883668903803132
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/60906-5BC_BoschettiFragola330_1572019190.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/60904-5BC_BoschettiAlbicocca330_1572019191.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/60905-5BC_BoshcettiPesche330_1572019191.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_tCD7xnZ_kXhoiIF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "132544",
                            "field1": "KELLOGG'S",
                            "field2": "Corn flakes",
                            "field3": "gr 375",
                            "field4": "",
                            "description": "KELLOGG'S Corn flakes gr 375",
                            "grammage": 375,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 27.293064876957455,
                                "left": 50.32811334824758,
                                "width": 22.94556301267711,
                                "height": 16.219239373601788
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/57871_kelloggs_1533217517.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_80zZ3z9_oHeDUTT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "130731",
                            "field1": "KELLOGG'S ",
                            "field2": "Special k gr 375",
                            "field3": "+ gr 125 omaggio",
                            "field4": "",
                            "description": "KELLOGG'S  Special k gr 375 + gr 125 omaggio",
                            "grammage": 500,
                            "price": "2.19",
                            "price_label": "€ 2,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 27.516778523489897,
                                "left": 73.40044742729306,
                                "width": 22.94556301267711,
                                "height": 16.219239373601788
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/46071_1530269566.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_HbvKzom_N8usbvc.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "91046",
                            "field1": "GRANAROLO\t",
                            "field2": "Latte crescita 3 ",
                            "field3": "alta qualità UHT ",
                            "field4": "ml 500 x 2",
                            "description": "GRANAROLO\t Latte crescita 3  alta qualità UHT  ml 500 x 2",
                            "grammage": 1000,
                            "price": "1.19",
                            "price_label": "€ 1,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 44.18344519015656,
                                "left": 3.5495898583146905,
                                "width": 22.94556301267711,
                                "height": 16.219239373601788
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/33947_latte_crescita_3_1494596171.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_lji4nyw_PicP72Y.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "189039",
                            "field1": "POLENGHI",
                            "field2": "Latte UHT ",
                            "field3": "parzialmente scremato ",
                            "field4": "lt 1 x 4",
                            "description": "POLENGHI Latte UHT  parzialmente scremato  lt 1 x 4",
                            "grammage": 4000,
                            "price": "2.20",
                            "price_label": "€ 2,20",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 44.407158836689,
                                "left": 27.12900820283371,
                                "width": 22.94556301267711,
                                "height": 16.219239373601788
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/polenghi_latte_ps_uht_lt.1x4_1550231422_1567589184.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/POLENGHI_singola_1568039054.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_u40o109_WVvNexv.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "89265",
                            "field1": "GRANAROLO",
                            "field2": "Bevanda di riso UHT",
                            "field3": "lt 1",
                            "field4": "",
                            "description": "GRANAROLO Bevanda di riso UHT lt 1",
                            "grammage": 1000,
                            "price": "1.19",
                            "price_label": "€ 1,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 44.18344519015656,
                                "left": 50.32811334824758,
                                "width": 22.94556301267711,
                                "height": 16.219239373601788
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/44694_GranaroloBevandeSoia1lt_1553599231.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_HZVv8qY_3Hvs1vL.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "94071",
                            "field1": "GRANAROLO ACCADì",
                            "field2": "Latte UHT parzialmente ",
                            "field3": "scremato/scremato 0,1%/intero ",
                            "field4": "lt 1",
                            "description": "GRANAROLO ACCADì Latte UHT parzialmente  scremato/scremato 0,1%/intero  lt 1",
                            "grammage": 1000,
                            "price": "1.05",
                            "price_label": "€ 1,05",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Parzialmente Scremato",
                                "Scremato 0.1%",
                                "Intero"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 44.18344519015656,
                                "left": 73.7807606263982,
                                "width": 22.94556301267711,
                                "height": 16.219239373601788
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/21544-095_1540995316.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/26761-095_1540995317.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/33946-095_1540995317.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_ZybHbjd_tGbKR4c.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "106337",
                            "field1": "STERILGARDA",
                            "field2": "Latte UHT ",
                            "field3": "scremato microfiltrato",
                            "field4": "lt 1",
                            "description": "STERILGARDA Latte UHT  scremato microfiltrato lt 1",
                            "grammage": 1000,
                            "price": "0.70",
                            "price_label": "€ 0,70",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 60.62639821029079,
                                "left": 3.2960477255779272,
                                "width": 22.94556301267711,
                                "height": 16.219239373601788
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Sterilgarda_latte_scremato_microfiltrato_1_lt.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_vcFsYHe_ovxzLl5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "89514",
                            "field1": "PARMALAT CHEF",
                            "field2": "Panna da cucina",
                            "field3": "classica/light",
                            "field4": "ml 65 ",
                            "description": "PARMALAT CHEF Panna da cucina classica/light ml 65 ",
                            "grammage": 65,
                            "price": "0.39",
                            "price_label": "€ 0,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classica",
                                "Light"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 61.185682326621894,
                                "left": 26.748695003728564,
                                "width": 22.94556301267711,
                                "height": 16.219239373601788
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/49449_1493221598.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_AvJK05G_CIJwWbN.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "87391",
                            "field1": "PARMALAT CHEF",
                            "field2": "Crema pasticcera/",
                            "field3": "cioccolato",
                            "field4": "gr 530",
                            "description": "PARMALAT CHEF Crema pasticcera/ cioccolato gr 530",
                            "grammage": 530,
                            "price": "1.09",
                            "price_label": "€ 1,09",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Crema Pasticcera",
                                "Crema Cioccolato"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 60.73825503355701,
                                "left": 50.32811334824758,
                                "width": 22.94556301267711,
                                "height": 16.219239373601788
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Chef_parmalat_crema_pasticciera_1453123982.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Parmalt_chef_crema_al_cioccolato_1453123988.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_y4zxxTA_kKbb4F6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "180264",
                            "field1": "GRANAROLO",
                            "field2": "Latte UHT alta qualità ",
                            "field3": "intero/parzialmente scremato",
                            "field4": "lt 1",
                            "description": "GRANAROLO Latte UHT alta qualità  intero/parzialmente scremato lt 1",
                            "grammage": 1000,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Intero",
                                "Parzialmente Scremato"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 60.96196868008945,
                                "left": 73.40044742729306,
                                "width": 22.94556301267711,
                                "height": 16.219239373601788
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/principale_8002670169621_1558447911.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/principale_8002670169607_1558447912.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_4fLaJNE_HcfwuUW.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "88629",
                            "field1": "GRANAROLO",
                            "field2": "Besciamella",
                            "field3": "ml 200 ",
                            "field4": "",
                            "description": "GRANAROLO Besciamella ml 200 ",
                            "grammage": 200,
                            "price": "0.65",
                            "price_label": "€ 0,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 77.74049217002234,
                                "left": 3.169276659209545,
                                "width": 22.94556301267711,
                                "height": 16.778523489932883
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/GRA_Besciamella_UHT_200ml_2018_1540283856.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_HgnFJ5o_y5LfQKu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "88634",
                            "field1": "GRANAROLO",
                            "field2": "Panna da cucina uht",
                            "field3": "ml 200",
                            "field4": "",
                            "description": "GRANAROLO Panna da cucina uht ml 200",
                            "grammage": 200,
                            "price": "0.65",
                            "price_label": "€ 0,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 77.40492170022368,
                                "left": 26.748695003728564,
                                "width": 22.94556301267711,
                                "height": 16.778523489932883
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/15516_granarolo_panna_da_cucina_1494495132.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_Hxii1Rp_izBoImr.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "110061",
                            "field1": "HALTA",
                            "field2": "Panna vegetale ",
                            "field3": "spray ",
                            "field4": "ml 250",
                            "description": "HALTA Panna vegetale  spray  ml 250",
                            "grammage": 250,
                            "price": "1.05",
                            "price_label": "€ 1,05",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 77.96420581655477,
                                "left": 49.94780014914243,
                                "width": 22.94556301267711,
                                "height": 16.778523489932883
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/42178_halta_spray_1569942250.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_jWMdylj_k5N22Eo.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "87401",
                            "field1": "GRANAROLO",
                            "field2": "Panna UHT spray",
                            "field3": "per dolci",
                            "field4": "ml 250",
                            "description": "GRANAROLO Panna UHT spray per dolci ml 250",
                            "grammage": 250,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 77.51677852348989,
                                "left": 73.65398956002983,
                                "width": 22.94556301267711,
                                "height": 16.778523489932883
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/15515_1490950807.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_wt2NIvf_0kKyAZp.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 17,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_17_GzHptYR.jpg",
                    "products": [
                        {
                            "item_id": "95184",
                            "field1": "BARILLA",
                            "field2": "Trancino",
                            "field3": "gr 396",
                            "field4": "",
                            "description": "BARILLA Trancino gr 396",
                            "grammage": 396,
                            "price": "1.10",
                            "price_label": "€ 1,10",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 9.731543624161024,
                                "left": 3.4228187919463093,
                                "width": 46.017897091722595,
                                "height": 34.00447427293064
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/37102-1027227-1027228-ttb_MulinoBiancoTrancino396gr_1580826108.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_xh5LWFK_bVgTSYT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "120295",
                            "field1": "CRICH",
                            "field2": "Biscotti",
                            "field3": "grand roll/costarica al cacao/zuccherini",
                            "field4": "kg 1",
                            "description": "CRICH Biscotti grand roll/costarica al cacao/zuccherini kg 1",
                            "grammage": 1000,
                            "price": "1.25",
                            "price_label": "€ 1,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Biscotti Grand Roll",
                                "Costarica al Cacao",
                                "Zuccherini"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 10.850111856823265,
                                "left": 50.190156599552566,
                                "width": 23.07233407904549,
                                "height": 32.774049217002236
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/crich_biscotti_costarica_cacao_1_kg_1428059037_1518082814.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_mR4QZaS_WZabq4J.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "94728",
                            "field1": "BAULI",
                            "field2": "Croissant",
                            "field3": "vari gusti",
                            "field4": "200/240 gr",
                            "description": "BAULI Croissant vari gusti 200/240 gr",
                            "grammage": 0,
                            "price": "1.10",
                            "price_label": "€ 1,10",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 10.850111856823265,
                                "left": 73.51603281133482,
                                "width": 23.07233407904549,
                                "height": 32.774049217002236
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Croissant_Classico_6pz_H_1580401972_1581352333.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_RbSVMT7_0VYBwOD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "107113",
                            "field1": "BARILLA",
                            "field2": "Cornetti farciti cioccolato/crema/albicocca",
                            "field3": "gr 300",
                            "field4": "",
                            "description": "BARILLA Cornetti farciti cioccolato/crema/albicocca gr 300",
                            "grammage": 300,
                            "price": "1.55",
                            "price_label": "€ 1,55",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Cioiccolato",
                                "Crema",
                                "Albicocca"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 44.407158836689035,
                                "left": 3.4116331096196824,
                                "width": 23.07233407904549,
                                "height": 32.774049217002236
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Mulino_Bianco_Cornetti_albicocca_6pz_1524035779_1530024295_153087129_3Dihrgp.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Mulino_Bianco_Cornetti_cioccolato_6pz_1524035781_1530024296_15308712_7Y14qph.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_lRKh21C_IKe4QyT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "87200",
                            "field1": "BARILLA",
                            "field2": "Crostatina",
                            "field3": "cacao/albicocca",
                            "field4": "gr 400",
                            "description": "BARILLA Crostatina cacao/albicocca gr 400",
                            "grammage": 400,
                            "price": "1.55",
                            "price_label": "€ 1,55",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Cacao",
                                "Albicocca"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 44.51901565995525,
                                "left": 26.610738255033553,
                                "width": 23.07233407904549,
                                "height": 32.774049217002236
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Crostatina_albicocca_10pz_sx_1524587520_1525452086_1526026806_152638_H6td48n.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Crostatina_cacao_10pz_sx_1524587517_1525452088_1526026808_1526380148_XzXx8jL.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_vbIajVI_P716cPk.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "206402",
                            "field1": "BARILLA",
                            "field2": "Plumcake",
                            "field3": "bipacco",
                            "field4": "gr 660",
                            "description": "BARILLA Plumcake bipacco gr 660",
                            "grammage": 660,
                            "price": "2.35",
                            "price_label": "€ 2,35",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 44.29530201342282,
                                "left": 50.57046979865771,
                                "width": 46.27143922445936,
                                "height": 32.774049217002236
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Mulino_Bianco_Plumcake_pz_20_1541498699_1541693181_1573834942_1582125713.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_k5EBcv5_Cu7FzsX.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "92244",
                            "field1": "BARILLA\t",
                            "field2": "Nastrine ",
                            "field3": "gr 240",
                            "field4": "",
                            "description": "BARILLA\t Nastrine  gr 240",
                            "grammage": 240,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 77.62863534675614,
                                "left": 3.4116331096196824,
                                "width": 23.19910514541387,
                                "height": 16.890380313199106
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/15197_nastrine_1539685045.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_iwV3KSu_Rqg4yZK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "105237",
                            "field1": "BARILLA\t",
                            "field2": "6 Cornetti di vera sfoglia",
                            "field3": "gr 240",
                            "field4": "",
                            "description": "BARILLA\t 6 Cornetti di vera sfoglia gr 240",
                            "grammage": 240,
                            "price": "1.35",
                            "price_label": "€ 1,35",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 77.51677852348992,
                                "left": 26.864280387770318,
                                "width": 23.19910514541387,
                                "height": 16.890380313199106
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Mulino_Bianco_6_Cornetti_classici_1538127393_1541440265.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_ERBQ7Wh_iQw4j9t.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "92246",
                            "field1": "BARILLA\t",
                            "field2": "Pane + cioccolato",
                            "field3": "gr 300",
                            "field4": "",
                            "description": "BARILLA\t Pane + cioccolato gr 300",
                            "grammage": 300,
                            "price": "1.65",
                            "price_label": "€ 1,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 77.85234899328857,
                                "left": 49.93661446681581,
                                "width": 23.19910514541387,
                                "height": 16.890380313199106
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/46713-1032607-1038476-1032179_1579541569.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_TDUn1KK_KbHt6Uc.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "89409",
                            "field1": "BARILLA",
                            "field2": "Cornetti integrali",
                            "field3": "gr 240",
                            "field4": "",
                            "description": "BARILLA Cornetti integrali gr 240",
                            "grammage": 240,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 77.74049217002235,
                                "left": 73.13571961222968,
                                "width": 23.19910514541387,
                                "height": 16.890380313199106
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/39446_mulino_bianco_cornetti_1540458682.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_9V85iIx_mW1rYzF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 18,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_18_q83Sh0U.jpg",
                    "products": [
                        {
                            "item_id": "89393",
                            "field1": "BARILLA",
                            "field2": "Biscotti",
                            "field3": "vari gusti",
                            "field4": "gr 700/800",
                            "description": "BARILLA Biscotti vari gusti gr 700/800",
                            "grammage": 0,
                            "price": "1.85",
                            "price_label": "€ 1,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 10.59020923805764,
                                "left": 3.307233407904546,
                                "width": 23.281133482475763,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Macine_800g_sx_1506669719.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/46254-221-q1a-a02MulinoBiancoGalletti700_1551376169.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_vNTEEvO_6noKuQ5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "124514",
                            "field1": "BARILLA",
                            "field2": "Nascondini",
                            "field3": "gr 600",
                            "field4": "",
                            "description": "BARILLA Nascondini gr 600",
                            "grammage": 600,
                            "price": "2.29",
                            "price_label": "€ 2,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 10.478352414791422,
                                "left": 26.75988068605518,
                                "width": 23.281133482475763,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Nascondini_600g_sx_1510158729.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_Q5NLgOY_1FyJyKr.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "89393",
                            "field1": "BARILLA",
                            "field2": "Biscotti",
                            "field3": "molinetti gr 800/primizie gr 700",
                            "field4": "",
                            "description": "BARILLA Biscotti molinetti gr 800/primizie gr 700",
                            "grammage": 0,
                            "price": "2.05",
                            "price_label": "€ 2,05",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 27.25687590472431,
                                "left": 3.307233407904546,
                                "width": 23.281133482475763,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/10268_MulinoMolinetti_1579512850.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_PcdEnQ1_PFc3gZA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "94722",
                            "field1": "BARILLA\t",
                            "field2": "Macine/tarallucci/",
                            "field3": "galletti/campagnole ",
                            "field4": "kg 1",
                            "description": "BARILLA\t Macine/tarallucci/ galletti/campagnole  kg 1",
                            "grammage": 1000,
                            "price": "2.09",
                            "price_label": "€ 2,09",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Macine",
                                "Tarallucci",
                                "Galletti",
                                "Campagnole"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 27.25687590472431,
                                "left": 26.75988068605518,
                                "width": 23.281133482475763,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Macine_1000g_1508342101.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Tarallucci_1000g_1508342101.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Campagnole_1000g_1508342102.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_FDu9j0R_xC25Kgb.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85829",
                            "field1": "PAVESI RINGO",
                            "field2": "vaniglia/cacao gr 165/",
                            "field3": "nocciola e choco gr 155",
                            "field4": "",
                            "description": "PAVESI RINGO vaniglia/cacao gr 165/ nocciola e choco gr 155",
                            "grammage": 0,
                            "price": "0.65",
                            "price_label": "€ 0,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Vaniglia",
                                "Cacao",
                                "Nocciola e Choco"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 10.478352414791422,
                                "left": 50.46607009694258,
                                "width": 23.281133482475763,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/185-f08_RingoCacao165gr_1580138699.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/186-f08_RingoVaniglia165gr_1580138699.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/42649-f08_RingoNocciola155gr_1580138700.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_QvXkRhP_hX1Aeuh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "173485",
                            "field1": "ELLEDÌ",
                            "field2": "Wafer poker",
                            "field3": "cacao/nocciola",
                            "field4": "gr 45 x 5",
                            "description": "ELLEDÌ Wafer poker cacao/nocciola gr 45 x 5",
                            "grammage": 225,
                            "price": "0.75",
                            "price_label": "€ 0,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Cacao",
                                "Nocciola"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 10.70206606132386,
                                "left": 73.4116331096197,
                                "width": 23.281133482475763,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/41110-EP5LagoWaferPokerCacao225g_1551375922.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/41111-EP5LagoWaferPokerNocciola225g_1551375923.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_gKa8kW3_KXIFJVa.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "92508",
                            "field1": "NESTLÈ NESQUIK",
                            "field2": "Solubile ",
                            "field3": "gr 250",
                            "field4": "",
                            "description": "NESTLÈ NESQUIK Solubile  gr 250",
                            "grammage": 250,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 27.14501908145809,
                                "left": 50.3392990305742,
                                "width": 23.281133482475763,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Optistart_250g_alta_1475749801.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_oaH7Tr2_6rylqdn.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "118166",
                            "field1": "FERRERO ",
                            "field2": "Tronky nocciolato ",
                            "field3": "gr 18",
                            "field4": "",
                            "description": "FERRERO  Tronky nocciolato  gr 18",
                            "grammage": 18,
                            "price": "0.32",
                            "price_label": "€ 0,32",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 27.25687590472431,
                                "left": 73.67636092468307,
                                "width": 23.281133482475763,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/2025_ferrero_tronky_singolo_1432044351.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_ZDf6zrb_Hqgb4hi.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "93464",
                            "field1": "BARILLA\t",
                            "field2": "Pan di stelle/",
                            "field3": "abbracci/ritornelli",
                            "field4": "gr 700",
                            "description": "BARILLA\t Pan di stelle/ abbracci/ritornelli gr 700",
                            "grammage": 700,
                            "price": "2.39",
                            "price_label": "€ 2,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 44.0353993946572,
                                "left": 3.042505592841163,
                                "width": 23.281133482475763,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Abbracci_700g_sx_1563547626.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/mulino_bianco_Ritornelli_700_g_1563547628.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Pandistelle_biscotti_700g_sx_1542989417_1545073498_1569942612.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_5yO9OMr_KW9LcLG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "88298",
                            "field1": "NESTLè ORZORO",
                            "field2": "Orzo e caffè gr 120",
                            "field3": "",
                            "field4": "",
                            "description": "NESTLè ORZORO Orzo e caffè gr 120",
                            "grammage": 120,
                            "price": "1.15",
                            "price_label": "€ 1,15",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 44.37096986445585,
                                "left": 26.87546607009694,
                                "width": 23.281133482475763,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/nestle-orzoro_Caffe_1486724634.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_sdjmyGs_K7E1kH7.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "106322",
                            "field1": "DIVELLA\t",
                            "field2": "Dolcenella crema nocciola ",
                            "field3": "gr 400",
                            "field4": "",
                            "description": "DIVELLA\t Dolcenella crema nocciola  gr 400",
                            "grammage": 400,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 43.92354257139097,
                                "left": 50.074571215510815,
                                "width": 23.281133482475763,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Crema-Nocciola-DOLCENELLA-gr-400_1438330599.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_fe6MsIg_TYMchDa.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85802",
                            "field1": "NESCAFè ",
                            "field2": "Dolce gusto",
                            "field3": "16 capsule",
                            "field4": "vari tipi ",
                            "description": "NESCAFè  Dolce gusto 16 capsule vari tipi ",
                            "grammage": null,
                            "price": "3.49",
                            "price_label": "€ 3,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 44.0353993946572,
                                "left": 73.65398956002983,
                                "width": 23.281133482475763,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Nescafe_dolce_gusto_barista_1468405346_1521803418.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/nescafe_dolce_gusto_nesquik_x_16_1465544289_1550484186.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_KPjISmk_Cl9ROkg.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "111716",
                            "field1": "BONOMELLI",
                            "field2": "Tisana rilassante/",
                            "field3": "depurativa/regolarità ",
                            "field4": "16 filtri",
                            "description": "BONOMELLI Tisana rilassante/ depurativa/regolarità  16 filtri",
                            "grammage": null,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Tisana Rilassante",
                                "Tisana Depurativa",
                                "Tisana Regolarità"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 60.81392288459008,
                                "left": 3.4228187919463093,
                                "width": 23.281133482475763,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/32903_1509098796.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/32905_1509098797.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_6IRnHWJ_B1L9EaI.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "130861",
                            "field1": "LAVAZZA",
                            "field2": "Caffè suerte",
                            "field3": "gr 250 x 2",
                            "field4": "",
                            "description": "LAVAZZA Caffè suerte gr 250 x 2",
                            "grammage": 500,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 60.81392288459008,
                                "left": 27.002237136465325,
                                "width": 23.281133482475763,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/2x250_SUERTE_dx_1525858257.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_jdbIvmR_gAqratn.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "106404",
                            "field1": "LAVAZZA",
                            "field2": "Dek caffè ",
                            "field3": "gr 250",
                            "field4": "",
                            "description": "LAVAZZA Dek caffè  gr 250",
                            "grammage": 250,
                            "price": "1.55",
                            "price_label": "€ 1,55",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 60.925779707856314,
                                "left": 50.074571215510815,
                                "width": 23.281133482475763,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/lavazza_dek_classico_250_gr_1501772410.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_xylI8Au_Mdu2Csm.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "107407",
                            "field1": "LAVAZZA",
                            "field2": "Crema e gusto espresso caffè ",
                            "field3": "gr 250",
                            "field4": "",
                            "description": "LAVAZZA Crema e gusto espresso caffè  gr 250",
                            "grammage": 250,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 60.925779707856314,
                                "left": 73.9075316927666,
                                "width": 23.281133482475763,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/7000_1503423422.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_54gwA7o_plLPBM8.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "205682",
                            "field1": "LAVAZZA ",
                            "field2": "Caffè crema e gusto ",
                            "field3": "gr 250 x 4",
                            "field4": "",
                            "description": "LAVAZZA  Caffè crema e gusto  gr 250 x 4",
                            "grammage": 1000,
                            "price": "4.95",
                            "price_label": "€ 4,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 78.26358731412029,
                                "left": 3.169276659209545,
                                "width": 23.281133482475763,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Lavazza_crema_e_gusto_classico_1538039046_1542732136_1558966895_1581346903.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_zy7jIJr_nSC3IPK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "120292",
                            "field1": "LAVAZZA",
                            "field2": "Crema e gusto caffè in grani ",
                            "field3": "kg 1",
                            "field4": "",
                            "description": "LAVAZZA Crema e gusto caffè in grani  kg 1",
                            "grammage": 1000,
                            "price": "6.19",
                            "price_label": "€ 6,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 78.37544413738651,
                                "left": 26.748695003728564,
                                "width": 23.281133482475763,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/lavazza_espresso_crema_e_gusto_classico_busta_in_grani_1503328715.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_YK1wt7L_bKFBUcp.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "195306",
                            "field1": "BORBONE",
                            "field2": "Capsule Miscela Nobile",
                            "field3": "compatibili con nespresso 5 gr x 10 /",
                            "field4": "a modo mio 7,2 gr x 10",
                            "description": "BORBONE Capsule Miscela Nobile compatibili con nespresso 5 gr x 10 / a modo mio 7,2 gr x 10",
                            "grammage": 0,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Compatibile Nespresso",
                                "Compatibile A Modo Mio"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 78.48730096065273,
                                "left": 50.074571215510815,
                                "width": 23.281133482475763,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/borbone_capsule_1572455356.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_Vhktx5U_orrkZCq.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "191882",
                            "field1": "BORBONE",
                            "field2": "Miscela decisa",
                            "field3": "cialde",
                            "field4": "gr 7,2 x 15 ",
                            "description": "BORBONE Miscela decisa cialde gr 7,2 x 15 ",
                            "grammage": 108,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 78.03987366758786,
                                "left": 73.65398956002983,
                                "width": 23.281133482475763,
                                "height": 16.291617318068166
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Borbone_1545924361_Decisa_1570118656.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_TAOBf8C_f7A3361.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 19,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_19_UKpITT0.jpg",
                    "products": [
                        {
                            "item_id": "104115",
                            "field1": "PIZZOLI\t",
                            "field2": "Patate le casalinghe surgelate",
                            "field3": "gr 750",
                            "field4": "",
                            "description": "PIZZOLI\t Patate le casalinghe surgelate gr 750",
                            "grammage": 750,
                            "price": "1.35",
                            "price_label": "€ 1,35",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Preparati",
                            "blueprint": {
                                "top": 9.807211475194125,
                                "left": 3.2960477255779272,
                                "width": 46.480238627889634,
                                "height": 33.741281747598364
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/38702-PizzoliPatate750gr_1579540152.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_jMVaDy2_TWHacKK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85995",
                            "field1": "PIZZOLI\t",
                            "field2": "Patate fritte surgelate ",
                            "field3": "kg 1",
                            "field4": "",
                            "description": "PIZZOLI\t Patate fritte surgelate  kg 1",
                            "grammage": 1000,
                            "price": "1.15",
                            "price_label": "€ 1,15",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Preparati",
                            "blueprint": {
                                "top": 10.47835241479144,
                                "left": 50.074571215510815,
                                "width": 23.281133482475763,
                                "height": 33.07014080800105
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/pizzoli_patatine_classic_kg_1_1453115496_1489078306.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_PbSijJx_opn4mKu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "88367",
                            "field1": "LA VALLE DEGLI ORTI",
                            "field2": "Piselli fini ",
                            "field3": "gr 900",
                            "field4": "",
                            "description": "LA VALLE DEGLI ORTI Piselli fini  gr 900",
                            "grammage": 900,
                            "price": "1.75",
                            "price_label": "€ 1,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 10.70206606132388,
                                "left": 73.67636092468307,
                                "width": 23.281133482475763,
                                "height": 33.07014080800105
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/25114_1535537148.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_j50CF05_mM47Yt8.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "207472",
                            "field1": "FRESCOFIORE",
                            "field2": "Panzerottini",
                            "field3": "prefritti",
                            "field4": "gr 650",
                            "description": "FRESCOFIORE Panzerottini prefritti gr 650",
                            "grammage": 650,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Preparati",
                            "blueprint": {
                                "top": 44.14725621792343,
                                "left": 3.3184190902311648,
                                "width": 23.281133482475763,
                                "height": 16.40347414133438
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/63083_vivi_puglia_panzerottini_pugliesi_pomodoro_mozzarella_1583506628.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_ibL12vV_uRHv7lC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "138168",
                            "field1": "LA VALLE DEGLI ORTI",
                            "field2": "Fave",
                            "field3": "gr 450",
                            "field4": "",
                            "description": "LA VALLE DEGLI ORTI Fave gr 450",
                            "grammage": 450,
                            "price": "1.35",
                            "price_label": "€ 1,35",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 44.14725621792343,
                                "left": 26.89783743475018,
                                "width": 23.281133482475763,
                                "height": 16.40347414133438
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/16738_1534178889.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_kZUVCqM_xHQS2AU.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "204401",
                            "field1": "3 MARI",
                            "field2": "vongole scure del pacifico 60/80 netto",
                            "field3": "gr 500",
                            "field4": "",
                            "description": "3 MARI vongole scure del pacifico 60/80 netto gr 500",
                            "grammage": 500,
                            "price": "1.45",
                            "price_label": "€ 1,45",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 60.70206606132387,
                                "left": 3.3184190902311648,
                                "width": 23.281133482475763,
                                "height": 16.40347414133438
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/61220_1580400227.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_6K9qtso_Zobr1HG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "87606",
                            "field1": "FILETTO DI PANGASIO",
                            "field2": "Surgelato",
                            "field3": "gr 800",
                            "field4": "",
                            "description": "FILETTO DI PANGASIO Surgelato gr 800",
                            "grammage": 800,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 61.03763653112252,
                                "left": 26.64429530201342,
                                "width": 23.281133482475763,
                                "height": 16.40347414133438
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/42517_pangasio_1584376644.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_W61rvZ6_yJ0fOBU.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "90987",
                            "field1": "3 MARI",
                            "field2": "Gamberetti sgusciati ",
                            "field3": "gr 160",
                            "field4": "",
                            "description": "3 MARI Gamberetti sgusciati  gr 160",
                            "grammage": 160,
                            "price": "2.05",
                            "price_label": "€ 2,05",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 43.92354257139098,
                                "left": 50.350484712900816,
                                "width": 45.84638329604772,
                                "height": 33.40571127779971
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/40811_3mari_gamberi_congelati_160gr_1494585133.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_tvnUcud_bxq5t7c.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "88813",
                            "field1": "TARANPESCA",
                            "field2": "preparato per Risotto",
                            "field3": "gr 250",
                            "field4": "",
                            "description": "TARANPESCA preparato per Risotto gr 250",
                            "grammage": 250,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Preparati",
                            "blueprint": {
                                "top": 77.59244637452298,
                                "left": 3.0648769574944015,
                                "width": 23.407904548844137,
                                "height": 17.633899197262796
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/12735_1492182476.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_WaH3IsJ_wKjd2hP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "207474",
                            "field1": "FROSTA",
                            "field2": "Filetti gustosi di merluzzo d’alaska",
                            "field3": "zucchine e capperi/patate e pomodori",
                            "field4": "gr 320",
                            "description": "FROSTA Filetti gustosi di merluzzo d’alaska zucchine e capperi/patate e pomodori gr 320",
                            "grammage": 320,
                            "price": "3.20",
                            "price_label": "€ 3,20",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Zucchine e Capperi",
                                "Patate e Pomodori"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Preparati",
                            "blueprint": {
                                "top": 77.25687590472432,
                                "left": 26.64429530201342,
                                "width": 23.407904548844137,
                                "height": 17.633899197262796
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Frosta_patate_e_pomodori_1574870834_1583506738.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/frosta_zucchine_e_capperi_1574870835_1583506738.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_0sXq6YA_BwXtuVZ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "112218",
                            "field1": "ABITUÈ",
                            "field2": "Gelato dessert ",
                            "field3": "vaniglia e cacao ",
                            "field4": "gr 320",
                            "description": "ABITUÈ Gelato dessert  vaniglia e cacao  gr 320",
                            "grammage": 320,
                            "price": "1.25",
                            "price_label": "€ 1,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Gelati",
                            "blueprint": {
                                "top": 78.03987366758786,
                                "left": 50.22371364653244,
                                "width": 23.407904548844137,
                                "height": 16.96275825766548
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/33505_1508865056.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_dffBLdZ_nAG8ceb.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "107127",
                            "field1": "TRE MARIE",
                            "field2": "6 Croissant surgelati gr 330",
                            "field3": "",
                            "field4": "",
                            "description": "TRE MARIE 6 Croissant surgelati gr 330",
                            "grammage": 0,
                            "price": "1.60",
                            "price_label": "€ 1,60",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Preparati",
                            "blueprint": {
                                "top": 77.59244637452298,
                                "left": 73.80313199105144,
                                "width": 22.774049217002222,
                                "height": 16.96275825766548
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/47760_1550157839.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_kSDUuqZ_4up8qVd.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 20,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_20_iwp7P7Z.jpg",
                    "products": [
                        {
                            "item_id": "89546",
                            "field1": "GALBANI",
                            "field2": "Crema bel paese ",
                            "field3": "8 formaggini",
                            "field4": "gr 175",
                            "description": "GALBANI Crema bel paese  8 formaggini gr 175",
                            "grammage": 0,
                            "price": "0.79",
                            "price_label": "€ 0,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 9.731543624161073,
                                "left": 3.5384041759880644,
                                "width": 46.14466815809098,
                                "height": 33.89261744966443
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Galbani_bel_paese_formaggini_175_gr.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_UBwaXUS_ozQqLLc.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "89475",
                            "field1": "AIA WUDY",
                            "field2": "Wurstel snack",
                            "field3": "pollo e tacchino classico",
                            "field4": "gr 100",
                            "description": "AIA WUDY Wurstel snack pollo e tacchino classico gr 100",
                            "grammage": 100,
                            "price": "0.20",
                            "price_label": "€ 0,20",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 10.51454138702461,
                                "left": 50.31692766592094,
                                "width": 23.07233407904549,
                                "height": 15.995525727069351
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/33543_1554112837.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_9x5eoip_TSXYV7C.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "87446",
                            "field1": "PARMAREGGIO",
                            "field2": "Cuor di mix formaggio grattugiato",
                            "field3": "gr 70 ",
                            "field4": "",
                            "description": "PARMAREGGIO Cuor di mix formaggio grattugiato gr 70 ",
                            "grammage": 70,
                            "price": "0.59",
                            "price_label": "€ 0,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 10.738255033557047,
                                "left": 73.63161819537657,
                                "width": 23.07233407904549,
                                "height": 15.548098434004473
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Parmareggio_cuor_mix_formaggi_100_g.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_sOxGfjK_bDz9W3j.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "119087",
                            "field1": "AMADORI EVVIVA",
                            "field2": "Wurstel di pollo e tacchino ",
                            "field3": "gr 500",
                            "field4": "",
                            "description": "AMADORI EVVIVA Wurstel di pollo e tacchino  gr 500",
                            "grammage": 500,
                            "price": "0.75",
                            "price_label": "€ 0,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 26.7337807606264,
                                "left": 50.55928411633109,
                                "width": 23.07233407904549,
                                "height": 16.890380313199106
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/55994_AmadoriEvvivaPolloTacchino500gr_1580918460.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_vGrVrU5_uuvL009.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "87360",
                            "field1": "BECHER",
                            "field2": "Le prosciuttine",
                            "field3": "classiche",
                            "field4": "gr 150",
                            "description": "BECHER Le prosciuttine classiche gr 150",
                            "grammage": 150,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 26.7337807606264,
                                "left": 74.13870246085011,
                                "width": 23.07233407904549,
                                "height": 16.890380313199106
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/31269_le_proscittine_le_classiche_150_gr_1491044244.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_EwqtkSX_mC2peWT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "110044",
                            "field1": "IL PASTAIO MAFFEI",
                            "field2": "Pasta fresca ",
                            "field3": "calamarata",
                            "field4": "kg 1",
                            "description": "IL PASTAIO MAFFEI Pasta fresca  calamarata kg 1",
                            "grammage": 1000,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 43.959731543624166,
                                "left": 3.4228187919463093,
                                "width": 23.07233407904549,
                                "height": 16.666666666666664
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/51456_1526658861.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_de0jpdW_G9gHamz.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "110044",
                            "field1": "IL PASTAIO MAFFEI",
                            "field2": "Pasta fresca ",
                            "field3": "orecchiette/cavatelli/troccoli/scialatielli ",
                            "field4": "kg 1",
                            "description": "IL PASTAIO MAFFEI Pasta fresca  orecchiette/cavatelli/troccoli/scialatielli  kg 1",
                            "grammage": 1000,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Orecchiette",
                                "Cavatelli",
                                "Troccoli",
                                "Scialatielli"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 43.73601789709172,
                                "left": 26.748695003728564,
                                "width": 23.07233407904549,
                                "height": 16.666666666666664
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/51448_1526658966.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_2vxNJkD_XTQd3OR.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "119480",
                            "field1": "ALIBERT",
                            "field2": "Pasta fresca ripiena ",
                            "field3": "tortellini carne/prosciutto crudo",
                            "field4": "gr 250 ",
                            "description": "ALIBERT Pasta fresca ripiena  tortellini carne/prosciutto crudo gr 250 ",
                            "grammage": 250,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Carne",
                                "Prosciutto Crudo "
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 60.62639821029082,
                                "left": 3.676360924683072,
                                "width": 23.07233407904549,
                                "height": 16.666666666666664
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/RENDER_TORTELLINI_ALLA_CARNE_250g_1509621245_1516352261.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/RENDER_TORTELLINI_PROSCIUTTIO_CRUDO_250g_1509621247_1516352262.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_HN3YkHP_HTur3eK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "103507",
                            "field1": "DIVELLA\t",
                            "field2": "Pasta fresca ",
                            "field3": "classica/integrale vari tipi",
                            "field4": "gr 500",
                            "description": "DIVELLA\t Pasta fresca  classica/integrale vari tipi gr 500",
                            "grammage": 500,
                            "price": "0.65",
                            "price_label": "€ 0,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classica",
                                "Integrale"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 60.514541387024614,
                                "left": 26.87546607009694,
                                "width": 23.07233407904549,
                                "height": 16.666666666666664
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/divella_01_1486650911_1489136299_1502353489.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/divella_2_1486650911_1489136299_1502353490.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Divella_pasta_fresca_trofiette_500_gr_1489136299_1502353490.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/12510_divella_1532617337.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/36488_divella_1532617338.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/12509_divella_1534262673.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/12518_1554972122.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_UkqL3hu_O54mBEy.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "92515",
                            "field1": "LATTERIA SORESINA",
                            "field2": "Grana padano D.O.P. grattugiato",
                            "field3": "gr 100",
                            "field4": "",
                            "description": "LATTERIA SORESINA Grana padano D.O.P. grattugiato gr 100",
                            "grammage": 100,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 44.407158836689035,
                                "left": 50.32811334824758,
                                "width": 46.017897091722595,
                                "height": 32.66219239373602
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/3254_soresina_grana_grattugiato_100_g.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_c9qSi16_Bas1sHh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "129152",
                            "field1": "CIEMME BELLI&FRESCHI ",
                            "field2": "Gnocchi/chicche di patate con patata fresca",
                            "field3": "gr 500",
                            "field4": "",
                            "description": "CIEMME BELLI&FRESCHI  Gnocchi/chicche di patate con patata fresca gr 500",
                            "grammage": 500,
                            "price": "0.49",
                            "price_label": "€ 0,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Gnocchi di Patate",
                                "Chicche di Patate"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 77.51677852348993,
                                "left": 3.2960477255779272,
                                "width": 23.19910514541387,
                                "height": 17.337807606263983
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/57844_ciemme_gnocchi_1539589906.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/57844_ciemme_chicce_1539589906.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_Y5n6fcq_t9LvvYB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "107401",
                            "field1": "BUITONI",
                            "field2": "Pasta sfoglia rettangolare",
                            "field3": "gr 230",
                            "field4": "",
                            "description": "BUITONI Pasta sfoglia rettangolare gr 230",
                            "grammage": 230,
                            "price": "1.09",
                            "price_label": "€ 1,09",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 77.74049217002238,
                                "left": 26.87546607009694,
                                "width": 23.19910514541387,
                                "height": 17.337807606263983
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Buitoni_Sfoglia_fresca_Rettangolare_1527006650_1583519494.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_0ZFAlEX_3XpbcgN.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "207466",
                            "field1": "GALBANI",
                            "field2": "Galbanino & galbanetto",
                            "field3": "affettato",
                            "field4": "gr 100",
                            "description": "GALBANI Galbanino & galbanetto affettato gr 100",
                            "grammage": 100,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 77.51677852348993,
                                "left": 50.454884414615954,
                                "width": 23.19910514541387,
                                "height": 17.337807606263983
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/1462203_GALBANI_GALBANINO_E_GALBANETTO_1552905358_1558596580_1562665_ox1REK5.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_riGW9A3_QNtn62Y.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "89471",
                            "field1": "COATI",
                            "field2": "Pancetta a cubetti",
                            "field3": "dolce/affumicata",
                            "field4": "gr 50 x 2",
                            "description": "COATI Pancetta a cubetti dolce/affumicata gr 50 x 2",
                            "grammage": 100,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Dolce",
                                "Affumicat"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 77.74049217002238,
                                "left": 73.52721849366145,
                                "width": 23.19910514541387,
                                "height": 17.337807606263983
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/coati_pancetta_a_cubetti_affumicata_e_dolce_1492683616.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_DofKBs0_ky2vkzQ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 21,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_21_ABGTtMD.jpg",
                    "products": [
                        {
                            "item_id": "86100",
                            "field1": "RIUNIONE",
                            "field2": "Salmone norvegese ",
                            "field3": "Affumicato ",
                            "field4": "gr 200",
                            "description": "RIUNIONE Salmone norvegese  Affumicato  gr 200",
                            "grammage": 200,
                            "price": "3.49",
                            "price_label": "€ 3,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 9.843400447427292,
                                "left": 3.5495898583146905,
                                "width": 46.14466815809098,
                                "height": 33.78076062639821
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/rosa_del_nord_1490089232_1507705986.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_bsv61sk_Muvu9CX.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "86075",
                            "field1": "GALBANI\t",
                            "field2": "Santa Lucia ",
                            "field3": "burro ",
                            "field4": "gr 250",
                            "description": "GALBANI\t Santa Lucia  burro  gr 250",
                            "grammage": 250,
                            "price": "1.55",
                            "price_label": "€ 1,55",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 10.738255033557047,
                                "left": 50.17897091722594,
                                "width": 46.14466815809098,
                                "height": 15.883668903803132
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Burro_Santa_Lucia_250gr_new_1480435277_1489138134.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_ctOGeFy_5GtFh7V.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "92302",
                            "field1": "PHILADELPHIA",
                            "field2": "Classico",
                            "field3": "gr 80",
                            "field4": "",
                            "description": "PHILADELPHIA Classico gr 80",
                            "grammage": 80,
                            "price": "0.65",
                            "price_label": "€ 0,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 26.621923937360176,
                                "left": 50.4325130499627,
                                "width": 22.94556301267711,
                                "height": 16.778523489932883
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Brick_FF_80g_3D_1525875187_1527173972_1528107092.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_dAJ3yTV_GCUY1nj.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "188051",
                            "field1": "VOGLIAZZI",
                            "field2": "Insalata ",
                            "field3": "capricciosa/russa",
                            "field4": "gr 150",
                            "description": "VOGLIAZZI Insalata  capricciosa/russa gr 150",
                            "grammage": 150,
                            "price": "0.59",
                            "price_label": "€ 0,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Capricciosa",
                                "Russa"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 26.7337807606264,
                                "left": 73.5048471290082,
                                "width": 22.94556301267711,
                                "height": 16.778523489932883
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/53808_1566576382.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_DTQ4zaa_JSCx7Wi.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "86090",
                            "field1": "SOTTILETTE\t",
                            "field2": "Classiche ",
                            "field3": "gr 200",
                            "field4": "",
                            "description": "SOTTILETTE\t Classiche  gr 200",
                            "grammage": 200,
                            "price": "1.05",
                            "price_label": "€ 1,05",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 43.959731543624166,
                                "left": 3.8031319910514543,
                                "width": 22.94556301267711,
                                "height": 16.778523489932883
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Sottilette_classiche_g200_1564141010_1568134839_1570210620_157046186_06JozOX.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_fTjUlE2_6U1zvsg.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "88651",
                            "field1": "GALBANI",
                            "field2": "Vallelata Ricotta classica",
                            "field3": "gr 250 ",
                            "field4": "",
                            "description": "GALBANI Vallelata Ricotta classica gr 250 ",
                            "grammage": 250,
                            "price": "1.15",
                            "price_label": "€ 1,15",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 44.071588366890374,
                                "left": 27.382550335570475,
                                "width": 22.94556301267711,
                                "height": 16.55480984340045
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/6000663_1508519930.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_ZFCssPP_3j6lrAY.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "89544",
                            "field1": "LATTERIA MONTELLO NONNO NANNI",
                            "field2": "Stracchino",
                            "field3": "gr 200",
                            "field4": "",
                            "description": "LATTERIA MONTELLO NONNO NANNI Stracchino gr 200",
                            "grammage": 200,
                            "price": "1.89",
                            "price_label": "€ 1,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 43.959731543624166,
                                "left": 50.83519761372111,
                                "width": 22.94556301267711,
                                "height": 16.55480984340045
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/nonno_nanni_stracchino_200gr_1492698258.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_1KW1qHV_95gXfTq.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "89820",
                            "field1": "EXQUISA",
                            "field2": "Formaggio fresco cremoso",
                            "field3": "senza lattosio",
                            "field4": "gr 175",
                            "description": "EXQUISA Formaggio fresco cremoso senza lattosio gr 175",
                            "grammage": 175,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 43.959731543624166,
                                "left": 73.63161819537657,
                                "width": 22.94556301267711,
                                "height": 16.55480984340045
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/exquisa_senza_lattosio_175_gr_1492782632.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_h4eROCB_DVg6TZ3.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "94787",
                            "field1": "LATTERIA MONTELLO NONNO NANNI",
                            "field2": "Robiola senza lattosio",
                            "field3": "gr 100",
                            "field4": "",
                            "description": "LATTERIA MONTELLO NONNO NANNI Robiola senza lattosio gr 100",
                            "grammage": 100,
                            "price": "1.09",
                            "price_label": "€ 1,09",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 60.73825503355705,
                                "left": 4.056674123788218,
                                "width": 22.94556301267711,
                                "height": 16.55480984340045
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Nonno_nanni_robiola_senza_lattosio_100_g_1490871795.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_q7WjhF0_uMic14q.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "125294",
                            "field1": "SAN VITO",
                            "field2": "Mozzarella di bufala",
                            "field3": "gr 250",
                            "field4": "",
                            "description": "SAN VITO Mozzarella di bufala gr 250",
                            "grammage": 250,
                            "price": "2.39",
                            "price_label": "€ 2,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 60.62639821029082,
                                "left": 27.12900820283371,
                                "width": 22.94556301267711,
                                "height": 16.55480984340045
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/6001591_1524502504.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_lNa3pOr_iMIJjsO.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "207470",
                            "field1": "PARMAREGGIO",
                            "field2": "L'abc della merenda ",
                            "field3": "crostatina al cacao",
                            "field4": "gr 185",
                            "description": "PARMAREGGIO L'abc della merenda  crostatina al cacao gr 185",
                            "grammage": 185,
                            "price": "0.65",
                            "price_label": "€ 0,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Snack",
                            "blueprint": {
                                "top": 60.85011185682326,
                                "left": 50.32811334824758,
                                "width": 22.94556301267711,
                                "height": 16.55480984340045
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/LABC_DELLA_MERENDA_CROSTATINA_CACAO_senza_flash_1568371012_156879671_P2NZDra.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_uG3zGDK_eDdVNEY.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "89550",
                            "field1": "PARMAREGGIO",
                            "field2": "Snack l’ABC della merenda",
                            "field3": "vari gusti",
                            "field4": "",
                            "description": "PARMAREGGIO Snack l’ABC della merenda vari gusti",
                            "grammage": 0,
                            "price": "0.75",
                            "price_label": "€ 0,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 60.514541387024614,
                                "left": 73.65398956002983,
                                "width": 22.94556301267711,
                                "height": 16.55480984340045
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Parmareggio_ABC_merenda_con_parmigiano_1567616997_1568620397_1570468299.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_COmanSu_Tn3WmZn.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "93551",
                            "field1": "FAGE TOTAL",
                            "field2": "Yogurt greco 0% ",
                            "field3": "split vari gusti",
                            "field4": "gr 170",
                            "description": "FAGE TOTAL Yogurt greco 0%  split vari gusti gr 170",
                            "grammage": 170,
                            "price": "0.75",
                            "price_label": "€ 0,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 77.51677852348993,
                                "left": 3.9299030574198364,
                                "width": 22.94556301267711,
                                "height": 17.449664429530202
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/52802_1508949544.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_PJOMBH0_sx1GJf2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "88615",
                            "field1": "yomo",
                            "field2": "yogurt greco delta 0%",
                            "field3": "vari gusti",
                            "field4": "gr 170",
                            "description": "yomo yogurt greco delta 0% vari gusti gr 170",
                            "grammage": 170,
                            "price": "0.79",
                            "price_label": "€ 0,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 77.62863534675614,
                                "left": 26.87546607009694,
                                "width": 22.94556301267711,
                                "height": 17.114093959731544
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Delta_yomo_BIANCO_1569578862.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Delta_yomo_MIRTILLO_1569578863.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_HHK86AP_sAvEakY.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "87382",
                            "field1": "DANONE",
                            "field2": "Actimel",
                            "field3": "classico/0,1% vari tipi",
                            "field4": "ml 100 x 6",
                            "description": "DANONE Actimel classico/0,1% vari tipi ml 100 x 6",
                            "grammage": 600,
                            "price": "2.09",
                            "price_label": "€ 2,09",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Bianco",
                                "Fragola"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 78.07606263982102,
                                "left": 50.454884414615954,
                                "width": 22.94556301267711,
                                "height": 17.114093959731544
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/6000002_1556291149.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/8002993_1556291150.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_NfqAu4R_v4jcUK6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "88621",
                            "field1": "NESTLÈ FRUTTOLO",
                            "field2": "Fragola/banana e fragola",
                            "field3": "gr 200",
                            "field4": "",
                            "description": "NESTLÈ FRUTTOLO Fragola/banana e fragola gr 200",
                            "grammage": 200,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Fragola",
                                "Banana e Fragola"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 77.74049217002235,
                                "left": 73.9075316927666,
                                "width": 22.94556301267711,
                                "height": 17.114093959731544
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Fruttolo_Mono_4x50g_Frutta_Singola_1519033666_1519227467_1519317419__8DuHQhL.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/3D-Fruttolo-4x50g-Frutta-Mista_1520000859.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_QTsCHk6_isMN35l.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 22,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_22_vaPQuB4.jpg",
                    "products": [
                        {
                            "item_id": "109574",
                            "field1": "CORONA",
                            "field2": "Carta igienica ",
                            "field3": "doppio velo ",
                            "field4": "4 rotoloni",
                            "description": "CORONA Carta igienica  doppio velo  4 rotoloni",
                            "grammage": null,
                            "price": "0.75",
                            "price_label": "€ 0,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 9.731543624161048,
                                "left": 3.4228187919463093,
                                "width": 46.14466815809098,
                                "height": 33.78076062639821
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/54026_1507296261.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_n1XSY8L_ct6HLlL.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "105332",
                            "field1": "FANTASY\t",
                            "field2": "Asciugatutto",
                            "field3": "2 rotoli magnum ",
                            "field4": "arancio",
                            "description": "FANTASY\t Asciugatutto 2 rotoli magnum  arancio",
                            "grammage": null,
                            "price": "1.15",
                            "price_label": "€ 1,15",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Superfici",
                            "blueprint": {
                                "top": 10.514541387024583,
                                "left": 50.074571215510815,
                                "width": 23.452647278150636,
                                "height": 16.442953020134226
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/32701_1500285913.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_MICVDGG_H4L29nX.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "187999",
                            "field1": "FOXY",
                            "field2": "Carta igienica mega decorata",
                            "field3": "2 veli 4 rotoli",
                            "field4": "",
                            "description": "FOXY Carta igienica mega decorata 2 veli 4 rotoli",
                            "grammage": 0,
                            "price": "1.55",
                            "price_label": "€ 1,55",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 10.290827740492142,
                                "left": 73.52721849366145,
                                "width": 23.452647278150636,
                                "height": 16.442953020134226
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Foxy_Mega_4_igienica_1491647551_1492502992_1537264428_1560879356_1566309886.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_OHGQpfk_yBHgUTT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "93624",
                            "field1": "REGINA",
                            "field2": "Cinquestelle ",
                            "field3": "43 tovaglioli ",
                            "field4": "2 veli cm 38 x 38",
                            "description": "REGINA Cinquestelle  43 tovaglioli  2 veli cm 38 x 38",
                            "grammage": 0,
                            "price": "0.52",
                            "price_label": "€ 0,52",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 27.29306487695747,
                                "left": 50.32811334824758,
                                "width": 23.07233407904549,
                                "height": 16.442953020134226
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Regina_5_stelle_1478258876_1484150934.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_qo9I9jn_tTd8t0a.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "88783",
                            "field1": "PAMPERS",
                            "field2": "Sole e luna ",
                            "field3": "pannolini ",
                            "field4": "varie misure",
                            "description": "PAMPERS Sole e luna  pannolini  varie misure",
                            "grammage": null,
                            "price": "3.10",
                            "price_label": "€ 3,10",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 27.29306487695747,
                                "left": 73.65398956002983,
                                "width": 21.424310216256522,
                                "height": 16.442953020134226
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/45121_1504802986.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/45117_1515064404.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/45117_1539156814.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/45122_1564409983.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_CQdW2Uh_Px8Nmks.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "110077",
                            "field1": "MIL MIL",
                            "field2": "Sapone liquido busta maxi ricarica",
                            "field3": "vari tipi",
                            "field4": "lt 2",
                            "description": "MIL MIL Sapone liquido busta maxi ricarica vari tipi lt 2",
                            "grammage": 2000,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 44.29530201342279,
                                "left": 3.2960477255779272,
                                "width": 23.579418344519016,
                                "height": 15.995525727069351
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/mil_mil_sapone_liquido_ricarica_classico_cocco_2_lt_1506332984_1506411554.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_k2Sv4de_1vwllDz.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "173927",
                            "field1": "DOVE",
                            "field2": "Bagno doccia mousse",
                            "field3": "vari tipi",
                            "field4": "ml 200",
                            "description": "DOVE Bagno doccia mousse vari tipi ml 200",
                            "grammage": 200,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 44.183445190156576,
                                "left": 26.748695003728564,
                                "width": 22.692020879940344,
                                "height": 15.995525727069351
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/dove_mousse_rosa_200ml_1527763531.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/dove_mousse_argan_200ml_1527763534.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_li0JyoC_fYxS6AC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "176748",
                            "field1": "ANTICA ERBORISTERIA ",
                            "field2": "Shampoo",
                            "field3": "vari tipi",
                            "field4": "ml 250",
                            "description": "ANTICA ERBORISTERIA  Shampoo vari tipi ml 250",
                            "grammage": 250,
                            "price": "0.80",
                            "price_label": "€ 0,80",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Lavanda"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Capelli",
                            "blueprint": {
                                "top": 61.07382550335568,
                                "left": 3.4228187919463093,
                                "width": 23.07233407904549,
                                "height": 16.107382550335572
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/60841-YCB_AnticaErboristeriaShampoo250Lavanda_1554909778.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_Ox85E5O_EnF9ZVn.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "89777",
                            "field1": "GILLETTE ",
                            "field2": "Blue II ",
                            "field3": "5 Rasoi ",
                            "field4": "usa e getta",
                            "description": "GILLETTE  Blue II  5 Rasoi  usa e getta",
                            "grammage": null,
                            "price": "1.10",
                            "price_label": "€ 1,10",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Viso",
                            "blueprint": {
                                "top": 60.738255033557024,
                                "left": 26.87546607009694,
                                "width": 23.07233407904549,
                                "height": 16.666666666666664
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/gillette_blue_II_rasoi_x_5_1483348600.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_mR2VR69_0nu7wPz.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "89808",
                            "field1": "PRESTO",
                            "field2": "Piatti fondi/piani ",
                            "field3": "gr 500",
                            "field4": "",
                            "description": "PRESTO Piatti fondi/piani  gr 500",
                            "grammage": 0,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Fondi",
                                "Piani"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 43.95973154362414,
                                "left": 50.074571215510815,
                                "width": 46.39821029082774,
                                "height": 33.1096196868009
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/24265_1493287711.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/24266_1522401661.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_NUJLVdD_vloWEL7.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "89791",
                            "field1": "LINES INTERVALLO LADY",
                            "field2": "Maxi/maxi long x28/",
                            "field3": "regular x40 proteggislip",
                            "field4": "",
                            "description": "LINES INTERVALLO LADY Maxi/maxi long x28/ regular x40 proteggislip",
                            "grammage": null,
                            "price": "2.20",
                            "price_label": "€ 2,20",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Maxi",
                                "Maxi Long",
                                "Regular Proteggislip"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 77.74049217002235,
                                "left": 3.4228187919463093,
                                "width": 22.311707680835198,
                                "height": 16.890380313199106
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/LINES_INTERVALLO_LADI_MAXY_X_28_1468999568.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/37919_1526028798.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_fK3vrDQ_x2N7rks.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "103796",
                            "field1": "DOMO PAK",
                            "field2": "Alluminio",
                            "field3": "8 metri/",
                            "field4": "pellicola 30 metri",
                            "description": "DOMO PAK Alluminio 8 metri/ pellicola 30 metri",
                            "grammage": null,
                            "price": "0.65",
                            "price_label": "€ 0,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Alluminio 8 metri",
                                "Pellicola 30 metri"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 77.40492170022368,
                                "left": 27.12900820283371,
                                "width": 22.94556301267711,
                                "height": 16.890380313199106
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/5028_1502200463.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/5027_1498831959_1513242502.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_BJCos6G_AjDpjpR.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "116676",
                            "field1": "MENTADENT",
                            "field2": "Dentifricio",
                            "field3": "vari tipi",
                            "field4": "ml 75",
                            "description": "MENTADENT Dentifricio vari tipi ml 75",
                            "grammage": 75,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Crystal Gel",
                                " White System"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Orale",
                            "blueprint": {
                                "top": 77.51677852348989,
                                "left": 50.454884414615954,
                                "width": 22.94556301267711,
                                "height": 16.890380313199106
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/mentadent_crystal_gel_75_ml_1440150354_1490714736_1505380232_1512035418.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/mentadent_microgranuli_dentifricio_75_ml_1505380232_1512035418.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/mentadent_white_system_dentifricio_75_ml_1505380232_1512035418.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_r4tI2Ja_mqZfPPB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "93868",
                            "field1": "ROYAL",
                            "field2": "100 bicchieri  ",
                            "field3": "bianchi",
                            "field4": "cc 200",
                            "description": "ROYAL 100 bicchieri   bianchi cc 200",
                            "grammage": null,
                            "price": "0.52",
                            "price_label": "€ 0,52",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 77.51677852348989,
                                "left": 73.52721849366145,
                                "width": 22.94556301267711,
                                "height": 16.890380313199106
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/52811_royalo_100_bicchieri_1497376314_1508746389.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_VHnE0uH_6DEIfQP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 23,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_23_HBA7lfJ.jpg",
                    "products": [
                        {
                            "item_id": "88852",
                            "field1": "SVELTO ",
                            "field2": "Detersivo piatti",
                            "field3": "vari tipi",
                            "field4": "lt 1 x 3",
                            "description": "SVELTO  Detersivo piatti vari tipi lt 1 x 3",
                            "grammage": 3000,
                            "price": "2.27",
                            "price_label": "€ 2,27",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Aceto",
                                "Limone"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 9.731543624161073,
                                "left": 3.284862043251301,
                                "width": 46.14466815809098,
                                "height": 33.89261744966443
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/svelto_limone_1556296069.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/svelto_aceto_1556296070.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_chvUfKd_MM0cqSZ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "207476",
                            "field1": "DASH",
                            "field2": "Fustone",
                            "field3": "87 misurini",
                            "field4": "",
                            "description": "DASH Fustone 87 misurini",
                            "grammage": 0,
                            "price": "9.29",
                            "price_label": "€ 9,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 10.738255033557047,
                                "left": 50.31692766592094,
                                "width": 23.19910514541387,
                                "height": 32.997762863534675
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/8001841531502_DashActilift87misurini_1583506940.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_copCXMC_ak4ADwy.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "87321",
                            "field1": "ACE",
                            "field2": "Candeggina profumata lt 3/",
                            "field3": "denso più classica/",
                            "field4": "armonie floreali lt 2,5",
                            "description": "ACE Candeggina profumata lt 3/ denso più classica/ armonie floreali lt 2,5",
                            "grammage": null,
                            "price": "1.95",
                            "price_label": "€ 1,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Candeggina Profumata",
                                "Denso Più Classica",
                                "Armonie Floreali"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 10.850111856823265,
                                "left": 73.76957494407158,
                                "width": 23.19910514541387,
                                "height": 32.5503355704698
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/ace_profumata_3_l_1509101552.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/ace_denso_piu_25_lt_1509101552.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/ace_denso_piu_armonie_25_lt_1509101553.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_GiY32JU_fYunhtE.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "185441",
                            "field1": "DIXAN",
                            "field2": "Disc vari tipi 25 pz/",
                            "field3": "duo-caps vari tipi 30 pz",
                            "field4": "",
                            "description": "DIXAN Disc vari tipi 25 pz/ duo-caps vari tipi 30 pz",
                            "grammage": 0,
                            "price": "4.60",
                            "price_label": "€ 4,60",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Disc",
                                "Duo-Caps"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 44.63087248322148,
                                "left": 3.4116331096196824,
                                "width": 23.19910514541387,
                                "height": 15.771812080536915
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/61932-c16_dixan_discs_classico_1582901108.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/61933-c16_dixan_discs_multicolor_1582901109.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_96T6LpN_SL5Ha7f.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "89726",
                            "field1": "ACE",
                            "field2": "Candeggina classica",
                            "field3": "lt 5",
                            "field4": "",
                            "description": "ACE Candeggina classica lt 5",
                            "grammage": 5000,
                            "price": "1.85",
                            "price_label": "€ 1,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 44.742729306487696,
                                "left": 26.864280387770318,
                                "width": 23.19910514541387,
                                "height": 15.771812080536915
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/ace_5_l_1509101575.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_LhoZSHm_ENyih5l.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "90789",
                            "field1": "BIO FORM",
                            "field2": "Plus additivo disinfettante",
                            "field3": "lt 1,5",
                            "field4": "",
                            "description": "BIO FORM Plus additivo disinfettante lt 1,5",
                            "grammage": 1500,
                            "price": "1.10",
                            "price_label": "€ 1,10",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 44.85458612975392,
                                "left": 50.443698732289334,
                                "width": 23.19910514541387,
                                "height": 15.771812080536915
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/BIO_FORM_ADDITIVO_PMC_1466614925.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_0VOE2Zh_ap5z7cR.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "207480",
                            "field1": "ACE",
                            "field2": "Sgrassatore spray",
                            "field3": "vari tipi",
                            "field4": "ml 500",
                            "description": "ACE Sgrassatore spray vari tipi ml 500",
                            "grammage": 500,
                            "price": "1.10",
                            "price_label": "€ 1,10",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Universale",
                                "Bagno"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Superfici",
                            "blueprint": {
                                "top": 43.959731543624166,
                                "left": 73.63161819537657,
                                "width": 23.19910514541387,
                                "height": 16.666666666666664
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/11130698_ace_spray_bagno_brillante_ml.500_1578506868_1580460354_1583507320.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/ace-spray-sgrassatore-universale-senza-candeggina-fresco-profumo-500_EKJJ68X.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_ffGtRXV_BKS4lAr.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "90899",
                            "field1": "QUASAR",
                            "field2": "Detergente/sgrassatore",
                            "field3": "vari tipi",
                            "field4": "ml 650",
                            "description": "QUASAR Detergente/sgrassatore vari tipi ml 650",
                            "grammage": 650,
                            "price": "1.35",
                            "price_label": "€ 1,35",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Superfici",
                            "blueprint": {
                                "top": 61.18568232662192,
                                "left": 3.2736763609246746,
                                "width": 23.19910514541387,
                                "height": 15.883668903803132
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/42840_quasar_sgrassatore_con_candeggina_1494594968.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/46570_quasar_pulito_stellare_vetri_formula_originale_1494594969.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/45482_quasar_pulito_stellare_bagno_anticalcare_1494594969_1513354853.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/45483_1513783989.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_dg7f8ln_QNA5Hha.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "86041",
                            "field1": "RIO CASAMIA ",
                            "field2": "Detergente pavimenti ",
                            "field3": "vari tipi",
                            "field4": "lt 1,25",
                            "description": "RIO CASAMIA  Detergente pavimenti  vari tipi lt 1,25",
                            "grammage": 1250,
                            "price": "0.85",
                            "price_label": "€ 0,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Pavimenti",
                            "blueprint": {
                                "top": 60.62639821029082,
                                "left": 26.726323639075307,
                                "width": 23.19910514541387,
                                "height": 16.778523489932883
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Rio_casamia_igienizzante_1250ml__1472561317.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Rio_Casa_Mia_Talco_1472833054.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_VpMMwvr_ClR1NuD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "207478",
                            "field1": "DASH",
                            "field2": "Detersivo lavatrice liquido",
                            "field3": "regolare/colore/lavanda",
                            "field4": "22 lavaggi x 3",
                            "description": "DASH Detersivo lavatrice liquido regolare/colore/lavanda 22 lavaggi x 3",
                            "grammage": 0,
                            "price": "7.29",
                            "price_label": "€ 7,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Regolare",
                                "Colore",
                                "Lavanda"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 60.62639821029082,
                                "left": 50.4325130499627,
                                "width": 23.19910514541387,
                                "height": 16.778523489932883
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/8001841524054_Dash22x3Classico_1583507260.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/8001841524085_Dash22x3_1583507261.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_5FQAGWb_GuK1iGh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "86035",
                            "field1": "LENOR",
                            "field2": "Ammorbidente concentrato ",
                            "field3": "varie profumazioni ",
                            "field4": "42 lavaggi lt 1,05/ natural 35 lavaggi ml 875",
                            "description": "LENOR Ammorbidente concentrato  varie profumazioni  42 lavaggi lt 1,05/ natural 35 lavaggi ml 875",
                            "grammage": 1050,
                            "price": "1.45",
                            "price_label": "€ 1,45",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "42 lavaggi",
                                "35 lavaggi"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 60.62639821029082,
                                "left": 73.3780760626398,
                                "width": 23.19910514541387,
                                "height": 16.778523489932883
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/49360_1555681065.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/49361_1555681065.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/57723_1568642073.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_dlfDHU9_Y9tk8c4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "115380",
                            "field1": "SPECIAL DOG",
                            "field2": "Patè Agnello e tacchino/",
                            "field3": " Vitello e Verdure/ Pollo e Coniglio ",
                            "field4": "gr 400",
                            "description": "SPECIAL DOG Patè Agnello e tacchino/  Vitello e Verdure/ Pollo e Coniglio  gr 400",
                            "grammage": 400,
                            "price": "0.49",
                            "price_label": "€ 0,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Agnello e Tacchino",
                                "Vitello e Verdure",
                                "Pollo e Coniglio"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 77.62863534675614,
                                "left": 20.64131245339298,
                                "width": 19.26920208799403,
                                "height": 17.114093959731544
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Special_Dog_pate_pollo_coniglio_400_g_1510994197.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Special_Dog_pate_vitello_verdure_400_g_1510994197.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_9Ce7FTP_5zVspn3.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "86132",
                            "field1": "MORANDO MIGLIOR CANE",
                            "field2": "Special menù ",
                            "field3": "croccantini mix ",
                            "field4": "kg 4",
                            "description": "MORANDO MIGLIOR CANE Special menù  croccantini mix  kg 4",
                            "grammage": 4000,
                            "price": "2.75",
                            "price_label": "€ 2,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 77.62863534675614,
                                "left": 39.910514541387016,
                                "width": 19.26920208799403,
                                "height": 17.114093959731544
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/miglior_cane_1489840391.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_4bvo888_lQcNxHu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "87359",
                            "field1": "FELIX ",
                            "field2": "Le ghiottonerie per gatti",
                            "field3": "vari gusti",
                            "field4": "gr 100 x 4",
                            "description": "FELIX  Le ghiottonerie per gatti vari gusti gr 100 x 4",
                            "grammage": 400,
                            "price": "1.19",
                            "price_label": "€ 1,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 77.51677852348992,
                                "left": 59.05294556301266,
                                "width": 18.508575689783743,
                                "height": 17.114093959731544
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/FELIX_Le_Ghiottonerie_Agnello_Coniglio_1436946662_1475662013_1550485765.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/FELIX_Le_Ghiottonerie_Salmone_Tonno_1436946641_1475662028_1550485805.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_19tBJE2_0BpKtcT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "86136",
                            "field1": "MORANDO MIGLIOR GATTO",
                            "field2": "Crocchette ",
                            "field3": "vari gusti ",
                            "field4": "kg 2",
                            "description": "MORANDO MIGLIOR GATTO Crocchette  vari gusti  kg 2",
                            "grammage": 2000,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 77.85234899328857,
                                "left": 78.06860551826995,
                                "width": 18.508575689783743,
                                "height": 16.666666666666664
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/30570_miglior_1535014982.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/30571_miglior_gatto_1539602327.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/miglior_gatto__1489840421_1550484880.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_AGGzZpN_xwB0JkE.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 24,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/page_24_502PqU3.jpg",
                    "products": [
                        {
                            "item_id": "85688",
                            "field1": "MONARDO",
                            "field2": "Campana/gallina ",
                            "field3": "di cioccolato al latte",
                            "field4": "gr 250",
                            "description": "MONARDO Campana/gallina  di cioccolato al latte gr 250",
                            "grammage": 250,
                            "price": "3.39",
                            "price_label": "€ 3,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Campana ",
                                "Gallina"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 43.63315757036226,
                                "left": 3.4672099340318163,
                                "width": 23.139309274350015,
                                "height": 14.712730260905289
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cupido_campana_in_busta_1519808602_1583227195.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cupido_gallina_in_busta_1521286559_1583227195.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_S1UOUxo_VMN67by.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85680",
                            "field1": "SORINI",
                            "field2": "Ovetti/",
                            "field3": "campanelle",
                            "field4": "gr 110",
                            "description": "SORINI Ovetti/ campanelle gr 110",
                            "grammage": 0,
                            "price": "0.65",
                            "price_label": "€ 0,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Ovetti",
                                "Campanelle"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 43.63315757036226,
                                "left": 26.81994567326348,
                                "width": 23.139309274350015,
                                "height": 14.712730260905289
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/47531SoriniCAmpanelleLAtte110_1551450782.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/47528_1553871571.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_kk2J60t_IwvJIrz.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85670",
                            "field1": "BALOCCO",
                            "field2": "Colomba farcita ",
                            "field3": "vari gusti",
                            "field4": "gr 750",
                            "description": "BALOCCO Colomba farcita  vari gusti gr 750",
                            "grammage": 750,
                            "price": "3.55",
                            "price_label": "€ 3,55",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 43.74957200575224,
                                "left": 50.0407450523865,
                                "width": 23.139309274350015,
                                "height": 14.712730260905289
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/32535_Col._CiokoPanna_750g_8001100062969_1583519913.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_A9zO34l_ZyN5ltn.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "120872",
                            "field1": "MAINA",
                            "field2": "La gran colomba kg 1/  ",
                            "field3": "la gran pandorella senza canditi gr 900",
                            "field4": "",
                            "description": "MAINA La gran colomba kg 1/   la gran pandorella senza canditi gr 900",
                            "grammage": 0,
                            "price": "3.49",
                            "price_label": "€ 3,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Gran Colomba",
                                "Gran Pandorella"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 43.63315757036226,
                                "left": 73.65735351183547,
                                "width": 23.139309274350015,
                                "height": 14.712730260905289
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/Gran_colomba_1582892473.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_EkJAXFv_xhUJkvI.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85701",
                            "field1": "MONARDO",
                            "field2": "Uovo di cioccolato ",
                            "field3": "al latte/fondente",
                            "field4": "gr 300",
                            "description": "MONARDO Uovo di cioccolato  al latte/fondente gr 300",
                            "grammage": 300,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Al Latte",
                                "Fondente"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 10.850111856823254,
                                "left": 3.0201342281879113,
                                "width": 15.466070096942579,
                                "height": 32.438478747203575
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/40795_1583246138.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_yM9roWv_uiw8fbV.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "85703",
                            "field1": "MONARDO",
                            "field2": "Uovo di cioccolato ",
                            "field3": "al latte/fondente ",
                            "field4": "gr 600",
                            "description": "MONARDO Uovo di cioccolato  al latte/fondente  gr 600",
                            "grammage": 600,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Al Latte",
                                "Fondente"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 11.185682326621912,
                                "left": 18.105891126025345,
                                "width": 15.466070096942579,
                                "height": 32.438478747203575
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/45850_1583246167.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/45851_1583246168.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_MdQMGmb_iAH4Fwu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "174620",
                            "field1": "BALOCCO",
                            "field2": "Uovo di cioccolato al latte",
                            "field3": "paw patrol",
                            "field4": "gr 150",
                            "description": "BALOCCO Uovo di cioccolato al latte paw patrol gr 150",
                            "grammage": 150,
                            "price": "3.79",
                            "price_label": "€ 3,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 11.07382550335569,
                                "left": 33.698732289336306,
                                "width": 15.466070096942579,
                                "height": 32.438478747203575
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/3155_Uovo_Paw_Patro_150g_femmina_8001100070384_JPG_1582892754.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/3155_Uovo_Paw_Patrol_150g_maschio_8001100070384_JPG_1582892755.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_ITyypG0_poCbmHb.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "207027",
                            "field1": "BALOCCO",
                            "field2": "Uovo",
                            "field3": "juventus",
                            "field4": "gr 240",
                            "description": "BALOCCO Uovo juventus gr 240",
                            "grammage": 240,
                            "price": "5.99",
                            "price_label": "€ 5,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 11.07382550335569,
                                "left": 49.29157345264727,
                                "width": 15.466070096942579,
                                "height": 32.438478747203575
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/3099_Uovo_Juventus_240g_8001100066493_PNG_1582890253.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_u1ytSRQ_7NfvX7p.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "173526",
                            "field1": "WALCOR",
                            "field2": "Uovo di cioccolato",
                            "field3": "robocar poli/ littlest pet shop gr 200",
                            "field4": "gr 200",
                            "description": "WALCOR Uovo di cioccolato robocar poli/ littlest pet shop gr 200 gr 200",
                            "grammage": 200,
                            "price": "3.29",
                            "price_label": "€ 3,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Robocar Poli",
                                "Littlest Pet Shop"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 11.07382550335569,
                                "left": 64.75764354958984,
                                "width": 15.466070096942579,
                                "height": 32.438478747203575
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/34027_1583247011.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/34028_1583247011.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_MrGIscv_lFBVkOF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "121056",
                            "field1": "DOLFIN",
                            "field2": "Uovo di cioccolato ",
                            "field3": "bing",
                            "field4": "gr 220",
                            "description": "DOLFIN Uovo di cioccolato  bing gr 220",
                            "grammage": 220,
                            "price": "5.79",
                            "price_label": "€ 5,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 11.185682326621912,
                                "left": 79.97017151379566,
                                "width": 16.733780760626395,
                                "height": 32.438478747203575
                            },
                            "images": [
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/494942_-_Bing220g_1582803522_1582803529_1582803531_1582887592_1582892852.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/products/cropped_image_KgZfVh4_eLpum1P.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 25,
                    "image_file": "https://r1-it.storage.cloud.it/interactive/rSdJMnYECA/pages/TuttoRisparmio-finepagina_ZxVGe4k.png",
                    "products": []
                }
            ]
        }
    }
}

const lefletSwitch = () => {
    return leaflets.tuttorisparmio;
}

export const serverResponse = lefletSwitch();


